export const shortNameList: { [key: string]: string } = {
    ':england:': '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f',
    ':scotland:': '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f',
    ':wales:': '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f',
    ':kiss_man_man_tone1:': '1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_man_man_tone1_tone2:': '1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_man_man_tone1_tone3:': '1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_man_man_tone1_tone4:': '1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_man_man_tone1_tone5:': '1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_man_man_tone2:': '1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_man_man_tone2_tone1:': '1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_man_man_tone2_tone3:': '1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_man_man_tone2_tone4:': '1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_man_man_tone2_tone5:': '1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_man_man_tone3:': '1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_man_man_tone3_tone1:': '1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_man_man_tone3_tone2:': '1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_man_man_tone3_tone4:': '1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_man_man_tone3_tone5:': '1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_man_man_tone4:': '1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_man_man_tone4_tone1:': '1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_man_man_tone4_tone2:': '1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_man_man_tone4_tone3:': '1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_man_man_tone4_tone5:': '1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_man_man_tone5:': '1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_man_man_tone5_tone1:': '1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_man_man_tone5_tone2:': '1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_man_man_tone5_tone3:': '1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_man_man_tone5_tone4:': '1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_person_person_tone1_tone2:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc',
    ':kiss_person_person_tone1_tone3:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd',
    ':kiss_person_person_tone1_tone4:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe',
    ':kiss_person_person_tone1_tone5:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff',
    ':kiss_person_person_tone2_tone1:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb',
    ':kiss_person_person_tone2_tone3:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd',
    ':kiss_person_person_tone2_tone4:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe',
    ':kiss_person_person_tone2_tone5:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff',
    ':kiss_person_person_tone3_tone1:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb',
    ':kiss_person_person_tone3_tone2:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc',
    ':kiss_person_person_tone3_tone4:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe',
    ':kiss_person_person_tone3_tone5:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff',
    ':kiss_person_person_tone4_tone1:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb',
    ':kiss_person_person_tone4_tone2:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc',
    ':kiss_person_person_tone4_tone3:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd',
    ':kiss_person_person_tone4_tone5:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff',
    ':kiss_person_person_tone5_tone1:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb',
    ':kiss_person_person_tone5_tone2:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc',
    ':kiss_person_person_tone5_tone3:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd',
    ':kiss_person_person_tone5_tone4:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe',
    ':kiss_woman_man_tone1:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_woman_man_tone1_tone2:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_woman_man_tone1_tone3:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_woman_man_tone1_tone4:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_woman_man_tone1_tone5:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_woman_man_tone2:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_woman_man_tone2_tone1:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_woman_man_tone2_tone3:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_woman_man_tone2_tone4:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_woman_man_tone2_tone5:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_woman_man_tone3:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_woman_man_tone3_tone1:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_woman_man_tone3_tone2:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_woman_man_tone3_tone4:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_woman_man_tone3_tone5:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_woman_man_tone4:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_woman_man_tone4_tone1:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_woman_man_tone4_tone2:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_woman_man_tone4_tone3:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_woman_man_tone4_tone5:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_woman_man_tone5:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff',
    ':kiss_woman_man_tone5_tone1:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb',
    ':kiss_woman_man_tone5_tone2:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc',
    ':kiss_woman_man_tone5_tone3:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd',
    ':kiss_woman_man_tone5_tone4:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe',
    ':kiss_woman_woman_tone1:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb',
    ':kiss_woman_woman_tone1_tone2:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc',
    ':kiss_woman_woman_tone1_tone3:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd',
    ':kiss_woman_woman_tone1_tone4:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe',
    ':kiss_woman_woman_tone1_tone5:': '1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff',
    ':kiss_woman_woman_tone2:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc',
    ':kiss_woman_woman_tone2_tone1:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb',
    ':kiss_woman_woman_tone2_tone3:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd',
    ':kiss_woman_woman_tone2_tone4:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe',
    ':kiss_woman_woman_tone2_tone5:': '1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff',
    ':kiss_woman_woman_tone3:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd',
    ':kiss_woman_woman_tone3_tone1:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb',
    ':kiss_woman_woman_tone3_tone2:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc',
    ':kiss_woman_woman_tone3_tone4:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe',
    ':kiss_woman_woman_tone3_tone5:': '1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff',
    ':kiss_woman_woman_tone4:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe',
    ':kiss_woman_woman_tone4_tone1:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb',
    ':kiss_woman_woman_tone4_tone2:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc',
    ':kiss_woman_woman_tone4_tone3:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd',
    ':kiss_woman_woman_tone4_tone5:': '1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff',
    ':kiss_woman_woman_tone5:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff',
    ':kiss_woman_woman_tone5_tone1:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb',
    ':kiss_woman_woman_tone5_tone2:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc',
    ':kiss_woman_woman_tone5_tone3:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd',
    ':kiss_woman_woman_tone5_tone4:': '1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe',
    ':men_holding_hands_tone1_tone2:': '1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc',
    ':men_holding_hands_tone1_tone3:': '1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd',
    ':men_holding_hands_tone1_tone4:': '1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe',
    ':men_holding_hands_tone1_tone5:': '1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff',
    ':men_holding_hands_tone2_tone1:': '1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb',
    ':men_holding_hands_tone2_tone3:': '1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd',
    ':men_holding_hands_tone2_tone4:': '1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe',
    ':men_holding_hands_tone2_tone5:': '1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff',
    ':men_holding_hands_tone3_tone1:': '1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb',
    ':men_holding_hands_tone3_tone2:': '1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc',
    ':men_holding_hands_tone3_tone4:': '1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe',
    ':men_holding_hands_tone3_tone5:': '1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff',
    ':men_holding_hands_tone4_tone1:': '1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb',
    ':men_holding_hands_tone4_tone2:': '1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc',
    ':men_holding_hands_tone4_tone3:': '1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd',
    ':men_holding_hands_tone4_tone5:': '1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff',
    ':men_holding_hands_tone5_tone1:': '1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb',
    ':men_holding_hands_tone5_tone2:': '1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc',
    ':men_holding_hands_tone5_tone3:': '1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd',
    ':men_holding_hands_tone5_tone4:': '1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe',
    ':people_holding_hands_tone1:': '1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb',
    ':people_holding_hands_tone1_tone2:': '1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc',
    ':people_holding_hands_tone1_tone3:': '1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd',
    ':people_holding_hands_tone1_tone4:': '1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe',
    ':people_holding_hands_tone1_tone5:': '1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff',
    ':people_holding_hands_tone2:': '1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc',
    ':people_holding_hands_tone2_tone1:': '1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb',
    ':people_holding_hands_tone2_tone3:': '1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd',
    ':people_holding_hands_tone2_tone4:': '1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe',
    ':people_holding_hands_tone2_tone5:': '1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff',
    ':people_holding_hands_tone3:': '1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd',
    ':people_holding_hands_tone3_tone1:': '1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb',
    ':people_holding_hands_tone3_tone2:': '1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc',
    ':people_holding_hands_tone3_tone4:': '1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe',
    ':people_holding_hands_tone3_tone5:': '1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff',
    ':people_holding_hands_tone4:': '1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe',
    ':people_holding_hands_tone4_tone1:': '1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb',
    ':people_holding_hands_tone4_tone2:': '1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc',
    ':people_holding_hands_tone4_tone3:': '1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd',
    ':people_holding_hands_tone4_tone5:': '1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff',
    ':people_holding_hands_tone5:': '1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff',
    ':people_holding_hands_tone5_tone1:': '1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb',
    ':people_holding_hands_tone5_tone2:': '1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc',
    ':people_holding_hands_tone5_tone3:': '1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd',
    ':people_holding_hands_tone5_tone4:': '1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe',
    ':woman_and_man_holding_hands_tone1_tone2:': '1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc',
    ':woman_and_man_holding_hands_tone1_tone3:': '1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd',
    ':woman_and_man_holding_hands_tone1_tone4:': '1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe',
    ':woman_and_man_holding_hands_tone1_tone5:': '1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff',
    ':woman_and_man_holding_hands_tone2_tone1:': '1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb',
    ':woman_and_man_holding_hands_tone2_tone3:': '1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd',
    ':woman_and_man_holding_hands_tone2_tone4:': '1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe',
    ':woman_and_man_holding_hands_tone2_tone5:': '1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff',
    ':woman_and_man_holding_hands_tone3_tone1:': '1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb',
    ':woman_and_man_holding_hands_tone3_tone2:': '1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc',
    ':woman_and_man_holding_hands_tone3_tone4:': '1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe',
    ':woman_and_man_holding_hands_tone3_tone5:': '1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff',
    ':woman_and_man_holding_hands_tone4_tone1:': '1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb',
    ':woman_and_man_holding_hands_tone4_tone2:': '1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc',
    ':woman_and_man_holding_hands_tone4_tone3:': '1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd',
    ':woman_and_man_holding_hands_tone4_tone5:': '1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff',
    ':woman_and_man_holding_hands_tone5_tone1:': '1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb',
    ':woman_and_man_holding_hands_tone5_tone2:': '1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc',
    ':woman_and_man_holding_hands_tone5_tone3:': '1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd',
    ':woman_and_man_holding_hands_tone5_tone4:': '1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe',
    ':women_holding_hands_tone1_tone2:': '1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc',
    ':women_holding_hands_tone1_tone3:': '1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd',
    ':women_holding_hands_tone1_tone4:': '1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe',
    ':women_holding_hands_tone1_tone5:': '1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff',
    ':women_holding_hands_tone2_tone1:': '1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb',
    ':women_holding_hands_tone2_tone3:': '1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd',
    ':women_holding_hands_tone2_tone4:': '1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe',
    ':women_holding_hands_tone2_tone5:': '1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff',
    ':women_holding_hands_tone3_tone1:': '1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb',
    ':women_holding_hands_tone3_tone2:': '1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc',
    ':women_holding_hands_tone3_tone4:': '1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe',
    ':women_holding_hands_tone3_tone5:': '1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff',
    ':women_holding_hands_tone4_tone1:': '1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb',
    ':women_holding_hands_tone4_tone2:': '1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc',
    ':women_holding_hands_tone4_tone3:': '1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd',
    ':women_holding_hands_tone4_tone5:': '1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff',
    ':women_holding_hands_tone5_tone1:': '1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb',
    ':women_holding_hands_tone5_tone2:': '1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc',
    ':women_holding_hands_tone5_tone3:': '1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd',
    ':women_holding_hands_tone5_tone4:': '1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe',
    ':couple_with_heart_man_man_tone1:': '1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_man_man_tone1_tone2:': '1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_man_man_tone1_tone3:': '1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_man_man_tone1_tone4:': '1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_man_man_tone1_tone5:': '1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_man_man_tone2:': '1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_man_man_tone2_tone1:': '1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_man_man_tone2_tone3:': '1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_man_man_tone2_tone4:': '1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_man_man_tone2_tone5:': '1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_man_man_tone3:': '1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_man_man_tone3_tone1:': '1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_man_man_tone3_tone2:': '1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_man_man_tone3_tone4:': '1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_man_man_tone3_tone5:': '1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_man_man_tone4:': '1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_man_man_tone4_tone1:': '1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_man_man_tone4_tone2:': '1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_man_man_tone4_tone3:': '1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_man_man_tone4_tone5:': '1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_man_man_tone5:': '1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_man_man_tone5_tone1:': '1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_man_man_tone5_tone2:': '1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_man_man_tone5_tone3:': '1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_man_man_tone5_tone4:': '1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_person_person_tone1_tone2:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc',
    ':couple_with_heart_person_person_tone1_tone3:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd',
    ':couple_with_heart_person_person_tone1_tone4:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe',
    ':couple_with_heart_person_person_tone1_tone5:': '1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff',
    ':couple_with_heart_person_person_tone2_tone1:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb',
    ':couple_with_heart_person_person_tone2_tone3:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd',
    ':couple_with_heart_person_person_tone2_tone4:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe',
    ':couple_with_heart_person_person_tone2_tone5:': '1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff',
    ':couple_with_heart_person_person_tone3_tone1:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb',
    ':couple_with_heart_person_person_tone3_tone2:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc',
    ':couple_with_heart_person_person_tone3_tone4:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe',
    ':couple_with_heart_person_person_tone3_tone5:': '1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff',
    ':couple_with_heart_person_person_tone4_tone1:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb',
    ':couple_with_heart_person_person_tone4_tone2:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc',
    ':couple_with_heart_person_person_tone4_tone3:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd',
    ':couple_with_heart_person_person_tone4_tone5:': '1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff',
    ':couple_with_heart_person_person_tone5_tone1:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb',
    ':couple_with_heart_person_person_tone5_tone2:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc',
    ':couple_with_heart_person_person_tone5_tone3:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd',
    ':couple_with_heart_person_person_tone5_tone4:': '1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe',
    ':couple_with_heart_woman_man_tone1:': '1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_woman_man_tone1_tone2:': '1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_woman_man_tone1_tone3:': '1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_woman_man_tone1_tone4:': '1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_woman_man_tone1_tone5:': '1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_woman_man_tone2:': '1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_woman_man_tone2_tone1:': '1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_woman_man_tone2_tone3:': '1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_woman_man_tone2_tone4:': '1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_woman_man_tone2_tone5:': '1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_woman_man_tone3:': '1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_woman_man_tone3_tone1:': '1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_woman_man_tone3_tone2:': '1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_woman_man_tone3_tone4:': '1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_woman_man_tone3_tone5:': '1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_woman_man_tone4:': '1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_woman_man_tone4_tone1:': '1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_woman_man_tone4_tone2:': '1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_woman_man_tone4_tone3:': '1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_woman_man_tone4_tone5:': '1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_woman_man_tone5:': '1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff',
    ':couple_with_heart_woman_man_tone5_tone1:': '1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb',
    ':couple_with_heart_woman_man_tone5_tone2:': '1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc',
    ':couple_with_heart_woman_man_tone5_tone3:': '1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd',
    ':couple_with_heart_woman_man_tone5_tone4:': '1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe',
    ':couple_with_heart_woman_woman_tone1:': '1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb',
    ':couple_with_heart_woman_woman_tone1_tone2:': '1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc',
    ':couple_with_heart_woman_woman_tone1_tone3:': '1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd',
    ':couple_with_heart_woman_woman_tone1_tone4:': '1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe',
    ':couple_with_heart_woman_woman_tone1_tone5:': '1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff',
    ':couple_with_heart_woman_woman_tone2:': '1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc',
    ':couple_with_heart_woman_woman_tone2_tone1:': '1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb',
    ':couple_with_heart_woman_woman_tone2_tone3:': '1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd',
    ':couple_with_heart_woman_woman_tone2_tone4:': '1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe',
    ':couple_with_heart_woman_woman_tone2_tone5:': '1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff',
    ':couple_with_heart_woman_woman_tone3:': '1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd',
    ':couple_with_heart_woman_woman_tone3_tone1:': '1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb',
    ':couple_with_heart_woman_woman_tone3_tone2:': '1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc',
    ':couple_with_heart_woman_woman_tone3_tone4:': '1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe',
    ':couple_with_heart_woman_woman_tone3_tone5:': '1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff',
    ':couple_with_heart_woman_woman_tone4:': '1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe',
    ':couple_with_heart_woman_woman_tone4_tone1:': '1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb',
    ':couple_with_heart_woman_woman_tone4_tone2:': '1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc',
    ':couple_with_heart_woman_woman_tone4_tone3:': '1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd',
    ':couple_with_heart_woman_woman_tone4_tone5:': '1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff',
    ':couple_with_heart_woman_woman_tone5:': '1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff',
    ':couple_with_heart_woman_woman_tone5_tone1:': '1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb',
    ':couple_with_heart_woman_woman_tone5_tone2:': '1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc',
    ':couple_with_heart_woman_woman_tone5_tone3:': '1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd',
    ':couple_with_heart_woman_woman_tone5_tone4:': '1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe',
    ':family_mmbb:': '1f468-200d-1f468-200d-1f466-200d-1f466',
    ':family_mmgb:': '1f468-200d-1f468-200d-1f467-200d-1f466',
    ':family_mmgg:': '1f468-200d-1f468-200d-1f467-200d-1f467',
    ':family_mwbb:': '1f468-200d-1f469-200d-1f466-200d-1f466',
    ':family_mwgb:': '1f468-200d-1f469-200d-1f467-200d-1f466',
    ':family_mwgg:': '1f468-200d-1f469-200d-1f467-200d-1f467',
    ':family_wwbb:': '1f469-200d-1f469-200d-1f466-200d-1f466',
    ':family_wwgb:': '1f469-200d-1f469-200d-1f467-200d-1f466',
    ':family_wwgg:': '1f469-200d-1f469-200d-1f467-200d-1f467',
    ':handshake_tone1_tone2:': '1faf1-1f3fb-200d-1faf2-1f3fc',
    ':handshake_tone1_tone3:': '1faf1-1f3fb-200d-1faf2-1f3fd',
    ':handshake_tone1_tone4:': '1faf1-1f3fb-200d-1faf2-1f3fe',
    ':handshake_tone1_tone5:': '1faf1-1f3fb-200d-1faf2-1f3ff',
    ':handshake_tone2_tone1:': '1faf1-1f3fc-200d-1faf2-1f3fb',
    ':handshake_tone2_tone3:': '1faf1-1f3fc-200d-1faf2-1f3fd',
    ':handshake_tone2_tone4:': '1faf1-1f3fc-200d-1faf2-1f3fe',
    ':handshake_tone2_tone5:': '1faf1-1f3fc-200d-1faf2-1f3ff',
    ':handshake_tone3_tone1:': '1faf1-1f3fd-200d-1faf2-1f3fb',
    ':handshake_tone3_tone2:': '1faf1-1f3fd-200d-1faf2-1f3fc',
    ':handshake_tone3_tone4:': '1faf1-1f3fd-200d-1faf2-1f3fe',
    ':handshake_tone3_tone5:': '1faf1-1f3fd-200d-1faf2-1f3ff',
    ':handshake_tone4_tone1:': '1faf1-1f3fe-200d-1faf2-1f3fb',
    ':handshake_tone4_tone2:': '1faf1-1f3fe-200d-1faf2-1f3fc',
    ':handshake_tone4_tone3:': '1faf1-1f3fe-200d-1faf2-1f3fd',
    ':handshake_tone4_tone5:': '1faf1-1f3fe-200d-1faf2-1f3ff',
    ':handshake_tone5_tone1:': '1faf1-1f3ff-200d-1faf2-1f3fb',
    ':handshake_tone5_tone2:': '1faf1-1f3ff-200d-1faf2-1f3fc',
    ':handshake_tone5_tone3:': '1faf1-1f3ff-200d-1faf2-1f3fd',
    ':handshake_tone5_tone4:': '1faf1-1f3ff-200d-1faf2-1f3fe',
    ':kiss_mm:': '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
    ':kiss_woman_man:': '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468',
    ':kiss_ww:': '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
    ':artist_tone1:': '1f9d1-1f3fb-200d-1f3a8',
    ':artist_tone2:': '1f9d1-1f3fc-200d-1f3a8',
    ':artist_tone3:': '1f9d1-1f3fd-200d-1f3a8',
    ':artist_tone4:': '1f9d1-1f3fe-200d-1f3a8',
    ':artist_tone5:': '1f9d1-1f3ff-200d-1f3a8',
    ':astronaut_tone1:': '1f9d1-1f3fb-200d-1f680',
    ':astronaut_tone2:': '1f9d1-1f3fc-200d-1f680',
    ':astronaut_tone3:': '1f9d1-1f3fd-200d-1f680',
    ':astronaut_tone4:': '1f9d1-1f3fe-200d-1f680',
    ':astronaut_tone5:': '1f9d1-1f3ff-200d-1f680',
    ':cook_tone1:': '1f9d1-1f3fb-200d-1f373',
    ':cook_tone2:': '1f9d1-1f3fc-200d-1f373',
    ':cook_tone3:': '1f9d1-1f3fd-200d-1f373',
    ':cook_tone4:': '1f9d1-1f3fe-200d-1f373',
    ':cook_tone5:': '1f9d1-1f3ff-200d-1f373',
    ':factory_worker_tone1:': '1f9d1-1f3fb-200d-1f3ed',
    ':factory_worker_tone2:': '1f9d1-1f3fc-200d-1f3ed',
    ':factory_worker_tone3:': '1f9d1-1f3fd-200d-1f3ed',
    ':factory_worker_tone4:': '1f9d1-1f3fe-200d-1f3ed',
    ':factory_worker_tone5:': '1f9d1-1f3ff-200d-1f3ed',
    ':family_man_boy_boy:': '1f468-200d-1f466-200d-1f466',
    ':family_man_girl_boy:': '1f468-200d-1f467-200d-1f466',
    ':family_man_girl_girl:': '1f468-200d-1f467-200d-1f467',
    ':family_man_woman_boy:': '1f468-200d-1f469-200d-1f466',
    ':family_mmb:': '1f468-200d-1f468-200d-1f466',
    ':family_mmg:': '1f468-200d-1f468-200d-1f467',
    ':family_mwg:': '1f468-200d-1f469-200d-1f467',
    ':family_woman_boy_boy:': '1f469-200d-1f466-200d-1f466',
    ':family_woman_girl_boy:': '1f469-200d-1f467-200d-1f466',
    ':family_woman_girl_girl:': '1f469-200d-1f467-200d-1f467',
    ':family_wwb:': '1f469-200d-1f469-200d-1f466',
    ':family_wwg:': '1f469-200d-1f469-200d-1f467',
    ':farmer_tone1:': '1f9d1-1f3fb-200d-1f33e',
    ':farmer_tone2:': '1f9d1-1f3fc-200d-1f33e',
    ':farmer_tone3:': '1f9d1-1f3fd-200d-1f33e',
    ':farmer_tone4:': '1f9d1-1f3fe-200d-1f33e',
    ':farmer_tone5:': '1f9d1-1f3ff-200d-1f33e',
    ':firefighter_tone1:': '1f9d1-1f3fb-200d-1f692',
    ':firefighter_tone2:': '1f9d1-1f3fc-200d-1f692',
    ':firefighter_tone3:': '1f9d1-1f3fd-200d-1f692',
    ':firefighter_tone4:': '1f9d1-1f3fe-200d-1f692',
    ':firefighter_tone5:': '1f9d1-1f3ff-200d-1f692',
    ':man_artist_tone1:': '1f468-1f3fb-200d-1f3a8',
    ':man_artist_tone2:': '1f468-1f3fc-200d-1f3a8',
    ':man_artist_tone3:': '1f468-1f3fd-200d-1f3a8',
    ':man_artist_tone4:': '1f468-1f3fe-200d-1f3a8',
    ':man_artist_tone5:': '1f468-1f3ff-200d-1f3a8',
    ':man_astronaut_tone1:': '1f468-1f3fb-200d-1f680',
    ':man_astronaut_tone2:': '1f468-1f3fc-200d-1f680',
    ':man_astronaut_tone3:': '1f468-1f3fd-200d-1f680',
    ':man_astronaut_tone4:': '1f468-1f3fe-200d-1f680',
    ':man_astronaut_tone5:': '1f468-1f3ff-200d-1f680',
    ':man_bald_tone1:': '1f468-1f3fb-200d-1f9b2',
    ':man_bald_tone2:': '1f468-1f3fc-200d-1f9b2',
    ':man_bald_tone3:': '1f468-1f3fd-200d-1f9b2',
    ':man_bald_tone4:': '1f468-1f3fe-200d-1f9b2',
    ':man_bald_tone5:': '1f468-1f3ff-200d-1f9b2',
    ':man_cook_tone1:': '1f468-1f3fb-200d-1f373',
    ':man_cook_tone2:': '1f468-1f3fc-200d-1f373',
    ':man_cook_tone3:': '1f468-1f3fd-200d-1f373',
    ':man_cook_tone4:': '1f468-1f3fe-200d-1f373',
    ':man_cook_tone5:': '1f468-1f3ff-200d-1f373',
    ':man_curly_haired_tone1:': '1f468-1f3fb-200d-1f9b1',
    ':man_curly_haired_tone2:': '1f468-1f3fc-200d-1f9b1',
    ':man_curly_haired_tone3:': '1f468-1f3fd-200d-1f9b1',
    ':man_curly_haired_tone4:': '1f468-1f3fe-200d-1f9b1',
    ':man_curly_haired_tone5:': '1f468-1f3ff-200d-1f9b1',
    ':man_factory_worker_tone1:': '1f468-1f3fb-200d-1f3ed',
    ':man_factory_worker_tone2:': '1f468-1f3fc-200d-1f3ed',
    ':man_factory_worker_tone3:': '1f468-1f3fd-200d-1f3ed',
    ':man_factory_worker_tone4:': '1f468-1f3fe-200d-1f3ed',
    ':man_factory_worker_tone5:': '1f468-1f3ff-200d-1f3ed',
    ':man_farmer_tone1:': '1f468-1f3fb-200d-1f33e',
    ':man_farmer_tone2:': '1f468-1f3fc-200d-1f33e',
    ':man_farmer_tone3:': '1f468-1f3fd-200d-1f33e',
    ':man_farmer_tone4:': '1f468-1f3fe-200d-1f33e',
    ':man_farmer_tone5:': '1f468-1f3ff-200d-1f33e',
    ':man_feeding_baby_tone1:': '1f468-1f3fb-200d-1f37c',
    ':man_feeding_baby_tone2:': '1f468-1f3fc-200d-1f37c',
    ':man_feeding_baby_tone3:': '1f468-1f3fd-200d-1f37c',
    ':man_feeding_baby_tone4:': '1f468-1f3fe-200d-1f37c',
    ':man_feeding_baby_tone5:': '1f468-1f3ff-200d-1f37c',
    ':man_firefighter_tone1:': '1f468-1f3fb-200d-1f692',
    ':man_firefighter_tone2:': '1f468-1f3fc-200d-1f692',
    ':man_firefighter_tone3:': '1f468-1f3fd-200d-1f692',
    ':man_firefighter_tone4:': '1f468-1f3fe-200d-1f692',
    ':man_firefighter_tone5:': '1f468-1f3ff-200d-1f692',
    ':man_in_manual_wheelchair_tone1:': '1f468-1f3fb-200d-1f9bd',
    ':man_in_manual_wheelchair_tone2:': '1f468-1f3fc-200d-1f9bd',
    ':man_in_manual_wheelchair_tone3:': '1f468-1f3fd-200d-1f9bd',
    ':man_in_manual_wheelchair_tone4:': '1f468-1f3fe-200d-1f9bd',
    ':man_in_manual_wheelchair_tone5:': '1f468-1f3ff-200d-1f9bd',
    ':man_in_motorized_wheelchair_tone1:': '1f468-1f3fb-200d-1f9bc',
    ':man_in_motorized_wheelchair_tone2:': '1f468-1f3fc-200d-1f9bc',
    ':man_in_motorized_wheelchair_tone3:': '1f468-1f3fd-200d-1f9bc',
    ':man_in_motorized_wheelchair_tone4:': '1f468-1f3fe-200d-1f9bc',
    ':man_in_motorized_wheelchair_tone5:': '1f468-1f3ff-200d-1f9bc',
    ':man_mechanic_tone1:': '1f468-1f3fb-200d-1f527',
    ':man_mechanic_tone2:': '1f468-1f3fc-200d-1f527',
    ':man_mechanic_tone3:': '1f468-1f3fd-200d-1f527',
    ':man_mechanic_tone4:': '1f468-1f3fe-200d-1f527',
    ':man_mechanic_tone5:': '1f468-1f3ff-200d-1f527',
    ':man_office_worker_tone1:': '1f468-1f3fb-200d-1f4bc',
    ':man_office_worker_tone2:': '1f468-1f3fc-200d-1f4bc',
    ':man_office_worker_tone3:': '1f468-1f3fd-200d-1f4bc',
    ':man_office_worker_tone4:': '1f468-1f3fe-200d-1f4bc',
    ':man_office_worker_tone5:': '1f468-1f3ff-200d-1f4bc',
    ':man_red_haired_tone1:': '1f468-1f3fb-200d-1f9b0',
    ':man_red_haired_tone2:': '1f468-1f3fc-200d-1f9b0',
    ':man_red_haired_tone3:': '1f468-1f3fd-200d-1f9b0',
    ':man_red_haired_tone4:': '1f468-1f3fe-200d-1f9b0',
    ':man_red_haired_tone5:': '1f468-1f3ff-200d-1f9b0',
    ':man_scientist_tone1:': '1f468-1f3fb-200d-1f52c',
    ':man_scientist_tone2:': '1f468-1f3fc-200d-1f52c',
    ':man_scientist_tone3:': '1f468-1f3fd-200d-1f52c',
    ':man_scientist_tone4:': '1f468-1f3fe-200d-1f52c',
    ':man_scientist_tone5:': '1f468-1f3ff-200d-1f52c',
    ':man_singer_tone1:': '1f468-1f3fb-200d-1f3a4',
    ':man_singer_tone2:': '1f468-1f3fc-200d-1f3a4',
    ':man_singer_tone3:': '1f468-1f3fd-200d-1f3a4',
    ':man_singer_tone4:': '1f468-1f3fe-200d-1f3a4',
    ':man_singer_tone5:': '1f468-1f3ff-200d-1f3a4',
    ':man_student_tone1:': '1f468-1f3fb-200d-1f393',
    ':man_student_tone2:': '1f468-1f3fc-200d-1f393',
    ':man_student_tone3:': '1f468-1f3fd-200d-1f393',
    ':man_student_tone4:': '1f468-1f3fe-200d-1f393',
    ':man_student_tone5:': '1f468-1f3ff-200d-1f393',
    ':man_teacher_tone1:': '1f468-1f3fb-200d-1f3eb',
    ':man_teacher_tone2:': '1f468-1f3fc-200d-1f3eb',
    ':man_teacher_tone3:': '1f468-1f3fd-200d-1f3eb',
    ':man_teacher_tone4:': '1f468-1f3fe-200d-1f3eb',
    ':man_teacher_tone5:': '1f468-1f3ff-200d-1f3eb',
    ':man_technologist_tone1:': '1f468-1f3fb-200d-1f4bb',
    ':man_technologist_tone2:': '1f468-1f3fc-200d-1f4bb',
    ':man_technologist_tone3:': '1f468-1f3fd-200d-1f4bb',
    ':man_technologist_tone4:': '1f468-1f3fe-200d-1f4bb',
    ':man_technologist_tone5:': '1f468-1f3ff-200d-1f4bb',
    ':man_white_haired_tone1:': '1f468-1f3fb-200d-1f9b3',
    ':man_white_haired_tone2:': '1f468-1f3fc-200d-1f9b3',
    ':man_white_haired_tone3:': '1f468-1f3fd-200d-1f9b3',
    ':man_white_haired_tone4:': '1f468-1f3fe-200d-1f9b3',
    ':man_white_haired_tone5:': '1f468-1f3ff-200d-1f9b3',
    ':man_with_probing_cane_tone1:': '1f468-1f3fb-200d-1f9af',
    ':man_with_probing_cane_tone2:': '1f468-1f3fc-200d-1f9af',
    ':man_with_probing_cane_tone3:': '1f468-1f3fd-200d-1f9af',
    ':man_with_probing_cane_tone4:': '1f468-1f3fe-200d-1f9af',
    ':man_with_probing_cane_tone5:': '1f468-1f3ff-200d-1f9af',
    ':mechanic_tone1:': '1f9d1-1f3fb-200d-1f527',
    ':mechanic_tone2:': '1f9d1-1f3fc-200d-1f527',
    ':mechanic_tone3:': '1f9d1-1f3fd-200d-1f527',
    ':mechanic_tone4:': '1f9d1-1f3fe-200d-1f527',
    ':mechanic_tone5:': '1f9d1-1f3ff-200d-1f527',
    ':mx_claus_tone1:': '1f9d1-1f3fb-200d-1f384',
    ':mx_claus_tone2:': '1f9d1-1f3fc-200d-1f384',
    ':mx_claus_tone3:': '1f9d1-1f3fd-200d-1f384',
    ':mx_claus_tone4:': '1f9d1-1f3fe-200d-1f384',
    ':mx_claus_tone5:': '1f9d1-1f3ff-200d-1f384',
    ':office_worker_tone1:': '1f9d1-1f3fb-200d-1f4bc',
    ':office_worker_tone2:': '1f9d1-1f3fc-200d-1f4bc',
    ':office_worker_tone3:': '1f9d1-1f3fd-200d-1f4bc',
    ':office_worker_tone4:': '1f9d1-1f3fe-200d-1f4bc',
    ':office_worker_tone5:': '1f9d1-1f3ff-200d-1f4bc',
    ':people_holding_hands:': '1f9d1-200d-1f91d-200d-1f9d1',
    ':person_feeding_baby_tone1:': '1f9d1-1f3fb-200d-1f37c',
    ':person_feeding_baby_tone2:': '1f9d1-1f3fc-200d-1f37c',
    ':person_feeding_baby_tone3:': '1f9d1-1f3fd-200d-1f37c',
    ':person_feeding_baby_tone4:': '1f9d1-1f3fe-200d-1f37c',
    ':person_feeding_baby_tone5:': '1f9d1-1f3ff-200d-1f37c',
    ':person_in_manual_wheelchair_tone1:': '1f9d1-1f3fb-200d-1f9bd',
    ':person_in_manual_wheelchair_tone2:': '1f9d1-1f3fc-200d-1f9bd',
    ':person_in_manual_wheelchair_tone3:': '1f9d1-1f3fd-200d-1f9bd',
    ':person_in_manual_wheelchair_tone4:': '1f9d1-1f3fe-200d-1f9bd',
    ':person_in_manual_wheelchair_tone5:': '1f9d1-1f3ff-200d-1f9bd',
    ':person_in_motorized_wheelchair_tone1:': '1f9d1-1f3fb-200d-1f9bc',
    ':person_in_motorized_wheelchair_tone2:': '1f9d1-1f3fc-200d-1f9bc',
    ':person_in_motorized_wheelchair_tone3:': '1f9d1-1f3fd-200d-1f9bc',
    ':person_in_motorized_wheelchair_tone4:': '1f9d1-1f3fe-200d-1f9bc',
    ':person_in_motorized_wheelchair_tone5:': '1f9d1-1f3ff-200d-1f9bc',
    ':person_tone1_bald:': '1f9d1-1f3fb-200d-1f9b2',
    ':person_tone1_curly_hair:': '1f9d1-1f3fb-200d-1f9b1',
    ':person_tone1_red_hair:': '1f9d1-1f3fb-200d-1f9b0',
    ':person_tone1_white_hair:': '1f9d1-1f3fb-200d-1f9b3',
    ':person_tone2_bald:': '1f9d1-1f3fc-200d-1f9b2',
    ':person_tone2_curly_hair:': '1f9d1-1f3fc-200d-1f9b1',
    ':person_tone2_red_hair:': '1f9d1-1f3fc-200d-1f9b0',
    ':person_tone2_white_hair:': '1f9d1-1f3fc-200d-1f9b3',
    ':person_tone3_bald:': '1f9d1-1f3fd-200d-1f9b2',
    ':person_tone3_curly_hair:': '1f9d1-1f3fd-200d-1f9b1',
    ':person_tone3_red_hair:': '1f9d1-1f3fd-200d-1f9b0',
    ':person_tone3_white_hair:': '1f9d1-1f3fd-200d-1f9b3',
    ':person_tone4_bald:': '1f9d1-1f3fe-200d-1f9b2',
    ':person_tone4_curly_hair:': '1f9d1-1f3fe-200d-1f9b1',
    ':person_tone4_red_hair:': '1f9d1-1f3fe-200d-1f9b0',
    ':person_tone4_white_hair:': '1f9d1-1f3fe-200d-1f9b3',
    ':person_tone5_bald:': '1f9d1-1f3ff-200d-1f9b2',
    ':person_tone5_curly_hair:': '1f9d1-1f3ff-200d-1f9b1',
    ':person_tone5_red_hair:': '1f9d1-1f3ff-200d-1f9b0',
    ':person_tone5_white_hair:': '1f9d1-1f3ff-200d-1f9b3',
    ':person_with_probing_cane_tone1:': '1f9d1-1f3fb-200d-1f9af',
    ':person_with_probing_cane_tone2:': '1f9d1-1f3fc-200d-1f9af',
    ':person_with_probing_cane_tone3:': '1f9d1-1f3fd-200d-1f9af',
    ':person_with_probing_cane_tone4:': '1f9d1-1f3fe-200d-1f9af',
    ':person_with_probing_cane_tone5:': '1f9d1-1f3ff-200d-1f9af',
    ':scientist_tone1:': '1f9d1-1f3fb-200d-1f52c',
    ':scientist_tone2:': '1f9d1-1f3fc-200d-1f52c',
    ':scientist_tone3:': '1f9d1-1f3fd-200d-1f52c',
    ':scientist_tone4:': '1f9d1-1f3fe-200d-1f52c',
    ':scientist_tone5:': '1f9d1-1f3ff-200d-1f52c',
    ':singer_tone1:': '1f9d1-1f3fb-200d-1f3a4',
    ':singer_tone2:': '1f9d1-1f3fc-200d-1f3a4',
    ':singer_tone3:': '1f9d1-1f3fd-200d-1f3a4',
    ':singer_tone4:': '1f9d1-1f3fe-200d-1f3a4',
    ':singer_tone5:': '1f9d1-1f3ff-200d-1f3a4',
    ':student_tone1:': '1f9d1-1f3fb-200d-1f393',
    ':student_tone2:': '1f9d1-1f3fc-200d-1f393',
    ':student_tone3:': '1f9d1-1f3fd-200d-1f393',
    ':student_tone4:': '1f9d1-1f3fe-200d-1f393',
    ':student_tone5:': '1f9d1-1f3ff-200d-1f393',
    ':teacher_tone1:': '1f9d1-1f3fb-200d-1f3eb',
    ':teacher_tone2:': '1f9d1-1f3fc-200d-1f3eb',
    ':teacher_tone3:': '1f9d1-1f3fd-200d-1f3eb',
    ':teacher_tone4:': '1f9d1-1f3fe-200d-1f3eb',
    ':teacher_tone5:': '1f9d1-1f3ff-200d-1f3eb',
    ':technologist_tone1:': '1f9d1-1f3fb-200d-1f4bb',
    ':technologist_tone2:': '1f9d1-1f3fc-200d-1f4bb',
    ':technologist_tone3:': '1f9d1-1f3fd-200d-1f4bb',
    ':technologist_tone4:': '1f9d1-1f3fe-200d-1f4bb',
    ':technologist_tone5:': '1f9d1-1f3ff-200d-1f4bb',
    ':woman_artist_tone1:': '1f469-1f3fb-200d-1f3a8',
    ':woman_artist_tone2:': '1f469-1f3fc-200d-1f3a8',
    ':woman_artist_tone3:': '1f469-1f3fd-200d-1f3a8',
    ':woman_artist_tone4:': '1f469-1f3fe-200d-1f3a8',
    ':woman_artist_tone5:': '1f469-1f3ff-200d-1f3a8',
    ':woman_astronaut_tone1:': '1f469-1f3fb-200d-1f680',
    ':woman_astronaut_tone2:': '1f469-1f3fc-200d-1f680',
    ':woman_astronaut_tone3:': '1f469-1f3fd-200d-1f680',
    ':woman_astronaut_tone4:': '1f469-1f3fe-200d-1f680',
    ':woman_astronaut_tone5:': '1f469-1f3ff-200d-1f680',
    ':woman_bald_tone1:': '1f469-1f3fb-200d-1f9b2',
    ':woman_bald_tone2:': '1f469-1f3fc-200d-1f9b2',
    ':woman_bald_tone3:': '1f469-1f3fd-200d-1f9b2',
    ':woman_bald_tone4:': '1f469-1f3fe-200d-1f9b2',
    ':woman_bald_tone5:': '1f469-1f3ff-200d-1f9b2',
    ':woman_cook_tone1:': '1f469-1f3fb-200d-1f373',
    ':woman_cook_tone2:': '1f469-1f3fc-200d-1f373',
    ':woman_cook_tone3:': '1f469-1f3fd-200d-1f373',
    ':woman_cook_tone4:': '1f469-1f3fe-200d-1f373',
    ':woman_cook_tone5:': '1f469-1f3ff-200d-1f373',
    ':woman_curly_haired_tone1:': '1f469-1f3fb-200d-1f9b1',
    ':woman_curly_haired_tone2:': '1f469-1f3fc-200d-1f9b1',
    ':woman_curly_haired_tone3:': '1f469-1f3fd-200d-1f9b1',
    ':woman_curly_haired_tone4:': '1f469-1f3fe-200d-1f9b1',
    ':woman_curly_haired_tone5:': '1f469-1f3ff-200d-1f9b1',
    ':woman_factory_worker_tone1:': '1f469-1f3fb-200d-1f3ed',
    ':woman_factory_worker_tone2:': '1f469-1f3fc-200d-1f3ed',
    ':woman_factory_worker_tone3:': '1f469-1f3fd-200d-1f3ed',
    ':woman_factory_worker_tone4:': '1f469-1f3fe-200d-1f3ed',
    ':woman_factory_worker_tone5:': '1f469-1f3ff-200d-1f3ed',
    ':woman_farmer_tone1:': '1f469-1f3fb-200d-1f33e',
    ':woman_farmer_tone2:': '1f469-1f3fc-200d-1f33e',
    ':woman_farmer_tone3:': '1f469-1f3fd-200d-1f33e',
    ':woman_farmer_tone4:': '1f469-1f3fe-200d-1f33e',
    ':woman_farmer_tone5:': '1f469-1f3ff-200d-1f33e',
    ':woman_feeding_baby_tone1:': '1f469-1f3fb-200d-1f37c',
    ':woman_feeding_baby_tone2:': '1f469-1f3fc-200d-1f37c',
    ':woman_feeding_baby_tone3:': '1f469-1f3fd-200d-1f37c',
    ':woman_feeding_baby_tone4:': '1f469-1f3fe-200d-1f37c',
    ':woman_feeding_baby_tone5:': '1f469-1f3ff-200d-1f37c',
    ':woman_firefighter_tone1:': '1f469-1f3fb-200d-1f692',
    ':woman_firefighter_tone2:': '1f469-1f3fc-200d-1f692',
    ':woman_firefighter_tone3:': '1f469-1f3fd-200d-1f692',
    ':woman_firefighter_tone4:': '1f469-1f3fe-200d-1f692',
    ':woman_firefighter_tone5:': '1f469-1f3ff-200d-1f692',
    ':woman_in_manual_wheelchair_tone1:': '1f469-1f3fb-200d-1f9bd',
    ':woman_in_manual_wheelchair_tone2:': '1f469-1f3fc-200d-1f9bd',
    ':woman_in_manual_wheelchair_tone3:': '1f469-1f3fd-200d-1f9bd',
    ':woman_in_manual_wheelchair_tone4:': '1f469-1f3fe-200d-1f9bd',
    ':woman_in_manual_wheelchair_tone5:': '1f469-1f3ff-200d-1f9bd',
    ':woman_in_motorized_wheelchair_tone1:': '1f469-1f3fb-200d-1f9bc',
    ':woman_in_motorized_wheelchair_tone2:': '1f469-1f3fc-200d-1f9bc',
    ':woman_in_motorized_wheelchair_tone3:': '1f469-1f3fd-200d-1f9bc',
    ':woman_in_motorized_wheelchair_tone4:': '1f469-1f3fe-200d-1f9bc',
    ':woman_in_motorized_wheelchair_tone5:': '1f469-1f3ff-200d-1f9bc',
    ':woman_mechanic_tone1:': '1f469-1f3fb-200d-1f527',
    ':woman_mechanic_tone2:': '1f469-1f3fc-200d-1f527',
    ':woman_mechanic_tone3:': '1f469-1f3fd-200d-1f527',
    ':woman_mechanic_tone4:': '1f469-1f3fe-200d-1f527',
    ':woman_mechanic_tone5:': '1f469-1f3ff-200d-1f527',
    ':woman_office_worker_tone1:': '1f469-1f3fb-200d-1f4bc',
    ':woman_office_worker_tone2:': '1f469-1f3fc-200d-1f4bc',
    ':woman_office_worker_tone3:': '1f469-1f3fd-200d-1f4bc',
    ':woman_office_worker_tone4:': '1f469-1f3fe-200d-1f4bc',
    ':woman_office_worker_tone5:': '1f469-1f3ff-200d-1f4bc',
    ':woman_red_haired_tone1:': '1f469-1f3fb-200d-1f9b0',
    ':woman_red_haired_tone2:': '1f469-1f3fc-200d-1f9b0',
    ':woman_red_haired_tone3:': '1f469-1f3fd-200d-1f9b0',
    ':woman_red_haired_tone4:': '1f469-1f3fe-200d-1f9b0',
    ':woman_red_haired_tone5:': '1f469-1f3ff-200d-1f9b0',
    ':woman_scientist_tone1:': '1f469-1f3fb-200d-1f52c',
    ':woman_scientist_tone2:': '1f469-1f3fc-200d-1f52c',
    ':woman_scientist_tone3:': '1f469-1f3fd-200d-1f52c',
    ':woman_scientist_tone4:': '1f469-1f3fe-200d-1f52c',
    ':woman_scientist_tone5:': '1f469-1f3ff-200d-1f52c',
    ':woman_singer_tone1:': '1f469-1f3fb-200d-1f3a4',
    ':woman_singer_tone2:': '1f469-1f3fc-200d-1f3a4',
    ':woman_singer_tone3:': '1f469-1f3fd-200d-1f3a4',
    ':woman_singer_tone4:': '1f469-1f3fe-200d-1f3a4',
    ':woman_singer_tone5:': '1f469-1f3ff-200d-1f3a4',
    ':woman_student_tone1:': '1f469-1f3fb-200d-1f393',
    ':woman_student_tone2:': '1f469-1f3fc-200d-1f393',
    ':woman_student_tone3:': '1f469-1f3fd-200d-1f393',
    ':woman_student_tone4:': '1f469-1f3fe-200d-1f393',
    ':woman_student_tone5:': '1f469-1f3ff-200d-1f393',
    ':woman_teacher_tone1:': '1f469-1f3fb-200d-1f3eb',
    ':woman_teacher_tone2:': '1f469-1f3fc-200d-1f3eb',
    ':woman_teacher_tone3:': '1f469-1f3fd-200d-1f3eb',
    ':woman_teacher_tone4:': '1f469-1f3fe-200d-1f3eb',
    ':woman_teacher_tone5:': '1f469-1f3ff-200d-1f3eb',
    ':woman_technologist_tone1:': '1f469-1f3fb-200d-1f4bb',
    ':woman_technologist_tone2:': '1f469-1f3fc-200d-1f4bb',
    ':woman_technologist_tone3:': '1f469-1f3fd-200d-1f4bb',
    ':woman_technologist_tone4:': '1f469-1f3fe-200d-1f4bb',
    ':woman_technologist_tone5:': '1f469-1f3ff-200d-1f4bb',
    ':woman_white_haired_tone1:': '1f469-1f3fb-200d-1f9b3',
    ':woman_white_haired_tone2:': '1f469-1f3fc-200d-1f9b3',
    ':woman_white_haired_tone3:': '1f469-1f3fd-200d-1f9b3',
    ':woman_white_haired_tone4:': '1f469-1f3fe-200d-1f9b3',
    ':woman_white_haired_tone5:': '1f469-1f3ff-200d-1f9b3',
    ':woman_with_probing_cane_tone1:': '1f469-1f3fb-200d-1f9af',
    ':woman_with_probing_cane_tone2:': '1f469-1f3fc-200d-1f9af',
    ':woman_with_probing_cane_tone3:': '1f469-1f3fd-200d-1f9af',
    ':woman_with_probing_cane_tone4:': '1f469-1f3fe-200d-1f9af',
    ':woman_with_probing_cane_tone5:': '1f469-1f3ff-200d-1f9af',
    ':blond-haired_man_tone1:': '1f471-1f3fb-200d-2642-fe0f',
    ':blond-haired_man_tone2:': '1f471-1f3fc-200d-2642-fe0f',
    ':blond-haired_man_tone3:': '1f471-1f3fd-200d-2642-fe0f',
    ':blond-haired_man_tone4:': '1f471-1f3fe-200d-2642-fe0f',
    ':blond-haired_man_tone5:': '1f471-1f3ff-200d-2642-fe0f',
    ':blond-haired_woman_tone1:': '1f471-1f3fb-200d-2640-fe0f',
    ':blond-haired_woman_tone2:': '1f471-1f3fc-200d-2640-fe0f',
    ':blond-haired_woman_tone3:': '1f471-1f3fd-200d-2640-fe0f',
    ':blond-haired_woman_tone4:': '1f471-1f3fe-200d-2640-fe0f',
    ':blond-haired_woman_tone5:': '1f471-1f3ff-200d-2640-fe0f',
    ':couple_mm:': '1f468-200d-2764-fe0f-200d-1f468',
    ':couple_with_heart_woman_man:': '1f469-200d-2764-fe0f-200d-1f468',
    ':couple_ww:': '1f469-200d-2764-fe0f-200d-1f469',
    ':deaf_man_tone1:': '1f9cf-1f3fb-200d-2642-fe0f',
    ':deaf_man_tone2:': '1f9cf-1f3fc-200d-2642-fe0f',
    ':deaf_man_tone3:': '1f9cf-1f3fd-200d-2642-fe0f',
    ':deaf_man_tone4:': '1f9cf-1f3fe-200d-2642-fe0f',
    ':deaf_man_tone5:': '1f9cf-1f3ff-200d-2642-fe0f',
    ':deaf_woman_tone1:': '1f9cf-1f3fb-200d-2640-fe0f',
    ':deaf_woman_tone2:': '1f9cf-1f3fc-200d-2640-fe0f',
    ':deaf_woman_tone3:': '1f9cf-1f3fd-200d-2640-fe0f',
    ':deaf_woman_tone4:': '1f9cf-1f3fe-200d-2640-fe0f',
    ':deaf_woman_tone5:': '1f9cf-1f3ff-200d-2640-fe0f',
    ':health_worker_tone1:': '1f9d1-1f3fb-200d-2695-fe0f',
    ':health_worker_tone2:': '1f9d1-1f3fc-200d-2695-fe0f',
    ':health_worker_tone3:': '1f9d1-1f3fd-200d-2695-fe0f',
    ':health_worker_tone4:': '1f9d1-1f3fe-200d-2695-fe0f',
    ':health_worker_tone5:': '1f9d1-1f3ff-200d-2695-fe0f',
    ':judge_tone1:': '1f9d1-1f3fb-200d-2696-fe0f',
    ':judge_tone2:': '1f9d1-1f3fc-200d-2696-fe0f',
    ':judge_tone3:': '1f9d1-1f3fd-200d-2696-fe0f',
    ':judge_tone4:': '1f9d1-1f3fe-200d-2696-fe0f',
    ':judge_tone5:': '1f9d1-1f3ff-200d-2696-fe0f',
    ':man_biking_tone1:': '1f6b4-1f3fb-200d-2642-fe0f',
    ':man_biking_tone2:': '1f6b4-1f3fc-200d-2642-fe0f',
    ':man_biking_tone3:': '1f6b4-1f3fd-200d-2642-fe0f',
    ':man_biking_tone4:': '1f6b4-1f3fe-200d-2642-fe0f',
    ':man_biking_tone5:': '1f6b4-1f3ff-200d-2642-fe0f',
    ':man_bowing_tone1:': '1f647-1f3fb-200d-2642-fe0f',
    ':man_bowing_tone2:': '1f647-1f3fc-200d-2642-fe0f',
    ':man_bowing_tone3:': '1f647-1f3fd-200d-2642-fe0f',
    ':man_bowing_tone4:': '1f647-1f3fe-200d-2642-fe0f',
    ':man_bowing_tone5:': '1f647-1f3ff-200d-2642-fe0f',
    ':man_cartwheeling_tone1:': '1f938-1f3fb-200d-2642-fe0f',
    ':man_cartwheeling_tone2:': '1f938-1f3fc-200d-2642-fe0f',
    ':man_cartwheeling_tone3:': '1f938-1f3fd-200d-2642-fe0f',
    ':man_cartwheeling_tone4:': '1f938-1f3fe-200d-2642-fe0f',
    ':man_cartwheeling_tone5:': '1f938-1f3ff-200d-2642-fe0f',
    ':man_climbing_tone1:': '1f9d7-1f3fb-200d-2642-fe0f',
    ':man_climbing_tone2:': '1f9d7-1f3fc-200d-2642-fe0f',
    ':man_climbing_tone3:': '1f9d7-1f3fd-200d-2642-fe0f',
    ':man_climbing_tone4:': '1f9d7-1f3fe-200d-2642-fe0f',
    ':man_climbing_tone5:': '1f9d7-1f3ff-200d-2642-fe0f',
    ':man_construction_worker_tone1:': '1f477-1f3fb-200d-2642-fe0f',
    ':man_construction_worker_tone2:': '1f477-1f3fc-200d-2642-fe0f',
    ':man_construction_worker_tone3:': '1f477-1f3fd-200d-2642-fe0f',
    ':man_construction_worker_tone4:': '1f477-1f3fe-200d-2642-fe0f',
    ':man_construction_worker_tone5:': '1f477-1f3ff-200d-2642-fe0f',
    ':man_detective_tone1:': '1f575-1f3fb-200d-2642-fe0f',
    ':man_detective_tone2:': '1f575-1f3fc-200d-2642-fe0f',
    ':man_detective_tone3:': '1f575-1f3fd-200d-2642-fe0f',
    ':man_detective_tone4:': '1f575-1f3fe-200d-2642-fe0f',
    ':man_detective_tone5:': '1f575-1f3ff-200d-2642-fe0f',
    ':man_elf_tone1:': '1f9dd-1f3fb-200d-2642-fe0f',
    ':man_elf_tone2:': '1f9dd-1f3fc-200d-2642-fe0f',
    ':man_elf_tone3:': '1f9dd-1f3fd-200d-2642-fe0f',
    ':man_elf_tone4:': '1f9dd-1f3fe-200d-2642-fe0f',
    ':man_elf_tone5:': '1f9dd-1f3ff-200d-2642-fe0f',
    ':man_facepalming_tone1:': '1f926-1f3fb-200d-2642-fe0f',
    ':man_facepalming_tone2:': '1f926-1f3fc-200d-2642-fe0f',
    ':man_facepalming_tone3:': '1f926-1f3fd-200d-2642-fe0f',
    ':man_facepalming_tone4:': '1f926-1f3fe-200d-2642-fe0f',
    ':man_facepalming_tone5:': '1f926-1f3ff-200d-2642-fe0f',
    ':man_fairy_tone1:': '1f9da-1f3fb-200d-2642-fe0f',
    ':man_fairy_tone2:': '1f9da-1f3fc-200d-2642-fe0f',
    ':man_fairy_tone3:': '1f9da-1f3fd-200d-2642-fe0f',
    ':man_fairy_tone4:': '1f9da-1f3fe-200d-2642-fe0f',
    ':man_fairy_tone5:': '1f9da-1f3ff-200d-2642-fe0f',
    ':man_frowning_tone1:': '1f64d-1f3fb-200d-2642-fe0f',
    ':man_frowning_tone2:': '1f64d-1f3fc-200d-2642-fe0f',
    ':man_frowning_tone3:': '1f64d-1f3fd-200d-2642-fe0f',
    ':man_frowning_tone4:': '1f64d-1f3fe-200d-2642-fe0f',
    ':man_frowning_tone5:': '1f64d-1f3ff-200d-2642-fe0f',
    ':man_gesturing_no_tone1:': '1f645-1f3fb-200d-2642-fe0f',
    ':man_gesturing_no_tone2:': '1f645-1f3fc-200d-2642-fe0f',
    ':man_gesturing_no_tone3:': '1f645-1f3fd-200d-2642-fe0f',
    ':man_gesturing_no_tone4:': '1f645-1f3fe-200d-2642-fe0f',
    ':man_gesturing_no_tone5:': '1f645-1f3ff-200d-2642-fe0f',
    ':man_gesturing_ok_tone1:': '1f646-1f3fb-200d-2642-fe0f',
    ':man_gesturing_ok_tone2:': '1f646-1f3fc-200d-2642-fe0f',
    ':man_gesturing_ok_tone3:': '1f646-1f3fd-200d-2642-fe0f',
    ':man_gesturing_ok_tone4:': '1f646-1f3fe-200d-2642-fe0f',
    ':man_gesturing_ok_tone5:': '1f646-1f3ff-200d-2642-fe0f',
    ':man_getting_face_massage_tone1:': '1f486-1f3fb-200d-2642-fe0f',
    ':man_getting_face_massage_tone2:': '1f486-1f3fc-200d-2642-fe0f',
    ':man_getting_face_massage_tone3:': '1f486-1f3fd-200d-2642-fe0f',
    ':man_getting_face_massage_tone4:': '1f486-1f3fe-200d-2642-fe0f',
    ':man_getting_face_massage_tone5:': '1f486-1f3ff-200d-2642-fe0f',
    ':man_getting_haircut_tone1:': '1f487-1f3fb-200d-2642-fe0f',
    ':man_getting_haircut_tone2:': '1f487-1f3fc-200d-2642-fe0f',
    ':man_getting_haircut_tone3:': '1f487-1f3fd-200d-2642-fe0f',
    ':man_getting_haircut_tone4:': '1f487-1f3fe-200d-2642-fe0f',
    ':man_getting_haircut_tone5:': '1f487-1f3ff-200d-2642-fe0f',
    ':man_golfing_tone1:': '1f3cc-1f3fb-200d-2642-fe0f',
    ':man_golfing_tone2:': '1f3cc-1f3fc-200d-2642-fe0f',
    ':man_golfing_tone3:': '1f3cc-1f3fd-200d-2642-fe0f',
    ':man_golfing_tone4:': '1f3cc-1f3fe-200d-2642-fe0f',
    ':man_golfing_tone5:': '1f3cc-1f3ff-200d-2642-fe0f',
    ':man_guard_tone1:': '1f482-1f3fb-200d-2642-fe0f',
    ':man_guard_tone2:': '1f482-1f3fc-200d-2642-fe0f',
    ':man_guard_tone3:': '1f482-1f3fd-200d-2642-fe0f',
    ':man_guard_tone4:': '1f482-1f3fe-200d-2642-fe0f',
    ':man_guard_tone5:': '1f482-1f3ff-200d-2642-fe0f',
    ':man_health_worker_tone1:': '1f468-1f3fb-200d-2695-fe0f',
    ':man_health_worker_tone2:': '1f468-1f3fc-200d-2695-fe0f',
    ':man_health_worker_tone3:': '1f468-1f3fd-200d-2695-fe0f',
    ':man_health_worker_tone4:': '1f468-1f3fe-200d-2695-fe0f',
    ':man_health_worker_tone5:': '1f468-1f3ff-200d-2695-fe0f',
    ':man_in_lotus_position_tone1:': '1f9d8-1f3fb-200d-2642-fe0f',
    ':man_in_lotus_position_tone2:': '1f9d8-1f3fc-200d-2642-fe0f',
    ':man_in_lotus_position_tone3:': '1f9d8-1f3fd-200d-2642-fe0f',
    ':man_in_lotus_position_tone4:': '1f9d8-1f3fe-200d-2642-fe0f',
    ':man_in_lotus_position_tone5:': '1f9d8-1f3ff-200d-2642-fe0f',
    ':man_in_steamy_room_tone1:': '1f9d6-1f3fb-200d-2642-fe0f',
    ':man_in_steamy_room_tone2:': '1f9d6-1f3fc-200d-2642-fe0f',
    ':man_in_steamy_room_tone3:': '1f9d6-1f3fd-200d-2642-fe0f',
    ':man_in_steamy_room_tone4:': '1f9d6-1f3fe-200d-2642-fe0f',
    ':man_in_steamy_room_tone5:': '1f9d6-1f3ff-200d-2642-fe0f',
    ':man_in_tuxedo_tone1:': '1f935-1f3fb-200d-2642-fe0f',
    ':man_in_tuxedo_tone2:': '1f935-1f3fc-200d-2642-fe0f',
    ':man_in_tuxedo_tone3:': '1f935-1f3fd-200d-2642-fe0f',
    ':man_in_tuxedo_tone4:': '1f935-1f3fe-200d-2642-fe0f',
    ':man_in_tuxedo_tone5:': '1f935-1f3ff-200d-2642-fe0f',
    ':man_judge_tone1:': '1f468-1f3fb-200d-2696-fe0f',
    ':man_judge_tone2:': '1f468-1f3fc-200d-2696-fe0f',
    ':man_judge_tone3:': '1f468-1f3fd-200d-2696-fe0f',
    ':man_judge_tone4:': '1f468-1f3fe-200d-2696-fe0f',
    ':man_judge_tone5:': '1f468-1f3ff-200d-2696-fe0f',
    ':man_juggling_tone1:': '1f939-1f3fb-200d-2642-fe0f',
    ':man_juggling_tone2:': '1f939-1f3fc-200d-2642-fe0f',
    ':man_juggling_tone3:': '1f939-1f3fd-200d-2642-fe0f',
    ':man_juggling_tone4:': '1f939-1f3fe-200d-2642-fe0f',
    ':man_juggling_tone5:': '1f939-1f3ff-200d-2642-fe0f',
    ':man_kneeling_tone1:': '1f9ce-1f3fb-200d-2642-fe0f',
    ':man_kneeling_tone2:': '1f9ce-1f3fc-200d-2642-fe0f',
    ':man_kneeling_tone3:': '1f9ce-1f3fd-200d-2642-fe0f',
    ':man_kneeling_tone4:': '1f9ce-1f3fe-200d-2642-fe0f',
    ':man_kneeling_tone5:': '1f9ce-1f3ff-200d-2642-fe0f',
    ':man_lifting_weights_tone1:': '1f3cb-1f3fb-200d-2642-fe0f',
    ':man_lifting_weights_tone2:': '1f3cb-1f3fc-200d-2642-fe0f',
    ':man_lifting_weights_tone3:': '1f3cb-1f3fd-200d-2642-fe0f',
    ':man_lifting_weights_tone4:': '1f3cb-1f3fe-200d-2642-fe0f',
    ':man_lifting_weights_tone5:': '1f3cb-1f3ff-200d-2642-fe0f',
    ':man_mage_tone1:': '1f9d9-1f3fb-200d-2642-fe0f',
    ':man_mage_tone2:': '1f9d9-1f3fc-200d-2642-fe0f',
    ':man_mage_tone3:': '1f9d9-1f3fd-200d-2642-fe0f',
    ':man_mage_tone4:': '1f9d9-1f3fe-200d-2642-fe0f',
    ':man_mage_tone5:': '1f9d9-1f3ff-200d-2642-fe0f',
    ':man_mountain_biking_tone1:': '1f6b5-1f3fb-200d-2642-fe0f',
    ':man_mountain_biking_tone2:': '1f6b5-1f3fc-200d-2642-fe0f',
    ':man_mountain_biking_tone3:': '1f6b5-1f3fd-200d-2642-fe0f',
    ':man_mountain_biking_tone4:': '1f6b5-1f3fe-200d-2642-fe0f',
    ':man_mountain_biking_tone5:': '1f6b5-1f3ff-200d-2642-fe0f',
    ':man_pilot_tone1:': '1f468-1f3fb-200d-2708-fe0f',
    ':man_pilot_tone2:': '1f468-1f3fc-200d-2708-fe0f',
    ':man_pilot_tone3:': '1f468-1f3fd-200d-2708-fe0f',
    ':man_pilot_tone4:': '1f468-1f3fe-200d-2708-fe0f',
    ':man_pilot_tone5:': '1f468-1f3ff-200d-2708-fe0f',
    ':man_playing_handball_tone1:': '1f93e-1f3fb-200d-2642-fe0f',
    ':man_playing_handball_tone2:': '1f93e-1f3fc-200d-2642-fe0f',
    ':man_playing_handball_tone3:': '1f93e-1f3fd-200d-2642-fe0f',
    ':man_playing_handball_tone4:': '1f93e-1f3fe-200d-2642-fe0f',
    ':man_playing_handball_tone5:': '1f93e-1f3ff-200d-2642-fe0f',
    ':man_playing_water_polo_tone1:': '1f93d-1f3fb-200d-2642-fe0f',
    ':man_playing_water_polo_tone2:': '1f93d-1f3fc-200d-2642-fe0f',
    ':man_playing_water_polo_tone3:': '1f93d-1f3fd-200d-2642-fe0f',
    ':man_playing_water_polo_tone4:': '1f93d-1f3fe-200d-2642-fe0f',
    ':man_playing_water_polo_tone5:': '1f93d-1f3ff-200d-2642-fe0f',
    ':man_police_officer_tone1:': '1f46e-1f3fb-200d-2642-fe0f',
    ':man_police_officer_tone2:': '1f46e-1f3fc-200d-2642-fe0f',
    ':man_police_officer_tone3:': '1f46e-1f3fd-200d-2642-fe0f',
    ':man_police_officer_tone4:': '1f46e-1f3fe-200d-2642-fe0f',
    ':man_police_officer_tone5:': '1f46e-1f3ff-200d-2642-fe0f',
    ':man_pouting_tone1:': '1f64e-1f3fb-200d-2642-fe0f',
    ':man_pouting_tone2:': '1f64e-1f3fc-200d-2642-fe0f',
    ':man_pouting_tone3:': '1f64e-1f3fd-200d-2642-fe0f',
    ':man_pouting_tone4:': '1f64e-1f3fe-200d-2642-fe0f',
    ':man_pouting_tone5:': '1f64e-1f3ff-200d-2642-fe0f',
    ':man_raising_hand_tone1:': '1f64b-1f3fb-200d-2642-fe0f',
    ':man_raising_hand_tone2:': '1f64b-1f3fc-200d-2642-fe0f',
    ':man_raising_hand_tone3:': '1f64b-1f3fd-200d-2642-fe0f',
    ':man_raising_hand_tone4:': '1f64b-1f3fe-200d-2642-fe0f',
    ':man_raising_hand_tone5:': '1f64b-1f3ff-200d-2642-fe0f',
    ':man_rowing_boat_tone1:': '1f6a3-1f3fb-200d-2642-fe0f',
    ':man_rowing_boat_tone2:': '1f6a3-1f3fc-200d-2642-fe0f',
    ':man_rowing_boat_tone3:': '1f6a3-1f3fd-200d-2642-fe0f',
    ':man_rowing_boat_tone4:': '1f6a3-1f3fe-200d-2642-fe0f',
    ':man_rowing_boat_tone5:': '1f6a3-1f3ff-200d-2642-fe0f',
    ':man_running_tone1:': '1f3c3-1f3fb-200d-2642-fe0f',
    ':man_running_tone2:': '1f3c3-1f3fc-200d-2642-fe0f',
    ':man_running_tone3:': '1f3c3-1f3fd-200d-2642-fe0f',
    ':man_running_tone4:': '1f3c3-1f3fe-200d-2642-fe0f',
    ':man_running_tone5:': '1f3c3-1f3ff-200d-2642-fe0f',
    ':man_shrugging_tone1:': '1f937-1f3fb-200d-2642-fe0f',
    ':man_shrugging_tone2:': '1f937-1f3fc-200d-2642-fe0f',
    ':man_shrugging_tone3:': '1f937-1f3fd-200d-2642-fe0f',
    ':man_shrugging_tone4:': '1f937-1f3fe-200d-2642-fe0f',
    ':man_shrugging_tone5:': '1f937-1f3ff-200d-2642-fe0f',
    ':man_standing_tone1:': '1f9cd-1f3fb-200d-2642-fe0f',
    ':man_standing_tone2:': '1f9cd-1f3fc-200d-2642-fe0f',
    ':man_standing_tone3:': '1f9cd-1f3fd-200d-2642-fe0f',
    ':man_standing_tone4:': '1f9cd-1f3fe-200d-2642-fe0f',
    ':man_standing_tone5:': '1f9cd-1f3ff-200d-2642-fe0f',
    ':man_superhero_tone1:': '1f9b8-1f3fb-200d-2642-fe0f',
    ':man_superhero_tone2:': '1f9b8-1f3fc-200d-2642-fe0f',
    ':man_superhero_tone3:': '1f9b8-1f3fd-200d-2642-fe0f',
    ':man_superhero_tone4:': '1f9b8-1f3fe-200d-2642-fe0f',
    ':man_superhero_tone5:': '1f9b8-1f3ff-200d-2642-fe0f',
    ':man_supervillain_tone1:': '1f9b9-1f3fb-200d-2642-fe0f',
    ':man_supervillain_tone2:': '1f9b9-1f3fc-200d-2642-fe0f',
    ':man_supervillain_tone3:': '1f9b9-1f3fd-200d-2642-fe0f',
    ':man_supervillain_tone4:': '1f9b9-1f3fe-200d-2642-fe0f',
    ':man_supervillain_tone5:': '1f9b9-1f3ff-200d-2642-fe0f',
    ':man_surfing_tone1:': '1f3c4-1f3fb-200d-2642-fe0f',
    ':man_surfing_tone2:': '1f3c4-1f3fc-200d-2642-fe0f',
    ':man_surfing_tone3:': '1f3c4-1f3fd-200d-2642-fe0f',
    ':man_surfing_tone4:': '1f3c4-1f3fe-200d-2642-fe0f',
    ':man_surfing_tone5:': '1f3c4-1f3ff-200d-2642-fe0f',
    ':man_swimming_tone1:': '1f3ca-1f3fb-200d-2642-fe0f',
    ':man_swimming_tone2:': '1f3ca-1f3fc-200d-2642-fe0f',
    ':man_swimming_tone3:': '1f3ca-1f3fd-200d-2642-fe0f',
    ':man_swimming_tone4:': '1f3ca-1f3fe-200d-2642-fe0f',
    ':man_swimming_tone5:': '1f3ca-1f3ff-200d-2642-fe0f',
    ':man_tipping_hand_tone1:': '1f481-1f3fb-200d-2642-fe0f',
    ':man_tipping_hand_tone2:': '1f481-1f3fc-200d-2642-fe0f',
    ':man_tipping_hand_tone3:': '1f481-1f3fd-200d-2642-fe0f',
    ':man_tipping_hand_tone4:': '1f481-1f3fe-200d-2642-fe0f',
    ':man_tipping_hand_tone5:': '1f481-1f3ff-200d-2642-fe0f',
    ':man_tone1_beard:': '1f9d4-1f3fb-200d-2642-fe0f',
    ':man_tone2_beard:': '1f9d4-1f3fc-200d-2642-fe0f',
    ':man_tone3_beard:': '1f9d4-1f3fd-200d-2642-fe0f',
    ':man_tone4_beard:': '1f9d4-1f3fe-200d-2642-fe0f',
    ':man_tone5_beard:': '1f9d4-1f3ff-200d-2642-fe0f',
    ':man_vampire_tone1:': '1f9db-1f3fb-200d-2642-fe0f',
    ':man_vampire_tone2:': '1f9db-1f3fc-200d-2642-fe0f',
    ':man_vampire_tone3:': '1f9db-1f3fd-200d-2642-fe0f',
    ':man_vampire_tone4:': '1f9db-1f3fe-200d-2642-fe0f',
    ':man_vampire_tone5:': '1f9db-1f3ff-200d-2642-fe0f',
    ':man_walking_tone1:': '1f6b6-1f3fb-200d-2642-fe0f',
    ':man_walking_tone2:': '1f6b6-1f3fc-200d-2642-fe0f',
    ':man_walking_tone3:': '1f6b6-1f3fd-200d-2642-fe0f',
    ':man_walking_tone4:': '1f6b6-1f3fe-200d-2642-fe0f',
    ':man_walking_tone5:': '1f6b6-1f3ff-200d-2642-fe0f',
    ':man_wearing_turban_tone1:': '1f473-1f3fb-200d-2642-fe0f',
    ':man_wearing_turban_tone2:': '1f473-1f3fc-200d-2642-fe0f',
    ':man_wearing_turban_tone3:': '1f473-1f3fd-200d-2642-fe0f',
    ':man_wearing_turban_tone4:': '1f473-1f3fe-200d-2642-fe0f',
    ':man_wearing_turban_tone5:': '1f473-1f3ff-200d-2642-fe0f',
    ':man_with_veil_tone1:': '1f470-1f3fb-200d-2642-fe0f',
    ':man_with_veil_tone2:': '1f470-1f3fc-200d-2642-fe0f',
    ':man_with_veil_tone3:': '1f470-1f3fd-200d-2642-fe0f',
    ':man_with_veil_tone4:': '1f470-1f3fe-200d-2642-fe0f',
    ':man_with_veil_tone5:': '1f470-1f3ff-200d-2642-fe0f',
    ':mermaid_tone1:': '1f9dc-1f3fb-200d-2640-fe0f',
    ':mermaid_tone2:': '1f9dc-1f3fc-200d-2640-fe0f',
    ':mermaid_tone3:': '1f9dc-1f3fd-200d-2640-fe0f',
    ':mermaid_tone4:': '1f9dc-1f3fe-200d-2640-fe0f',
    ':mermaid_tone5:': '1f9dc-1f3ff-200d-2640-fe0f',
    ':merman_tone1:': '1f9dc-1f3fb-200d-2642-fe0f',
    ':merman_tone2:': '1f9dc-1f3fc-200d-2642-fe0f',
    ':merman_tone3:': '1f9dc-1f3fd-200d-2642-fe0f',
    ':merman_tone4:': '1f9dc-1f3fe-200d-2642-fe0f',
    ':merman_tone5:': '1f9dc-1f3ff-200d-2642-fe0f',
    ':pilot_tone1:': '1f9d1-1f3fb-200d-2708-fe0f',
    ':pilot_tone2:': '1f9d1-1f3fc-200d-2708-fe0f',
    ':pilot_tone3:': '1f9d1-1f3fd-200d-2708-fe0f',
    ':pilot_tone4:': '1f9d1-1f3fe-200d-2708-fe0f',
    ':pilot_tone5:': '1f9d1-1f3ff-200d-2708-fe0f',
    ':woman_biking_tone1:': '1f6b4-1f3fb-200d-2640-fe0f',
    ':woman_biking_tone2:': '1f6b4-1f3fc-200d-2640-fe0f',
    ':woman_biking_tone3:': '1f6b4-1f3fd-200d-2640-fe0f',
    ':woman_biking_tone4:': '1f6b4-1f3fe-200d-2640-fe0f',
    ':woman_biking_tone5:': '1f6b4-1f3ff-200d-2640-fe0f',
    ':woman_bowing_tone1:': '1f647-1f3fb-200d-2640-fe0f',
    ':woman_bowing_tone2:': '1f647-1f3fc-200d-2640-fe0f',
    ':woman_bowing_tone3:': '1f647-1f3fd-200d-2640-fe0f',
    ':woman_bowing_tone4:': '1f647-1f3fe-200d-2640-fe0f',
    ':woman_bowing_tone5:': '1f647-1f3ff-200d-2640-fe0f',
    ':woman_cartwheeling_tone1:': '1f938-1f3fb-200d-2640-fe0f',
    ':woman_cartwheeling_tone2:': '1f938-1f3fc-200d-2640-fe0f',
    ':woman_cartwheeling_tone3:': '1f938-1f3fd-200d-2640-fe0f',
    ':woman_cartwheeling_tone4:': '1f938-1f3fe-200d-2640-fe0f',
    ':woman_cartwheeling_tone5:': '1f938-1f3ff-200d-2640-fe0f',
    ':woman_climbing_tone1:': '1f9d7-1f3fb-200d-2640-fe0f',
    ':woman_climbing_tone2:': '1f9d7-1f3fc-200d-2640-fe0f',
    ':woman_climbing_tone3:': '1f9d7-1f3fd-200d-2640-fe0f',
    ':woman_climbing_tone4:': '1f9d7-1f3fe-200d-2640-fe0f',
    ':woman_climbing_tone5:': '1f9d7-1f3ff-200d-2640-fe0f',
    ':woman_construction_worker_tone1:': '1f477-1f3fb-200d-2640-fe0f',
    ':woman_construction_worker_tone2:': '1f477-1f3fc-200d-2640-fe0f',
    ':woman_construction_worker_tone3:': '1f477-1f3fd-200d-2640-fe0f',
    ':woman_construction_worker_tone4:': '1f477-1f3fe-200d-2640-fe0f',
    ':woman_construction_worker_tone5:': '1f477-1f3ff-200d-2640-fe0f',
    ':woman_detective_tone1:': '1f575-1f3fb-200d-2640-fe0f',
    ':woman_detective_tone2:': '1f575-1f3fc-200d-2640-fe0f',
    ':woman_detective_tone3:': '1f575-1f3fd-200d-2640-fe0f',
    ':woman_detective_tone4:': '1f575-1f3fe-200d-2640-fe0f',
    ':woman_detective_tone5:': '1f575-1f3ff-200d-2640-fe0f',
    ':woman_elf_tone1:': '1f9dd-1f3fb-200d-2640-fe0f',
    ':woman_elf_tone2:': '1f9dd-1f3fc-200d-2640-fe0f',
    ':woman_elf_tone3:': '1f9dd-1f3fd-200d-2640-fe0f',
    ':woman_elf_tone4:': '1f9dd-1f3fe-200d-2640-fe0f',
    ':woman_elf_tone5:': '1f9dd-1f3ff-200d-2640-fe0f',
    ':woman_facepalming_tone1:': '1f926-1f3fb-200d-2640-fe0f',
    ':woman_facepalming_tone2:': '1f926-1f3fc-200d-2640-fe0f',
    ':woman_facepalming_tone3:': '1f926-1f3fd-200d-2640-fe0f',
    ':woman_facepalming_tone4:': '1f926-1f3fe-200d-2640-fe0f',
    ':woman_facepalming_tone5:': '1f926-1f3ff-200d-2640-fe0f',
    ':woman_fairy_tone1:': '1f9da-1f3fb-200d-2640-fe0f',
    ':woman_fairy_tone2:': '1f9da-1f3fc-200d-2640-fe0f',
    ':woman_fairy_tone3:': '1f9da-1f3fd-200d-2640-fe0f',
    ':woman_fairy_tone4:': '1f9da-1f3fe-200d-2640-fe0f',
    ':woman_fairy_tone5:': '1f9da-1f3ff-200d-2640-fe0f',
    ':woman_frowning_tone1:': '1f64d-1f3fb-200d-2640-fe0f',
    ':woman_frowning_tone2:': '1f64d-1f3fc-200d-2640-fe0f',
    ':woman_frowning_tone3:': '1f64d-1f3fd-200d-2640-fe0f',
    ':woman_frowning_tone4:': '1f64d-1f3fe-200d-2640-fe0f',
    ':woman_frowning_tone5:': '1f64d-1f3ff-200d-2640-fe0f',
    ':woman_gesturing_no_tone1:': '1f645-1f3fb-200d-2640-fe0f',
    ':woman_gesturing_no_tone2:': '1f645-1f3fc-200d-2640-fe0f',
    ':woman_gesturing_no_tone3:': '1f645-1f3fd-200d-2640-fe0f',
    ':woman_gesturing_no_tone4:': '1f645-1f3fe-200d-2640-fe0f',
    ':woman_gesturing_no_tone5:': '1f645-1f3ff-200d-2640-fe0f',
    ':woman_gesturing_ok_tone1:': '1f646-1f3fb-200d-2640-fe0f',
    ':woman_gesturing_ok_tone2:': '1f646-1f3fc-200d-2640-fe0f',
    ':woman_gesturing_ok_tone3:': '1f646-1f3fd-200d-2640-fe0f',
    ':woman_gesturing_ok_tone4:': '1f646-1f3fe-200d-2640-fe0f',
    ':woman_gesturing_ok_tone5:': '1f646-1f3ff-200d-2640-fe0f',
    ':woman_getting_face_massage_tone1:': '1f486-1f3fb-200d-2640-fe0f',
    ':woman_getting_face_massage_tone2:': '1f486-1f3fc-200d-2640-fe0f',
    ':woman_getting_face_massage_tone3:': '1f486-1f3fd-200d-2640-fe0f',
    ':woman_getting_face_massage_tone4:': '1f486-1f3fe-200d-2640-fe0f',
    ':woman_getting_face_massage_tone5:': '1f486-1f3ff-200d-2640-fe0f',
    ':woman_getting_haircut_tone1:': '1f487-1f3fb-200d-2640-fe0f',
    ':woman_getting_haircut_tone2:': '1f487-1f3fc-200d-2640-fe0f',
    ':woman_getting_haircut_tone3:': '1f487-1f3fd-200d-2640-fe0f',
    ':woman_getting_haircut_tone4:': '1f487-1f3fe-200d-2640-fe0f',
    ':woman_getting_haircut_tone5:': '1f487-1f3ff-200d-2640-fe0f',
    ':woman_golfing_tone1:': '1f3cc-1f3fb-200d-2640-fe0f',
    ':woman_golfing_tone2:': '1f3cc-1f3fc-200d-2640-fe0f',
    ':woman_golfing_tone3:': '1f3cc-1f3fd-200d-2640-fe0f',
    ':woman_golfing_tone4:': '1f3cc-1f3fe-200d-2640-fe0f',
    ':woman_golfing_tone5:': '1f3cc-1f3ff-200d-2640-fe0f',
    ':woman_guard_tone1:': '1f482-1f3fb-200d-2640-fe0f',
    ':woman_guard_tone2:': '1f482-1f3fc-200d-2640-fe0f',
    ':woman_guard_tone3:': '1f482-1f3fd-200d-2640-fe0f',
    ':woman_guard_tone4:': '1f482-1f3fe-200d-2640-fe0f',
    ':woman_guard_tone5:': '1f482-1f3ff-200d-2640-fe0f',
    ':woman_health_worker_tone1:': '1f469-1f3fb-200d-2695-fe0f',
    ':woman_health_worker_tone2:': '1f469-1f3fc-200d-2695-fe0f',
    ':woman_health_worker_tone3:': '1f469-1f3fd-200d-2695-fe0f',
    ':woman_health_worker_tone4:': '1f469-1f3fe-200d-2695-fe0f',
    ':woman_health_worker_tone5:': '1f469-1f3ff-200d-2695-fe0f',
    ':woman_in_lotus_position_tone1:': '1f9d8-1f3fb-200d-2640-fe0f',
    ':woman_in_lotus_position_tone2:': '1f9d8-1f3fc-200d-2640-fe0f',
    ':woman_in_lotus_position_tone3:': '1f9d8-1f3fd-200d-2640-fe0f',
    ':woman_in_lotus_position_tone4:': '1f9d8-1f3fe-200d-2640-fe0f',
    ':woman_in_lotus_position_tone5:': '1f9d8-1f3ff-200d-2640-fe0f',
    ':woman_in_steamy_room_tone1:': '1f9d6-1f3fb-200d-2640-fe0f',
    ':woman_in_steamy_room_tone2:': '1f9d6-1f3fc-200d-2640-fe0f',
    ':woman_in_steamy_room_tone3:': '1f9d6-1f3fd-200d-2640-fe0f',
    ':woman_in_steamy_room_tone4:': '1f9d6-1f3fe-200d-2640-fe0f',
    ':woman_in_steamy_room_tone5:': '1f9d6-1f3ff-200d-2640-fe0f',
    ':woman_in_tuxedo_tone1:': '1f935-1f3fb-200d-2640-fe0f',
    ':woman_in_tuxedo_tone2:': '1f935-1f3fc-200d-2640-fe0f',
    ':woman_in_tuxedo_tone3:': '1f935-1f3fd-200d-2640-fe0f',
    ':woman_in_tuxedo_tone4:': '1f935-1f3fe-200d-2640-fe0f',
    ':woman_in_tuxedo_tone5:': '1f935-1f3ff-200d-2640-fe0f',
    ':woman_judge_tone1:': '1f469-1f3fb-200d-2696-fe0f',
    ':woman_judge_tone2:': '1f469-1f3fc-200d-2696-fe0f',
    ':woman_judge_tone3:': '1f469-1f3fd-200d-2696-fe0f',
    ':woman_judge_tone4:': '1f469-1f3fe-200d-2696-fe0f',
    ':woman_judge_tone5:': '1f469-1f3ff-200d-2696-fe0f',
    ':woman_juggling_tone1:': '1f939-1f3fb-200d-2640-fe0f',
    ':woman_juggling_tone2:': '1f939-1f3fc-200d-2640-fe0f',
    ':woman_juggling_tone3:': '1f939-1f3fd-200d-2640-fe0f',
    ':woman_juggling_tone4:': '1f939-1f3fe-200d-2640-fe0f',
    ':woman_juggling_tone5:': '1f939-1f3ff-200d-2640-fe0f',
    ':woman_kneeling_tone1:': '1f9ce-1f3fb-200d-2640-fe0f',
    ':woman_kneeling_tone2:': '1f9ce-1f3fc-200d-2640-fe0f',
    ':woman_kneeling_tone3:': '1f9ce-1f3fd-200d-2640-fe0f',
    ':woman_kneeling_tone4:': '1f9ce-1f3fe-200d-2640-fe0f',
    ':woman_kneeling_tone5:': '1f9ce-1f3ff-200d-2640-fe0f',
    ':woman_lifting_weights_tone1:': '1f3cb-1f3fb-200d-2640-fe0f',
    ':woman_lifting_weights_tone2:': '1f3cb-1f3fc-200d-2640-fe0f',
    ':woman_lifting_weights_tone3:': '1f3cb-1f3fd-200d-2640-fe0f',
    ':woman_lifting_weights_tone4:': '1f3cb-1f3fe-200d-2640-fe0f',
    ':woman_lifting_weights_tone5:': '1f3cb-1f3ff-200d-2640-fe0f',
    ':woman_mage_tone1:': '1f9d9-1f3fb-200d-2640-fe0f',
    ':woman_mage_tone2:': '1f9d9-1f3fc-200d-2640-fe0f',
    ':woman_mage_tone3:': '1f9d9-1f3fd-200d-2640-fe0f',
    ':woman_mage_tone4:': '1f9d9-1f3fe-200d-2640-fe0f',
    ':woman_mage_tone5:': '1f9d9-1f3ff-200d-2640-fe0f',
    ':woman_mountain_biking_tone1:': '1f6b5-1f3fb-200d-2640-fe0f',
    ':woman_mountain_biking_tone2:': '1f6b5-1f3fc-200d-2640-fe0f',
    ':woman_mountain_biking_tone3:': '1f6b5-1f3fd-200d-2640-fe0f',
    ':woman_mountain_biking_tone4:': '1f6b5-1f3fe-200d-2640-fe0f',
    ':woman_mountain_biking_tone5:': '1f6b5-1f3ff-200d-2640-fe0f',
    ':woman_pilot_tone1:': '1f469-1f3fb-200d-2708-fe0f',
    ':woman_pilot_tone2:': '1f469-1f3fc-200d-2708-fe0f',
    ':woman_pilot_tone3:': '1f469-1f3fd-200d-2708-fe0f',
    ':woman_pilot_tone4:': '1f469-1f3fe-200d-2708-fe0f',
    ':woman_pilot_tone5:': '1f469-1f3ff-200d-2708-fe0f',
    ':woman_playing_handball_tone1:': '1f93e-1f3fb-200d-2640-fe0f',
    ':woman_playing_handball_tone2:': '1f93e-1f3fc-200d-2640-fe0f',
    ':woman_playing_handball_tone3:': '1f93e-1f3fd-200d-2640-fe0f',
    ':woman_playing_handball_tone4:': '1f93e-1f3fe-200d-2640-fe0f',
    ':woman_playing_handball_tone5:': '1f93e-1f3ff-200d-2640-fe0f',
    ':woman_playing_water_polo_tone1:': '1f93d-1f3fb-200d-2640-fe0f',
    ':woman_playing_water_polo_tone2:': '1f93d-1f3fc-200d-2640-fe0f',
    ':woman_playing_water_polo_tone3:': '1f93d-1f3fd-200d-2640-fe0f',
    ':woman_playing_water_polo_tone4:': '1f93d-1f3fe-200d-2640-fe0f',
    ':woman_playing_water_polo_tone5:': '1f93d-1f3ff-200d-2640-fe0f',
    ':woman_police_officer_tone1:': '1f46e-1f3fb-200d-2640-fe0f',
    ':woman_police_officer_tone2:': '1f46e-1f3fc-200d-2640-fe0f',
    ':woman_police_officer_tone3:': '1f46e-1f3fd-200d-2640-fe0f',
    ':woman_police_officer_tone4:': '1f46e-1f3fe-200d-2640-fe0f',
    ':woman_police_officer_tone5:': '1f46e-1f3ff-200d-2640-fe0f',
    ':woman_pouting_tone1:': '1f64e-1f3fb-200d-2640-fe0f',
    ':woman_pouting_tone2:': '1f64e-1f3fc-200d-2640-fe0f',
    ':woman_pouting_tone3:': '1f64e-1f3fd-200d-2640-fe0f',
    ':woman_pouting_tone4:': '1f64e-1f3fe-200d-2640-fe0f',
    ':woman_pouting_tone5:': '1f64e-1f3ff-200d-2640-fe0f',
    ':woman_raising_hand_tone1:': '1f64b-1f3fb-200d-2640-fe0f',
    ':woman_raising_hand_tone2:': '1f64b-1f3fc-200d-2640-fe0f',
    ':woman_raising_hand_tone3:': '1f64b-1f3fd-200d-2640-fe0f',
    ':woman_raising_hand_tone4:': '1f64b-1f3fe-200d-2640-fe0f',
    ':woman_raising_hand_tone5:': '1f64b-1f3ff-200d-2640-fe0f',
    ':woman_rowing_boat_tone1:': '1f6a3-1f3fb-200d-2640-fe0f',
    ':woman_rowing_boat_tone2:': '1f6a3-1f3fc-200d-2640-fe0f',
    ':woman_rowing_boat_tone3:': '1f6a3-1f3fd-200d-2640-fe0f',
    ':woman_rowing_boat_tone4:': '1f6a3-1f3fe-200d-2640-fe0f',
    ':woman_rowing_boat_tone5:': '1f6a3-1f3ff-200d-2640-fe0f',
    ':woman_running_tone1:': '1f3c3-1f3fb-200d-2640-fe0f',
    ':woman_running_tone2:': '1f3c3-1f3fc-200d-2640-fe0f',
    ':woman_running_tone3:': '1f3c3-1f3fd-200d-2640-fe0f',
    ':woman_running_tone4:': '1f3c3-1f3fe-200d-2640-fe0f',
    ':woman_running_tone5:': '1f3c3-1f3ff-200d-2640-fe0f',
    ':woman_shrugging_tone1:': '1f937-1f3fb-200d-2640-fe0f',
    ':woman_shrugging_tone2:': '1f937-1f3fc-200d-2640-fe0f',
    ':woman_shrugging_tone3:': '1f937-1f3fd-200d-2640-fe0f',
    ':woman_shrugging_tone4:': '1f937-1f3fe-200d-2640-fe0f',
    ':woman_shrugging_tone5:': '1f937-1f3ff-200d-2640-fe0f',
    ':woman_standing_tone1:': '1f9cd-1f3fb-200d-2640-fe0f',
    ':woman_standing_tone2:': '1f9cd-1f3fc-200d-2640-fe0f',
    ':woman_standing_tone3:': '1f9cd-1f3fd-200d-2640-fe0f',
    ':woman_standing_tone4:': '1f9cd-1f3fe-200d-2640-fe0f',
    ':woman_standing_tone5:': '1f9cd-1f3ff-200d-2640-fe0f',
    ':woman_superhero_tone1:': '1f9b8-1f3fb-200d-2640-fe0f',
    ':woman_superhero_tone2:': '1f9b8-1f3fc-200d-2640-fe0f',
    ':woman_superhero_tone3:': '1f9b8-1f3fd-200d-2640-fe0f',
    ':woman_superhero_tone4:': '1f9b8-1f3fe-200d-2640-fe0f',
    ':woman_superhero_tone5:': '1f9b8-1f3ff-200d-2640-fe0f',
    ':woman_supervillain_tone1:': '1f9b9-1f3fb-200d-2640-fe0f',
    ':woman_supervillain_tone2:': '1f9b9-1f3fc-200d-2640-fe0f',
    ':woman_supervillain_tone3:': '1f9b9-1f3fd-200d-2640-fe0f',
    ':woman_supervillain_tone4:': '1f9b9-1f3fe-200d-2640-fe0f',
    ':woman_supervillain_tone5:': '1f9b9-1f3ff-200d-2640-fe0f',
    ':woman_surfing_tone1:': '1f3c4-1f3fb-200d-2640-fe0f',
    ':woman_surfing_tone2:': '1f3c4-1f3fc-200d-2640-fe0f',
    ':woman_surfing_tone3:': '1f3c4-1f3fd-200d-2640-fe0f',
    ':woman_surfing_tone4:': '1f3c4-1f3fe-200d-2640-fe0f',
    ':woman_surfing_tone5:': '1f3c4-1f3ff-200d-2640-fe0f',
    ':woman_swimming_tone1:': '1f3ca-1f3fb-200d-2640-fe0f',
    ':woman_swimming_tone2:': '1f3ca-1f3fc-200d-2640-fe0f',
    ':woman_swimming_tone3:': '1f3ca-1f3fd-200d-2640-fe0f',
    ':woman_swimming_tone4:': '1f3ca-1f3fe-200d-2640-fe0f',
    ':woman_swimming_tone5:': '1f3ca-1f3ff-200d-2640-fe0f',
    ':woman_tipping_hand_tone1:': '1f481-1f3fb-200d-2640-fe0f',
    ':woman_tipping_hand_tone2:': '1f481-1f3fc-200d-2640-fe0f',
    ':woman_tipping_hand_tone3:': '1f481-1f3fd-200d-2640-fe0f',
    ':woman_tipping_hand_tone4:': '1f481-1f3fe-200d-2640-fe0f',
    ':woman_tipping_hand_tone5:': '1f481-1f3ff-200d-2640-fe0f',
    ':woman_tone1_beard:': '1f9d4-1f3fb-200d-2640-fe0f',
    ':woman_tone2_beard:': '1f9d4-1f3fc-200d-2640-fe0f',
    ':woman_tone3_beard:': '1f9d4-1f3fd-200d-2640-fe0f',
    ':woman_tone4_beard:': '1f9d4-1f3fe-200d-2640-fe0f',
    ':woman_tone5_beard:': '1f9d4-1f3ff-200d-2640-fe0f',
    ':woman_vampire_tone1:': '1f9db-1f3fb-200d-2640-fe0f',
    ':woman_vampire_tone2:': '1f9db-1f3fc-200d-2640-fe0f',
    ':woman_vampire_tone3:': '1f9db-1f3fd-200d-2640-fe0f',
    ':woman_vampire_tone4:': '1f9db-1f3fe-200d-2640-fe0f',
    ':woman_vampire_tone5:': '1f9db-1f3ff-200d-2640-fe0f',
    ':woman_walking_tone1:': '1f6b6-1f3fb-200d-2640-fe0f',
    ':woman_walking_tone2:': '1f6b6-1f3fc-200d-2640-fe0f',
    ':woman_walking_tone3:': '1f6b6-1f3fd-200d-2640-fe0f',
    ':woman_walking_tone4:': '1f6b6-1f3fe-200d-2640-fe0f',
    ':woman_walking_tone5:': '1f6b6-1f3ff-200d-2640-fe0f',
    ':woman_wearing_turban_tone1:': '1f473-1f3fb-200d-2640-fe0f',
    ':woman_wearing_turban_tone2:': '1f473-1f3fc-200d-2640-fe0f',
    ':woman_wearing_turban_tone3:': '1f473-1f3fd-200d-2640-fe0f',
    ':woman_wearing_turban_tone4:': '1f473-1f3fe-200d-2640-fe0f',
    ':woman_wearing_turban_tone5:': '1f473-1f3ff-200d-2640-fe0f',
    ':woman_with_veil_tone1:': '1f470-1f3fb-200d-2640-fe0f',
    ':woman_with_veil_tone2:': '1f470-1f3fc-200d-2640-fe0f',
    ':woman_with_veil_tone3:': '1f470-1f3fd-200d-2640-fe0f',
    ':woman_with_veil_tone4:': '1f470-1f3fe-200d-2640-fe0f',
    ':woman_with_veil_tone5:': '1f470-1f3ff-200d-2640-fe0f',
    ':man_bouncing_ball_tone1:': '26f9-1f3fb-200d-2642-fe0f',
    ':man_bouncing_ball_tone2:': '26f9-1f3fc-200d-2642-fe0f',
    ':man_bouncing_ball_tone3:': '26f9-1f3fd-200d-2642-fe0f',
    ':man_bouncing_ball_tone4:': '26f9-1f3fe-200d-2642-fe0f',
    ':man_bouncing_ball_tone5:': '26f9-1f3ff-200d-2642-fe0f',
    ':woman_bouncing_ball_tone1:': '26f9-1f3fb-200d-2640-fe0f',
    ':woman_bouncing_ball_tone2:': '26f9-1f3fc-200d-2640-fe0f',
    ':woman_bouncing_ball_tone3:': '26f9-1f3fd-200d-2640-fe0f',
    ':woman_bouncing_ball_tone4:': '26f9-1f3fe-200d-2640-fe0f',
    ':woman_bouncing_ball_tone5:': '26f9-1f3ff-200d-2640-fe0f',
    ':adult_tone1:': '1f9d1-1f3fb',
    ':adult_tone2:': '1f9d1-1f3fc',
    ':adult_tone3:': '1f9d1-1f3fd',
    ':adult_tone4:': '1f9d1-1f3fe',
    ':adult_tone5:': '1f9d1-1f3ff',
    ':angel_tone1:': '1f47c-1f3fb',
    ':angel_tone2:': '1f47c-1f3fc',
    ':angel_tone3:': '1f47c-1f3fd',
    ':angel_tone4:': '1f47c-1f3fe',
    ':angel_tone5:': '1f47c-1f3ff',
    ':artist:': '1f9d1-200d-1f3a8',
    ':astronaut:': '1f9d1-200d-1f680',
    ':baby_tone1:': '1f476-1f3fb',
    ':baby_tone2:': '1f476-1f3fc',
    ':baby_tone3:': '1f476-1f3fd',
    ':baby_tone4:': '1f476-1f3fe',
    ':baby_tone5:': '1f476-1f3ff',
    ':bath_tone1:': '1f6c0-1f3fb',
    ':bath_tone2:': '1f6c0-1f3fc',
    ':bath_tone3:': '1f6c0-1f3fd',
    ':bath_tone4:': '1f6c0-1f3fe',
    ':bath_tone5:': '1f6c0-1f3ff',
    ':bearded_person_tone1:': '1f9d4-1f3fb',
    ':bearded_person_tone2:': '1f9d4-1f3fc',
    ':bearded_person_tone3:': '1f9d4-1f3fd',
    ':bearded_person_tone4:': '1f9d4-1f3fe',
    ':bearded_person_tone5:': '1f9d4-1f3ff',
    ':blond_haired_person_tone1:': '1f471-1f3fb',
    ':blond_haired_person_tone2:': '1f471-1f3fc',
    ':blond_haired_person_tone3:': '1f471-1f3fd',
    ':blond_haired_person_tone4:': '1f471-1f3fe',
    ':blond_haired_person_tone5:': '1f471-1f3ff',
    ':boy_tone1:': '1f466-1f3fb',
    ':boy_tone2:': '1f466-1f3fc',
    ':boy_tone3:': '1f466-1f3fd',
    ':boy_tone4:': '1f466-1f3fe',
    ':boy_tone5:': '1f466-1f3ff',
    ':breast_feeding_tone1:': '1f931-1f3fb',
    ':breast_feeding_tone2:': '1f931-1f3fc',
    ':breast_feeding_tone3:': '1f931-1f3fd',
    ':breast_feeding_tone4:': '1f931-1f3fe',
    ':breast_feeding_tone5:': '1f931-1f3ff',
    ':call_me_tone1:': '1f919-1f3fb',
    ':call_me_tone2:': '1f919-1f3fc',
    ':call_me_tone3:': '1f919-1f3fd',
    ':call_me_tone4:': '1f919-1f3fe',
    ':call_me_tone5:': '1f919-1f3ff',
    ':child_tone1:': '1f9d2-1f3fb',
    ':child_tone2:': '1f9d2-1f3fc',
    ':child_tone3:': '1f9d2-1f3fd',
    ':child_tone4:': '1f9d2-1f3fe',
    ':child_tone5:': '1f9d2-1f3ff',
    ':clap_tone1:': '1f44f-1f3fb',
    ':clap_tone2:': '1f44f-1f3fc',
    ':clap_tone3:': '1f44f-1f3fd',
    ':clap_tone4:': '1f44f-1f3fe',
    ':clap_tone5:': '1f44f-1f3ff',
    ':construction_worker_tone1:': '1f477-1f3fb',
    ':construction_worker_tone2:': '1f477-1f3fc',
    ':construction_worker_tone3:': '1f477-1f3fd',
    ':construction_worker_tone4:': '1f477-1f3fe',
    ':construction_worker_tone5:': '1f477-1f3ff',
    ':cook:': '1f9d1-200d-1f373',
    ':couple_with_heart_tone1:': '1f491-1f3fb',
    ':couple_with_heart_tone2:': '1f491-1f3fc',
    ':couple_with_heart_tone3:': '1f491-1f3fd',
    ':couple_with_heart_tone4:': '1f491-1f3fe',
    ':couple_with_heart_tone5:': '1f491-1f3ff',
    ':dancer_tone1:': '1f483-1f3fb',
    ':dancer_tone2:': '1f483-1f3fc',
    ':dancer_tone3:': '1f483-1f3fd',
    ':dancer_tone4:': '1f483-1f3fe',
    ':dancer_tone5:': '1f483-1f3ff',
    ':deaf_person_tone1:': '1f9cf-1f3fb',
    ':deaf_person_tone2:': '1f9cf-1f3fc',
    ':deaf_person_tone3:': '1f9cf-1f3fd',
    ':deaf_person_tone4:': '1f9cf-1f3fe',
    ':deaf_person_tone5:': '1f9cf-1f3ff',
    ':detective_tone1:': '1f575-1f3fb',
    ':detective_tone2:': '1f575-1f3fc',
    ':detective_tone3:': '1f575-1f3fd',
    ':detective_tone4:': '1f575-1f3fe',
    ':detective_tone5:': '1f575-1f3ff',
    ':ear_tone1:': '1f442-1f3fb',
    ':ear_tone2:': '1f442-1f3fc',
    ':ear_tone3:': '1f442-1f3fd',
    ':ear_tone4:': '1f442-1f3fe',
    ':ear_tone5:': '1f442-1f3ff',
    ':ear_with_hearing_aid_tone1:': '1f9bb-1f3fb',
    ':ear_with_hearing_aid_tone2:': '1f9bb-1f3fc',
    ':ear_with_hearing_aid_tone3:': '1f9bb-1f3fd',
    ':ear_with_hearing_aid_tone4:': '1f9bb-1f3fe',
    ':ear_with_hearing_aid_tone5:': '1f9bb-1f3ff',
    ':elf_tone1:': '1f9dd-1f3fb',
    ':elf_tone2:': '1f9dd-1f3fc',
    ':elf_tone3:': '1f9dd-1f3fd',
    ':elf_tone4:': '1f9dd-1f3fe',
    ':elf_tone5:': '1f9dd-1f3ff',
    ':eye_in_speech_bubble:': '1f441-fe0f-200d-1f5e8-fe0f',
    ':face_exhaling:': '1f62e-200d-1f4a8',
    ':face_in_clouds:': '1f636-200d-1f32b-fe0f',
    ':face_with_spiral_eyes:': '1f635-200d-1f4ab',
    ':factory_worker:': '1f9d1-200d-1f3ed',
    ':fairy_tone1:': '1f9da-1f3fb',
    ':fairy_tone2:': '1f9da-1f3fc',
    ':fairy_tone3:': '1f9da-1f3fd',
    ':fairy_tone4:': '1f9da-1f3fe',
    ':fairy_tone5:': '1f9da-1f3ff',
    ':family_man_boy:': '1f468-200d-1f466',
    ':family_man_girl:': '1f468-200d-1f467',
    ':family_woman_boy:': '1f469-200d-1f466',
    ':family_woman_girl:': '1f469-200d-1f467',
    ':farmer:': '1f9d1-200d-1f33e',
    ':fingers_crossed_tone1:': '1f91e-1f3fb',
    ':fingers_crossed_tone2:': '1f91e-1f3fc',
    ':fingers_crossed_tone3:': '1f91e-1f3fd',
    ':fingers_crossed_tone4:': '1f91e-1f3fe',
    ':fingers_crossed_tone5:': '1f91e-1f3ff',
    ':firefighter:': '1f9d1-200d-1f692',
    ':flag_ac:': '1f1e6-1f1e8',
    ':flag_ad:': '1f1e6-1f1e9',
    ':flag_ae:': '1f1e6-1f1ea',
    ':flag_af:': '1f1e6-1f1eb',
    ':flag_ag:': '1f1e6-1f1ec',
    ':flag_ai:': '1f1e6-1f1ee',
    ':flag_al:': '1f1e6-1f1f1',
    ':flag_am:': '1f1e6-1f1f2',
    ':flag_ao:': '1f1e6-1f1f4',
    ':flag_aq:': '1f1e6-1f1f6',
    ':flag_ar:': '1f1e6-1f1f7',
    ':flag_as:': '1f1e6-1f1f8',
    ':flag_at:': '1f1e6-1f1f9',
    ':flag_au:': '1f1e6-1f1fa',
    ':flag_aw:': '1f1e6-1f1fc',
    ':flag_ax:': '1f1e6-1f1fd',
    ':flag_az:': '1f1e6-1f1ff',
    ':flag_ba:': '1f1e7-1f1e6',
    ':flag_bb:': '1f1e7-1f1e7',
    ':flag_bd:': '1f1e7-1f1e9',
    ':flag_be:': '1f1e7-1f1ea',
    ':flag_bf:': '1f1e7-1f1eb',
    ':flag_bg:': '1f1e7-1f1ec',
    ':flag_bh:': '1f1e7-1f1ed',
    ':flag_bi:': '1f1e7-1f1ee',
    ':flag_bj:': '1f1e7-1f1ef',
    ':flag_bl:': '1f1e7-1f1f1',
    ':flag_bm:': '1f1e7-1f1f2',
    ':flag_bn:': '1f1e7-1f1f3',
    ':flag_bo:': '1f1e7-1f1f4',
    ':flag_bq:': '1f1e7-1f1f6',
    ':flag_br:': '1f1e7-1f1f7',
    ':flag_bs:': '1f1e7-1f1f8',
    ':flag_bt:': '1f1e7-1f1f9',
    ':flag_bv:': '1f1e7-1f1fb',
    ':flag_bw:': '1f1e7-1f1fc',
    ':flag_by:': '1f1e7-1f1fe',
    ':flag_bz:': '1f1e7-1f1ff',
    ':flag_ca:': '1f1e8-1f1e6',
    ':flag_cc:': '1f1e8-1f1e8',
    ':flag_cd:': '1f1e8-1f1e9',
    ':flag_cf:': '1f1e8-1f1eb',
    ':flag_cg:': '1f1e8-1f1ec',
    ':flag_ch:': '1f1e8-1f1ed',
    ':flag_ci:': '1f1e8-1f1ee',
    ':flag_ck:': '1f1e8-1f1f0',
    ':flag_cl:': '1f1e8-1f1f1',
    ':flag_cm:': '1f1e8-1f1f2',
    ':flag_cn:': '1f1e8-1f1f3',
    ':flag_co:': '1f1e8-1f1f4',
    ':flag_cp:': '1f1e8-1f1f5',
    ':flag_cr:': '1f1e8-1f1f7',
    ':flag_cu:': '1f1e8-1f1fa',
    ':flag_cv:': '1f1e8-1f1fb',
    ':flag_cw:': '1f1e8-1f1fc',
    ':flag_cx:': '1f1e8-1f1fd',
    ':flag_cy:': '1f1e8-1f1fe',
    ':flag_cz:': '1f1e8-1f1ff',
    ':flag_de:': '1f1e9-1f1ea',
    ':flag_dg:': '1f1e9-1f1ec',
    ':flag_dj:': '1f1e9-1f1ef',
    ':flag_dk:': '1f1e9-1f1f0',
    ':flag_dm:': '1f1e9-1f1f2',
    ':flag_do:': '1f1e9-1f1f4',
    ':flag_dz:': '1f1e9-1f1ff',
    ':flag_ea:': '1f1ea-1f1e6',
    ':flag_ec:': '1f1ea-1f1e8',
    ':flag_ee:': '1f1ea-1f1ea',
    ':flag_eg:': '1f1ea-1f1ec',
    ':flag_eh:': '1f1ea-1f1ed',
    ':flag_er:': '1f1ea-1f1f7',
    ':flag_es:': '1f1ea-1f1f8',
    ':flag_et:': '1f1ea-1f1f9',
    ':flag_eu:': '1f1ea-1f1fa',
    ':flag_fi:': '1f1eb-1f1ee',
    ':flag_fj:': '1f1eb-1f1ef',
    ':flag_fk:': '1f1eb-1f1f0',
    ':flag_fm:': '1f1eb-1f1f2',
    ':flag_fo:': '1f1eb-1f1f4',
    ':flag_fr:': '1f1eb-1f1f7',
    ':flag_ga:': '1f1ec-1f1e6',
    ':flag_gb:': '1f1ec-1f1e7',
    ':flag_gd:': '1f1ec-1f1e9',
    ':flag_ge:': '1f1ec-1f1ea',
    ':flag_gf:': '1f1ec-1f1eb',
    ':flag_gg:': '1f1ec-1f1ec',
    ':flag_gh:': '1f1ec-1f1ed',
    ':flag_gi:': '1f1ec-1f1ee',
    ':flag_gl:': '1f1ec-1f1f1',
    ':flag_gm:': '1f1ec-1f1f2',
    ':flag_gn:': '1f1ec-1f1f3',
    ':flag_gp:': '1f1ec-1f1f5',
    ':flag_gq:': '1f1ec-1f1f6',
    ':flag_gr:': '1f1ec-1f1f7',
    ':flag_gs:': '1f1ec-1f1f8',
    ':flag_gt:': '1f1ec-1f1f9',
    ':flag_gu:': '1f1ec-1f1fa',
    ':flag_gw:': '1f1ec-1f1fc',
    ':flag_gy:': '1f1ec-1f1fe',
    ':flag_hk:': '1f1ed-1f1f0',
    ':flag_hm:': '1f1ed-1f1f2',
    ':flag_hn:': '1f1ed-1f1f3',
    ':flag_hr:': '1f1ed-1f1f7',
    ':flag_ht:': '1f1ed-1f1f9',
    ':flag_hu:': '1f1ed-1f1fa',
    ':flag_ic:': '1f1ee-1f1e8',
    ':flag_id:': '1f1ee-1f1e9',
    ':flag_ie:': '1f1ee-1f1ea',
    ':flag_il:': '1f1ee-1f1f1',
    ':flag_im:': '1f1ee-1f1f2',
    ':flag_in:': '1f1ee-1f1f3',
    ':flag_io:': '1f1ee-1f1f4',
    ':flag_iq:': '1f1ee-1f1f6',
    ':flag_ir:': '1f1ee-1f1f7',
    ':flag_is:': '1f1ee-1f1f8',
    ':flag_it:': '1f1ee-1f1f9',
    ':flag_je:': '1f1ef-1f1ea',
    ':flag_jm:': '1f1ef-1f1f2',
    ':flag_jo:': '1f1ef-1f1f4',
    ':flag_jp:': '1f1ef-1f1f5',
    ':flag_ke:': '1f1f0-1f1ea',
    ':flag_kg:': '1f1f0-1f1ec',
    ':flag_kh:': '1f1f0-1f1ed',
    ':flag_ki:': '1f1f0-1f1ee',
    ':flag_km:': '1f1f0-1f1f2',
    ':flag_kn:': '1f1f0-1f1f3',
    ':flag_kp:': '1f1f0-1f1f5',
    ':flag_kr:': '1f1f0-1f1f7',
    ':flag_kw:': '1f1f0-1f1fc',
    ':flag_ky:': '1f1f0-1f1fe',
    ':flag_kz:': '1f1f0-1f1ff',
    ':flag_la:': '1f1f1-1f1e6',
    ':flag_lb:': '1f1f1-1f1e7',
    ':flag_lc:': '1f1f1-1f1e8',
    ':flag_li:': '1f1f1-1f1ee',
    ':flag_lk:': '1f1f1-1f1f0',
    ':flag_lr:': '1f1f1-1f1f7',
    ':flag_ls:': '1f1f1-1f1f8',
    ':flag_lt:': '1f1f1-1f1f9',
    ':flag_lu:': '1f1f1-1f1fa',
    ':flag_lv:': '1f1f1-1f1fb',
    ':flag_ly:': '1f1f1-1f1fe',
    ':flag_ma:': '1f1f2-1f1e6',
    ':flag_mc:': '1f1f2-1f1e8',
    ':flag_md:': '1f1f2-1f1e9',
    ':flag_me:': '1f1f2-1f1ea',
    ':flag_mf:': '1f1f2-1f1eb',
    ':flag_mg:': '1f1f2-1f1ec',
    ':flag_mh:': '1f1f2-1f1ed',
    ':flag_mk:': '1f1f2-1f1f0',
    ':flag_ml:': '1f1f2-1f1f1',
    ':flag_mm:': '1f1f2-1f1f2',
    ':flag_mn:': '1f1f2-1f1f3',
    ':flag_mo:': '1f1f2-1f1f4',
    ':flag_mp:': '1f1f2-1f1f5',
    ':flag_mq:': '1f1f2-1f1f6',
    ':flag_mr:': '1f1f2-1f1f7',
    ':flag_ms:': '1f1f2-1f1f8',
    ':flag_mt:': '1f1f2-1f1f9',
    ':flag_mu:': '1f1f2-1f1fa',
    ':flag_mv:': '1f1f2-1f1fb',
    ':flag_mw:': '1f1f2-1f1fc',
    ':flag_mx:': '1f1f2-1f1fd',
    ':flag_my:': '1f1f2-1f1fe',
    ':flag_mz:': '1f1f2-1f1ff',
    ':flag_na:': '1f1f3-1f1e6',
    ':flag_nc:': '1f1f3-1f1e8',
    ':flag_ne:': '1f1f3-1f1ea',
    ':flag_nf:': '1f1f3-1f1eb',
    ':flag_ng:': '1f1f3-1f1ec',
    ':flag_ni:': '1f1f3-1f1ee',
    ':flag_nl:': '1f1f3-1f1f1',
    ':flag_no:': '1f1f3-1f1f4',
    ':flag_np:': '1f1f3-1f1f5',
    ':flag_nr:': '1f1f3-1f1f7',
    ':flag_nu:': '1f1f3-1f1fa',
    ':flag_nz:': '1f1f3-1f1ff',
    ':flag_om:': '1f1f4-1f1f2',
    ':flag_pa:': '1f1f5-1f1e6',
    ':flag_pe:': '1f1f5-1f1ea',
    ':flag_pf:': '1f1f5-1f1eb',
    ':flag_pg:': '1f1f5-1f1ec',
    ':flag_ph:': '1f1f5-1f1ed',
    ':flag_pk:': '1f1f5-1f1f0',
    ':flag_pl:': '1f1f5-1f1f1',
    ':flag_pm:': '1f1f5-1f1f2',
    ':flag_pn:': '1f1f5-1f1f3',
    ':flag_pr:': '1f1f5-1f1f7',
    ':flag_ps:': '1f1f5-1f1f8',
    ':flag_pt:': '1f1f5-1f1f9',
    ':flag_pw:': '1f1f5-1f1fc',
    ':flag_py:': '1f1f5-1f1fe',
    ':flag_qa:': '1f1f6-1f1e6',
    ':flag_re:': '1f1f7-1f1ea',
    ':flag_ro:': '1f1f7-1f1f4',
    ':flag_rs:': '1f1f7-1f1f8',
    ':flag_ru:': '1f1f7-1f1fa',
    ':flag_rw:': '1f1f7-1f1fc',
    ':flag_sa:': '1f1f8-1f1e6',
    ':flag_sb:': '1f1f8-1f1e7',
    ':flag_sc:': '1f1f8-1f1e8',
    ':flag_sd:': '1f1f8-1f1e9',
    ':flag_se:': '1f1f8-1f1ea',
    ':flag_sg:': '1f1f8-1f1ec',
    ':flag_sh:': '1f1f8-1f1ed',
    ':flag_si:': '1f1f8-1f1ee',
    ':flag_sj:': '1f1f8-1f1ef',
    ':flag_sk:': '1f1f8-1f1f0',
    ':flag_sl:': '1f1f8-1f1f1',
    ':flag_sm:': '1f1f8-1f1f2',
    ':flag_sn:': '1f1f8-1f1f3',
    ':flag_so:': '1f1f8-1f1f4',
    ':flag_sr:': '1f1f8-1f1f7',
    ':flag_ss:': '1f1f8-1f1f8',
    ':flag_st:': '1f1f8-1f1f9',
    ':flag_sv:': '1f1f8-1f1fb',
    ':flag_sx:': '1f1f8-1f1fd',
    ':flag_sy:': '1f1f8-1f1fe',
    ':flag_sz:': '1f1f8-1f1ff',
    ':flag_ta:': '1f1f9-1f1e6',
    ':flag_tc:': '1f1f9-1f1e8',
    ':flag_td:': '1f1f9-1f1e9',
    ':flag_tf:': '1f1f9-1f1eb',
    ':flag_tg:': '1f1f9-1f1ec',
    ':flag_th:': '1f1f9-1f1ed',
    ':flag_tj:': '1f1f9-1f1ef',
    ':flag_tk:': '1f1f9-1f1f0',
    ':flag_tl:': '1f1f9-1f1f1',
    ':flag_tm:': '1f1f9-1f1f2',
    ':flag_tn:': '1f1f9-1f1f3',
    ':flag_to:': '1f1f9-1f1f4',
    ':flag_tr:': '1f1f9-1f1f7',
    ':flag_tt:': '1f1f9-1f1f9',
    ':flag_tv:': '1f1f9-1f1fb',
    ':flag_tw:': '1f1f9-1f1fc',
    ':flag_tz:': '1f1f9-1f1ff',
    ':flag_ua:': '1f1fa-1f1e6',
    ':flag_ug:': '1f1fa-1f1ec',
    ':flag_um:': '1f1fa-1f1f2',
    ':flag_us:': '1f1fa-1f1f8',
    ':flag_uy:': '1f1fa-1f1fe',
    ':flag_uz:': '1f1fa-1f1ff',
    ':flag_va:': '1f1fb-1f1e6',
    ':flag_vc:': '1f1fb-1f1e8',
    ':flag_ve:': '1f1fb-1f1ea',
    ':flag_vg:': '1f1fb-1f1ec',
    ':flag_vi:': '1f1fb-1f1ee',
    ':flag_vn:': '1f1fb-1f1f3',
    ':flag_vu:': '1f1fb-1f1fa',
    ':flag_wf:': '1f1fc-1f1eb',
    ':flag_ws:': '1f1fc-1f1f8',
    ':flag_xk:': '1f1fd-1f1f0',
    ':flag_ye:': '1f1fe-1f1ea',
    ':flag_yt:': '1f1fe-1f1f9',
    ':flag_za:': '1f1ff-1f1e6',
    ':flag_zm:': '1f1ff-1f1f2',
    ':flag_zw:': '1f1ff-1f1fc',
    ':foot_tone1:': '1f9b6-1f3fb',
    ':foot_tone2:': '1f9b6-1f3fc',
    ':foot_tone3:': '1f9b6-1f3fd',
    ':foot_tone4:': '1f9b6-1f3fe',
    ':foot_tone5:': '1f9b6-1f3ff',
    ':girl_tone1:': '1f467-1f3fb',
    ':girl_tone2:': '1f467-1f3fc',
    ':girl_tone3:': '1f467-1f3fd',
    ':girl_tone4:': '1f467-1f3fe',
    ':girl_tone5:': '1f467-1f3ff',
    ':guard_tone1:': '1f482-1f3fb',
    ':guard_tone2:': '1f482-1f3fc',
    ':guard_tone3:': '1f482-1f3fd',
    ':guard_tone4:': '1f482-1f3fe',
    ':guard_tone5:': '1f482-1f3ff',
    ':hand_splayed_tone1:': '1f590-1f3fb',
    ':hand_splayed_tone2:': '1f590-1f3fc',
    ':hand_splayed_tone3:': '1f590-1f3fd',
    ':hand_splayed_tone4:': '1f590-1f3fe',
    ':hand_splayed_tone5:': '1f590-1f3ff',
    ':hand_with_index_finger_and_thumb_crossed_tone1:': '1faf0-1f3fb',
    ':hand_with_index_finger_and_thumb_crossed_tone2:': '1faf0-1f3fc',
    ':hand_with_index_finger_and_thumb_crossed_tone3:': '1faf0-1f3fd',
    ':hand_with_index_finger_and_thumb_crossed_tone4:': '1faf0-1f3fe',
    ':hand_with_index_finger_and_thumb_crossed_tone5:': '1faf0-1f3ff',
    ':handshake_tone1:': '1f91d-1f3fb',
    ':handshake_tone2:': '1f91d-1f3fc',
    ':handshake_tone3:': '1f91d-1f3fd',
    ':handshake_tone4:': '1f91d-1f3fe',
    ':handshake_tone5:': '1f91d-1f3ff',
    ':heart_hands_tone1:': '1faf6-1f3fb',
    ':heart_hands_tone2:': '1faf6-1f3fc',
    ':heart_hands_tone3:': '1faf6-1f3fd',
    ':heart_hands_tone4:': '1faf6-1f3fe',
    ':heart_hands_tone5:': '1faf6-1f3ff',
    ':horse_racing_tone1:': '1f3c7-1f3fb',
    ':horse_racing_tone2:': '1f3c7-1f3fc',
    ':horse_racing_tone3:': '1f3c7-1f3fd',
    ':horse_racing_tone4:': '1f3c7-1f3fe',
    ':horse_racing_tone5:': '1f3c7-1f3ff',
    ':index_pointing_at_the_viewer_tone1:': '1faf5-1f3fb',
    ':index_pointing_at_the_viewer_tone2:': '1faf5-1f3fc',
    ':index_pointing_at_the_viewer_tone3:': '1faf5-1f3fd',
    ':index_pointing_at_the_viewer_tone4:': '1faf5-1f3fe',
    ':index_pointing_at_the_viewer_tone5:': '1faf5-1f3ff',
    ':kiss_tone1:': '1f48f-1f3fb',
    ':kiss_tone2:': '1f48f-1f3fc',
    ':kiss_tone3:': '1f48f-1f3fd',
    ':kiss_tone4:': '1f48f-1f3fe',
    ':kiss_tone5:': '1f48f-1f3ff',
    ':left_facing_fist_tone1:': '1f91b-1f3fb',
    ':left_facing_fist_tone2:': '1f91b-1f3fc',
    ':left_facing_fist_tone3:': '1f91b-1f3fd',
    ':left_facing_fist_tone4:': '1f91b-1f3fe',
    ':left_facing_fist_tone5:': '1f91b-1f3ff',
    ':leftwards_hand_tone1:': '1faf2-1f3fb',
    ':leftwards_hand_tone2:': '1faf2-1f3fc',
    ':leftwards_hand_tone3:': '1faf2-1f3fd',
    ':leftwards_hand_tone4:': '1faf2-1f3fe',
    ':leftwards_hand_tone5:': '1faf2-1f3ff',
    ':leg_tone1:': '1f9b5-1f3fb',
    ':leg_tone2:': '1f9b5-1f3fc',
    ':leg_tone3:': '1f9b5-1f3fd',
    ':leg_tone4:': '1f9b5-1f3fe',
    ':leg_tone5:': '1f9b5-1f3ff',
    ':levitate_tone1:': '1f574-1f3fb',
    ':levitate_tone2:': '1f574-1f3fc',
    ':levitate_tone3:': '1f574-1f3fd',
    ':levitate_tone4:': '1f574-1f3fe',
    ':levitate_tone5:': '1f574-1f3ff',
    ':love_you_gesture_tone1:': '1f91f-1f3fb',
    ':love_you_gesture_tone2:': '1f91f-1f3fc',
    ':love_you_gesture_tone3:': '1f91f-1f3fd',
    ':love_you_gesture_tone4:': '1f91f-1f3fe',
    ':love_you_gesture_tone5:': '1f91f-1f3ff',
    ':mage_tone1:': '1f9d9-1f3fb',
    ':mage_tone2:': '1f9d9-1f3fc',
    ':mage_tone3:': '1f9d9-1f3fd',
    ':mage_tone4:': '1f9d9-1f3fe',
    ':mage_tone5:': '1f9d9-1f3ff',
    ':man_artist:': '1f468-200d-1f3a8',
    ':man_astronaut:': '1f468-200d-1f680',
    ':man_bald:': '1f468-200d-1f9b2',
    ':man_cook:': '1f468-200d-1f373',
    ':man_curly_haired:': '1f468-200d-1f9b1',
    ':man_dancing_tone1:': '1f57a-1f3fb',
    ':man_dancing_tone2:': '1f57a-1f3fc',
    ':man_dancing_tone3:': '1f57a-1f3fd',
    ':man_dancing_tone4:': '1f57a-1f3fe',
    ':man_dancing_tone5:': '1f57a-1f3ff',
    ':man_factory_worker:': '1f468-200d-1f3ed',
    ':man_farmer:': '1f468-200d-1f33e',
    ':man_feeding_baby:': '1f468-200d-1f37c',
    ':man_firefighter:': '1f468-200d-1f692',
    ':man_in_manual_wheelchair:': '1f468-200d-1f9bd',
    ':man_in_motorized_wheelchair:': '1f468-200d-1f9bc',
    ':man_mechanic:': '1f468-200d-1f527',
    ':man_office_worker:': '1f468-200d-1f4bc',
    ':man_red_haired:': '1f468-200d-1f9b0',
    ':man_scientist:': '1f468-200d-1f52c',
    ':man_singer:': '1f468-200d-1f3a4',
    ':man_student:': '1f468-200d-1f393',
    ':man_teacher:': '1f468-200d-1f3eb',
    ':man_technologist:': '1f468-200d-1f4bb',
    ':man_tone1:': '1f468-1f3fb',
    ':man_tone2:': '1f468-1f3fc',
    ':man_tone3:': '1f468-1f3fd',
    ':man_tone4:': '1f468-1f3fe',
    ':man_tone5:': '1f468-1f3ff',
    ':man_white_haired:': '1f468-200d-1f9b3',
    ':man_with_chinese_cap_tone1:': '1f472-1f3fb',
    ':man_with_chinese_cap_tone2:': '1f472-1f3fc',
    ':man_with_chinese_cap_tone3:': '1f472-1f3fd',
    ':man_with_chinese_cap_tone4:': '1f472-1f3fe',
    ':man_with_chinese_cap_tone5:': '1f472-1f3ff',
    ':man_with_probing_cane:': '1f468-200d-1f9af',
    ':mechanic:': '1f9d1-200d-1f527',
    ':men_holding_hands_tone1:': '1f46c-1f3fb',
    ':men_holding_hands_tone2:': '1f46c-1f3fc',
    ':men_holding_hands_tone3:': '1f46c-1f3fd',
    ':men_holding_hands_tone4:': '1f46c-1f3fe',
    ':men_holding_hands_tone5:': '1f46c-1f3ff',
    ':merperson_tone1:': '1f9dc-1f3fb',
    ':merperson_tone2:': '1f9dc-1f3fc',
    ':merperson_tone3:': '1f9dc-1f3fd',
    ':merperson_tone4:': '1f9dc-1f3fe',
    ':merperson_tone5:': '1f9dc-1f3ff',
    ':metal_tone1:': '1f918-1f3fb',
    ':metal_tone2:': '1f918-1f3fc',
    ':metal_tone3:': '1f918-1f3fd',
    ':metal_tone4:': '1f918-1f3fe',
    ':metal_tone5:': '1f918-1f3ff',
    ':middle_finger_tone1:': '1f595-1f3fb',
    ':middle_finger_tone2:': '1f595-1f3fc',
    ':middle_finger_tone3:': '1f595-1f3fd',
    ':middle_finger_tone4:': '1f595-1f3fe',
    ':middle_finger_tone5:': '1f595-1f3ff',
    ':mrs_claus_tone1:': '1f936-1f3fb',
    ':mrs_claus_tone2:': '1f936-1f3fc',
    ':mrs_claus_tone3:': '1f936-1f3fd',
    ':mrs_claus_tone4:': '1f936-1f3fe',
    ':mrs_claus_tone5:': '1f936-1f3ff',
    ':muscle_tone1:': '1f4aa-1f3fb',
    ':muscle_tone2:': '1f4aa-1f3fc',
    ':muscle_tone3:': '1f4aa-1f3fd',
    ':muscle_tone4:': '1f4aa-1f3fe',
    ':muscle_tone5:': '1f4aa-1f3ff',
    ':mx_claus:': '1f9d1-200d-1f384',
    ':nail_care_tone1:': '1f485-1f3fb',
    ':nail_care_tone2:': '1f485-1f3fc',
    ':nail_care_tone3:': '1f485-1f3fd',
    ':nail_care_tone4:': '1f485-1f3fe',
    ':nail_care_tone5:': '1f485-1f3ff',
    ':ninja_tone1:': '1f977-1f3fb',
    ':ninja_tone2:': '1f977-1f3fc',
    ':ninja_tone3:': '1f977-1f3fd',
    ':ninja_tone4:': '1f977-1f3fe',
    ':ninja_tone5:': '1f977-1f3ff',
    ':nose_tone1:': '1f443-1f3fb',
    ':nose_tone2:': '1f443-1f3fc',
    ':nose_tone3:': '1f443-1f3fd',
    ':nose_tone4:': '1f443-1f3fe',
    ':nose_tone5:': '1f443-1f3ff',
    ':office_worker:': '1f9d1-200d-1f4bc',
    ':ok_hand_tone1:': '1f44c-1f3fb',
    ':ok_hand_tone2:': '1f44c-1f3fc',
    ':ok_hand_tone3:': '1f44c-1f3fd',
    ':ok_hand_tone4:': '1f44c-1f3fe',
    ':ok_hand_tone5:': '1f44c-1f3ff',
    ':older_adult_tone1:': '1f9d3-1f3fb',
    ':older_adult_tone2:': '1f9d3-1f3fc',
    ':older_adult_tone3:': '1f9d3-1f3fd',
    ':older_adult_tone4:': '1f9d3-1f3fe',
    ':older_adult_tone5:': '1f9d3-1f3ff',
    ':older_man_tone1:': '1f474-1f3fb',
    ':older_man_tone2:': '1f474-1f3fc',
    ':older_man_tone3:': '1f474-1f3fd',
    ':older_man_tone4:': '1f474-1f3fe',
    ':older_man_tone5:': '1f474-1f3ff',
    ':older_woman_tone1:': '1f475-1f3fb',
    ':older_woman_tone2:': '1f475-1f3fc',
    ':older_woman_tone3:': '1f475-1f3fd',
    ':older_woman_tone4:': '1f475-1f3fe',
    ':older_woman_tone5:': '1f475-1f3ff',
    ':open_hands_tone1:': '1f450-1f3fb',
    ':open_hands_tone2:': '1f450-1f3fc',
    ':open_hands_tone3:': '1f450-1f3fd',
    ':open_hands_tone4:': '1f450-1f3fe',
    ':open_hands_tone5:': '1f450-1f3ff',
    ':palm_down_hand_tone1:': '1faf3-1f3fb',
    ':palm_down_hand_tone2:': '1faf3-1f3fc',
    ':palm_down_hand_tone3:': '1faf3-1f3fd',
    ':palm_down_hand_tone4:': '1faf3-1f3fe',
    ':palm_down_hand_tone5:': '1faf3-1f3ff',
    ':palm_up_hand_tone1:': '1faf4-1f3fb',
    ':palm_up_hand_tone2:': '1faf4-1f3fc',
    ':palm_up_hand_tone3:': '1faf4-1f3fd',
    ':palm_up_hand_tone4:': '1faf4-1f3fe',
    ':palm_up_hand_tone5:': '1faf4-1f3ff',
    ':palms_up_together_tone1:': '1f932-1f3fb',
    ':palms_up_together_tone2:': '1f932-1f3fc',
    ':palms_up_together_tone3:': '1f932-1f3fd',
    ':palms_up_together_tone4:': '1f932-1f3fe',
    ':palms_up_together_tone5:': '1f932-1f3ff',
    ':person_bald:': '1f9d1-200d-1f9b2',
    ':person_biking_tone1:': '1f6b4-1f3fb',
    ':person_biking_tone2:': '1f6b4-1f3fc',
    ':person_biking_tone3:': '1f6b4-1f3fd',
    ':person_biking_tone4:': '1f6b4-1f3fe',
    ':person_biking_tone5:': '1f6b4-1f3ff',
    ':person_bowing_tone1:': '1f647-1f3fb',
    ':person_bowing_tone2:': '1f647-1f3fc',
    ':person_bowing_tone3:': '1f647-1f3fd',
    ':person_bowing_tone4:': '1f647-1f3fe',
    ':person_bowing_tone5:': '1f647-1f3ff',
    ':person_climbing_tone1:': '1f9d7-1f3fb',
    ':person_climbing_tone2:': '1f9d7-1f3fc',
    ':person_climbing_tone3:': '1f9d7-1f3fd',
    ':person_climbing_tone4:': '1f9d7-1f3fe',
    ':person_climbing_tone5:': '1f9d7-1f3ff',
    ':person_curly_hair:': '1f9d1-200d-1f9b1',
    ':person_doing_cartwheel_tone1:': '1f938-1f3fb',
    ':person_doing_cartwheel_tone2:': '1f938-1f3fc',
    ':person_doing_cartwheel_tone3:': '1f938-1f3fd',
    ':person_doing_cartwheel_tone4:': '1f938-1f3fe',
    ':person_doing_cartwheel_tone5:': '1f938-1f3ff',
    ':person_facepalming_tone1:': '1f926-1f3fb',
    ':person_facepalming_tone2:': '1f926-1f3fc',
    ':person_facepalming_tone3:': '1f926-1f3fd',
    ':person_facepalming_tone4:': '1f926-1f3fe',
    ':person_facepalming_tone5:': '1f926-1f3ff',
    ':person_feeding_baby:': '1f9d1-200d-1f37c',
    ':person_frowning_tone1:': '1f64d-1f3fb',
    ':person_frowning_tone2:': '1f64d-1f3fc',
    ':person_frowning_tone3:': '1f64d-1f3fd',
    ':person_frowning_tone4:': '1f64d-1f3fe',
    ':person_frowning_tone5:': '1f64d-1f3ff',
    ':person_gesturing_no_tone1:': '1f645-1f3fb',
    ':person_gesturing_no_tone2:': '1f645-1f3fc',
    ':person_gesturing_no_tone3:': '1f645-1f3fd',
    ':person_gesturing_no_tone4:': '1f645-1f3fe',
    ':person_gesturing_no_tone5:': '1f645-1f3ff',
    ':person_gesturing_ok_tone1:': '1f646-1f3fb',
    ':person_gesturing_ok_tone2:': '1f646-1f3fc',
    ':person_gesturing_ok_tone3:': '1f646-1f3fd',
    ':person_gesturing_ok_tone4:': '1f646-1f3fe',
    ':person_gesturing_ok_tone5:': '1f646-1f3ff',
    ':person_getting_haircut_tone1:': '1f487-1f3fb',
    ':person_getting_haircut_tone2:': '1f487-1f3fc',
    ':person_getting_haircut_tone3:': '1f487-1f3fd',
    ':person_getting_haircut_tone4:': '1f487-1f3fe',
    ':person_getting_haircut_tone5:': '1f487-1f3ff',
    ':person_getting_massage_tone1:': '1f486-1f3fb',
    ':person_getting_massage_tone2:': '1f486-1f3fc',
    ':person_getting_massage_tone3:': '1f486-1f3fd',
    ':person_getting_massage_tone4:': '1f486-1f3fe',
    ':person_getting_massage_tone5:': '1f486-1f3ff',
    ':person_golfing_tone1:': '1f3cc-1f3fb',
    ':person_golfing_tone2:': '1f3cc-1f3fc',
    ':person_golfing_tone3:': '1f3cc-1f3fd',
    ':person_golfing_tone4:': '1f3cc-1f3fe',
    ':person_golfing_tone5:': '1f3cc-1f3ff',
    ':person_in_bed_tone1:': '1f6cc-1f3fb',
    ':person_in_bed_tone2:': '1f6cc-1f3fc',
    ':person_in_bed_tone3:': '1f6cc-1f3fd',
    ':person_in_bed_tone4:': '1f6cc-1f3fe',
    ':person_in_bed_tone5:': '1f6cc-1f3ff',
    ':person_in_lotus_position_tone1:': '1f9d8-1f3fb',
    ':person_in_lotus_position_tone2:': '1f9d8-1f3fc',
    ':person_in_lotus_position_tone3:': '1f9d8-1f3fd',
    ':person_in_lotus_position_tone4:': '1f9d8-1f3fe',
    ':person_in_lotus_position_tone5:': '1f9d8-1f3ff',
    ':person_in_manual_wheelchair:': '1f9d1-200d-1f9bd',
    ':person_in_motorized_wheelchair:': '1f9d1-200d-1f9bc',
    ':person_in_steamy_room_tone1:': '1f9d6-1f3fb',
    ':person_in_steamy_room_tone2:': '1f9d6-1f3fc',
    ':person_in_steamy_room_tone3:': '1f9d6-1f3fd',
    ':person_in_steamy_room_tone4:': '1f9d6-1f3fe',
    ':person_in_steamy_room_tone5:': '1f9d6-1f3ff',
    ':person_in_tuxedo_tone1:': '1f935-1f3fb',
    ':person_in_tuxedo_tone2:': '1f935-1f3fc',
    ':person_in_tuxedo_tone3:': '1f935-1f3fd',
    ':person_in_tuxedo_tone4:': '1f935-1f3fe',
    ':person_in_tuxedo_tone5:': '1f935-1f3ff',
    ':person_juggling_tone1:': '1f939-1f3fb',
    ':person_juggling_tone2:': '1f939-1f3fc',
    ':person_juggling_tone3:': '1f939-1f3fd',
    ':person_juggling_tone4:': '1f939-1f3fe',
    ':person_juggling_tone5:': '1f939-1f3ff',
    ':person_kneeling_tone1:': '1f9ce-1f3fb',
    ':person_kneeling_tone2:': '1f9ce-1f3fc',
    ':person_kneeling_tone3:': '1f9ce-1f3fd',
    ':person_kneeling_tone4:': '1f9ce-1f3fe',
    ':person_kneeling_tone5:': '1f9ce-1f3ff',
    ':person_lifting_weights_tone1:': '1f3cb-1f3fb',
    ':person_lifting_weights_tone2:': '1f3cb-1f3fc',
    ':person_lifting_weights_tone3:': '1f3cb-1f3fd',
    ':person_lifting_weights_tone4:': '1f3cb-1f3fe',
    ':person_lifting_weights_tone5:': '1f3cb-1f3ff',
    ':person_mountain_biking_tone1:': '1f6b5-1f3fb',
    ':person_mountain_biking_tone2:': '1f6b5-1f3fc',
    ':person_mountain_biking_tone3:': '1f6b5-1f3fd',
    ':person_mountain_biking_tone4:': '1f6b5-1f3fe',
    ':person_mountain_biking_tone5:': '1f6b5-1f3ff',
    ':person_playing_handball_tone1:': '1f93e-1f3fb',
    ':person_playing_handball_tone2:': '1f93e-1f3fc',
    ':person_playing_handball_tone3:': '1f93e-1f3fd',
    ':person_playing_handball_tone4:': '1f93e-1f3fe',
    ':person_playing_handball_tone5:': '1f93e-1f3ff',
    ':person_playing_water_polo_tone1:': '1f93d-1f3fb',
    ':person_playing_water_polo_tone2:': '1f93d-1f3fc',
    ':person_playing_water_polo_tone3:': '1f93d-1f3fd',
    ':person_playing_water_polo_tone4:': '1f93d-1f3fe',
    ':person_playing_water_polo_tone5:': '1f93d-1f3ff',
    ':person_pouting_tone1:': '1f64e-1f3fb',
    ':person_pouting_tone2:': '1f64e-1f3fc',
    ':person_pouting_tone3:': '1f64e-1f3fd',
    ':person_pouting_tone4:': '1f64e-1f3fe',
    ':person_pouting_tone5:': '1f64e-1f3ff',
    ':person_raising_hand_tone1:': '1f64b-1f3fb',
    ':person_raising_hand_tone2:': '1f64b-1f3fc',
    ':person_raising_hand_tone3:': '1f64b-1f3fd',
    ':person_raising_hand_tone4:': '1f64b-1f3fe',
    ':person_raising_hand_tone5:': '1f64b-1f3ff',
    ':person_red_hair:': '1f9d1-200d-1f9b0',
    ':person_rowing_boat_tone1:': '1f6a3-1f3fb',
    ':person_rowing_boat_tone2:': '1f6a3-1f3fc',
    ':person_rowing_boat_tone3:': '1f6a3-1f3fd',
    ':person_rowing_boat_tone4:': '1f6a3-1f3fe',
    ':person_rowing_boat_tone5:': '1f6a3-1f3ff',
    ':person_running_tone1:': '1f3c3-1f3fb',
    ':person_running_tone2:': '1f3c3-1f3fc',
    ':person_running_tone3:': '1f3c3-1f3fd',
    ':person_running_tone4:': '1f3c3-1f3fe',
    ':person_running_tone5:': '1f3c3-1f3ff',
    ':person_shrugging_tone1:': '1f937-1f3fb',
    ':person_shrugging_tone2:': '1f937-1f3fc',
    ':person_shrugging_tone3:': '1f937-1f3fd',
    ':person_shrugging_tone4:': '1f937-1f3fe',
    ':person_shrugging_tone5:': '1f937-1f3ff',
    ':person_standing_tone1:': '1f9cd-1f3fb',
    ':person_standing_tone2:': '1f9cd-1f3fc',
    ':person_standing_tone3:': '1f9cd-1f3fd',
    ':person_standing_tone4:': '1f9cd-1f3fe',
    ':person_standing_tone5:': '1f9cd-1f3ff',
    ':person_surfing_tone1:': '1f3c4-1f3fb',
    ':person_surfing_tone2:': '1f3c4-1f3fc',
    ':person_surfing_tone3:': '1f3c4-1f3fd',
    ':person_surfing_tone4:': '1f3c4-1f3fe',
    ':person_surfing_tone5:': '1f3c4-1f3ff',
    ':person_swimming_tone1:': '1f3ca-1f3fb',
    ':person_swimming_tone2:': '1f3ca-1f3fc',
    ':person_swimming_tone3:': '1f3ca-1f3fd',
    ':person_swimming_tone4:': '1f3ca-1f3fe',
    ':person_swimming_tone5:': '1f3ca-1f3ff',
    ':person_tipping_hand_tone1:': '1f481-1f3fb',
    ':person_tipping_hand_tone2:': '1f481-1f3fc',
    ':person_tipping_hand_tone3:': '1f481-1f3fd',
    ':person_tipping_hand_tone4:': '1f481-1f3fe',
    ':person_tipping_hand_tone5:': '1f481-1f3ff',
    ':person_walking_tone1:': '1f6b6-1f3fb',
    ':person_walking_tone2:': '1f6b6-1f3fc',
    ':person_walking_tone3:': '1f6b6-1f3fd',
    ':person_walking_tone4:': '1f6b6-1f3fe',
    ':person_walking_tone5:': '1f6b6-1f3ff',
    ':person_wearing_turban_tone1:': '1f473-1f3fb',
    ':person_wearing_turban_tone2:': '1f473-1f3fc',
    ':person_wearing_turban_tone3:': '1f473-1f3fd',
    ':person_wearing_turban_tone4:': '1f473-1f3fe',
    ':person_wearing_turban_tone5:': '1f473-1f3ff',
    ':person_white_hair:': '1f9d1-200d-1f9b3',
    ':person_with_crown_tone1:': '1fac5-1f3fb',
    ':person_with_crown_tone2:': '1fac5-1f3fc',
    ':person_with_crown_tone3:': '1fac5-1f3fd',
    ':person_with_crown_tone4:': '1fac5-1f3fe',
    ':person_with_crown_tone5:': '1fac5-1f3ff',
    ':person_with_probing_cane:': '1f9d1-200d-1f9af',
    ':person_with_veil_tone1:': '1f470-1f3fb',
    ':person_with_veil_tone2:': '1f470-1f3fc',
    ':person_with_veil_tone3:': '1f470-1f3fd',
    ':person_with_veil_tone4:': '1f470-1f3fe',
    ':person_with_veil_tone5:': '1f470-1f3ff',
    ':pinched_fingers_tone1:': '1f90c-1f3fb',
    ':pinched_fingers_tone2:': '1f90c-1f3fc',
    ':pinched_fingers_tone3:': '1f90c-1f3fd',
    ':pinched_fingers_tone4:': '1f90c-1f3fe',
    ':pinched_fingers_tone5:': '1f90c-1f3ff',
    ':pinching_hand_tone1:': '1f90f-1f3fb',
    ':pinching_hand_tone2:': '1f90f-1f3fc',
    ':pinching_hand_tone3:': '1f90f-1f3fd',
    ':pinching_hand_tone4:': '1f90f-1f3fe',
    ':pinching_hand_tone5:': '1f90f-1f3ff',
    ':point_down_tone1:': '1f447-1f3fb',
    ':point_down_tone2:': '1f447-1f3fc',
    ':point_down_tone3:': '1f447-1f3fd',
    ':point_down_tone4:': '1f447-1f3fe',
    ':point_down_tone5:': '1f447-1f3ff',
    ':point_left_tone1:': '1f448-1f3fb',
    ':point_left_tone2:': '1f448-1f3fc',
    ':point_left_tone3:': '1f448-1f3fd',
    ':point_left_tone4:': '1f448-1f3fe',
    ':point_left_tone5:': '1f448-1f3ff',
    ':point_right_tone1:': '1f449-1f3fb',
    ':point_right_tone2:': '1f449-1f3fc',
    ':point_right_tone3:': '1f449-1f3fd',
    ':point_right_tone4:': '1f449-1f3fe',
    ':point_right_tone5:': '1f449-1f3ff',
    ':point_up_2_tone1:': '1f446-1f3fb',
    ':point_up_2_tone2:': '1f446-1f3fc',
    ':point_up_2_tone3:': '1f446-1f3fd',
    ':point_up_2_tone4:': '1f446-1f3fe',
    ':point_up_2_tone5:': '1f446-1f3ff',
    ':police_officer_tone1:': '1f46e-1f3fb',
    ':police_officer_tone2:': '1f46e-1f3fc',
    ':police_officer_tone3:': '1f46e-1f3fd',
    ':police_officer_tone4:': '1f46e-1f3fe',
    ':police_officer_tone5:': '1f46e-1f3ff',
    ':pray_tone1:': '1f64f-1f3fb',
    ':pray_tone2:': '1f64f-1f3fc',
    ':pray_tone3:': '1f64f-1f3fd',
    ':pray_tone4:': '1f64f-1f3fe',
    ':pray_tone5:': '1f64f-1f3ff',
    ':pregnant_man_tone1:': '1fac3-1f3fb',
    ':pregnant_man_tone2:': '1fac3-1f3fc',
    ':pregnant_man_tone3:': '1fac3-1f3fd',
    ':pregnant_man_tone4:': '1fac3-1f3fe',
    ':pregnant_man_tone5:': '1fac3-1f3ff',
    ':pregnant_person_tone1:': '1fac4-1f3fb',
    ':pregnant_person_tone2:': '1fac4-1f3fc',
    ':pregnant_person_tone3:': '1fac4-1f3fd',
    ':pregnant_person_tone4:': '1fac4-1f3fe',
    ':pregnant_person_tone5:': '1fac4-1f3ff',
    ':pregnant_woman_tone1:': '1f930-1f3fb',
    ':pregnant_woman_tone2:': '1f930-1f3fc',
    ':pregnant_woman_tone3:': '1f930-1f3fd',
    ':pregnant_woman_tone4:': '1f930-1f3fe',
    ':pregnant_woman_tone5:': '1f930-1f3ff',
    ':prince_tone1:': '1f934-1f3fb',
    ':prince_tone2:': '1f934-1f3fc',
    ':prince_tone3:': '1f934-1f3fd',
    ':prince_tone4:': '1f934-1f3fe',
    ':prince_tone5:': '1f934-1f3ff',
    ':princess_tone1:': '1f478-1f3fb',
    ':princess_tone2:': '1f478-1f3fc',
    ':princess_tone3:': '1f478-1f3fd',
    ':princess_tone4:': '1f478-1f3fe',
    ':princess_tone5:': '1f478-1f3ff',
    ':punch_tone1:': '1f44a-1f3fb',
    ':punch_tone2:': '1f44a-1f3fc',
    ':punch_tone3:': '1f44a-1f3fd',
    ':punch_tone4:': '1f44a-1f3fe',
    ':punch_tone5:': '1f44a-1f3ff',
    ':rainbow_flag:': '1f3f3-fe0f-200d-1f308',
    ':raised_back_of_hand_tone1:': '1f91a-1f3fb',
    ':raised_back_of_hand_tone2:': '1f91a-1f3fc',
    ':raised_back_of_hand_tone3:': '1f91a-1f3fd',
    ':raised_back_of_hand_tone4:': '1f91a-1f3fe',
    ':raised_back_of_hand_tone5:': '1f91a-1f3ff',
    ':raised_hands_tone1:': '1f64c-1f3fb',
    ':raised_hands_tone2:': '1f64c-1f3fc',
    ':raised_hands_tone3:': '1f64c-1f3fd',
    ':raised_hands_tone4:': '1f64c-1f3fe',
    ':raised_hands_tone5:': '1f64c-1f3ff',
    ':right_facing_fist_tone1:': '1f91c-1f3fb',
    ':right_facing_fist_tone2:': '1f91c-1f3fc',
    ':right_facing_fist_tone3:': '1f91c-1f3fd',
    ':right_facing_fist_tone4:': '1f91c-1f3fe',
    ':right_facing_fist_tone5:': '1f91c-1f3ff',
    ':rightwards_hand_tone1:': '1faf1-1f3fb',
    ':rightwards_hand_tone2:': '1faf1-1f3fc',
    ':rightwards_hand_tone3:': '1faf1-1f3fd',
    ':rightwards_hand_tone4:': '1faf1-1f3fe',
    ':rightwards_hand_tone5:': '1faf1-1f3ff',
    ':santa_tone1:': '1f385-1f3fb',
    ':santa_tone2:': '1f385-1f3fc',
    ':santa_tone3:': '1f385-1f3fd',
    ':santa_tone4:': '1f385-1f3fe',
    ':santa_tone5:': '1f385-1f3ff',
    ':scientist:': '1f9d1-200d-1f52c',
    ':selfie_tone1:': '1f933-1f3fb',
    ':selfie_tone2:': '1f933-1f3fc',
    ':selfie_tone3:': '1f933-1f3fd',
    ':selfie_tone4:': '1f933-1f3fe',
    ':selfie_tone5:': '1f933-1f3ff',
    ':service_dog:': '1f415-200d-1f9ba',
    ':singer:': '1f9d1-200d-1f3a4',
    ':snowboarder_tone1:': '1f3c2-1f3fb',
    ':snowboarder_tone2:': '1f3c2-1f3fc',
    ':snowboarder_tone3:': '1f3c2-1f3fd',
    ':snowboarder_tone4:': '1f3c2-1f3fe',
    ':snowboarder_tone5:': '1f3c2-1f3ff',
    ':student:': '1f9d1-200d-1f393',
    ':superhero_tone1:': '1f9b8-1f3fb',
    ':superhero_tone2:': '1f9b8-1f3fc',
    ':superhero_tone3:': '1f9b8-1f3fd',
    ':superhero_tone4:': '1f9b8-1f3fe',
    ':superhero_tone5:': '1f9b8-1f3ff',
    ':supervillain_tone1:': '1f9b9-1f3fb',
    ':supervillain_tone2:': '1f9b9-1f3fc',
    ':supervillain_tone3:': '1f9b9-1f3fd',
    ':supervillain_tone4:': '1f9b9-1f3fe',
    ':supervillain_tone5:': '1f9b9-1f3ff',
    ':teacher:': '1f9d1-200d-1f3eb',
    ':technologist:': '1f9d1-200d-1f4bb',
    ':thumbsdown_tone1:': '1f44e-1f3fb',
    ':thumbsdown_tone2:': '1f44e-1f3fc',
    ':thumbsdown_tone3:': '1f44e-1f3fd',
    ':thumbsdown_tone4:': '1f44e-1f3fe',
    ':thumbsdown_tone5:': '1f44e-1f3ff',
    ':thumbsup_tone1:': '1f44d-1f3fb',
    ':thumbsup_tone2:': '1f44d-1f3fc',
    ':thumbsup_tone3:': '1f44d-1f3fd',
    ':thumbsup_tone4:': '1f44d-1f3fe',
    ':thumbsup_tone5:': '1f44d-1f3ff',
    ':united_nations:': '1f1fa-1f1f3',
    ':vampire_tone1:': '1f9db-1f3fb',
    ':vampire_tone2:': '1f9db-1f3fc',
    ':vampire_tone3:': '1f9db-1f3fd',
    ':vampire_tone4:': '1f9db-1f3fe',
    ':vampire_tone5:': '1f9db-1f3ff',
    ':vulcan_tone1:': '1f596-1f3fb',
    ':vulcan_tone2:': '1f596-1f3fc',
    ':vulcan_tone3:': '1f596-1f3fd',
    ':vulcan_tone4:': '1f596-1f3fe',
    ':vulcan_tone5:': '1f596-1f3ff',
    ':wave_tone1:': '1f44b-1f3fb',
    ':wave_tone2:': '1f44b-1f3fc',
    ':wave_tone3:': '1f44b-1f3fd',
    ':wave_tone4:': '1f44b-1f3fe',
    ':wave_tone5:': '1f44b-1f3ff',
    ':woman_and_man_holding_hands_tone1:': '1f46b-1f3fb',
    ':woman_and_man_holding_hands_tone2:': '1f46b-1f3fc',
    ':woman_and_man_holding_hands_tone3:': '1f46b-1f3fd',
    ':woman_and_man_holding_hands_tone4:': '1f46b-1f3fe',
    ':woman_and_man_holding_hands_tone5:': '1f46b-1f3ff',
    ':woman_artist:': '1f469-200d-1f3a8',
    ':woman_astronaut:': '1f469-200d-1f680',
    ':woman_bald:': '1f469-200d-1f9b2',
    ':woman_cook:': '1f469-200d-1f373',
    ':woman_curly_haired:': '1f469-200d-1f9b1',
    ':woman_factory_worker:': '1f469-200d-1f3ed',
    ':woman_farmer:': '1f469-200d-1f33e',
    ':woman_feeding_baby:': '1f469-200d-1f37c',
    ':woman_firefighter:': '1f469-200d-1f692',
    ':woman_in_manual_wheelchair:': '1f469-200d-1f9bd',
    ':woman_in_motorized_wheelchair:': '1f469-200d-1f9bc',
    ':woman_mechanic:': '1f469-200d-1f527',
    ':woman_office_worker:': '1f469-200d-1f4bc',
    ':woman_red_haired:': '1f469-200d-1f9b0',
    ':woman_scientist:': '1f469-200d-1f52c',
    ':woman_singer:': '1f469-200d-1f3a4',
    ':woman_student:': '1f469-200d-1f393',
    ':woman_teacher:': '1f469-200d-1f3eb',
    ':woman_technologist:': '1f469-200d-1f4bb',
    ':woman_tone1:': '1f469-1f3fb',
    ':woman_tone2:': '1f469-1f3fc',
    ':woman_tone3:': '1f469-1f3fd',
    ':woman_tone4:': '1f469-1f3fe',
    ':woman_tone5:': '1f469-1f3ff',
    ':woman_white_haired:': '1f469-200d-1f9b3',
    ':woman_with_headscarf_tone1:': '1f9d5-1f3fb',
    ':woman_with_headscarf_tone2:': '1f9d5-1f3fc',
    ':woman_with_headscarf_tone3:': '1f9d5-1f3fd',
    ':woman_with_headscarf_tone4:': '1f9d5-1f3fe',
    ':woman_with_headscarf_tone5:': '1f9d5-1f3ff',
    ':woman_with_probing_cane:': '1f469-200d-1f9af',
    ':women_holding_hands_tone1:': '1f46d-1f3fb',
    ':women_holding_hands_tone2:': '1f46d-1f3fc',
    ':women_holding_hands_tone3:': '1f46d-1f3fd',
    ':women_holding_hands_tone4:': '1f46d-1f3fe',
    ':women_holding_hands_tone5:': '1f46d-1f3ff',
    ':black_cat:': '1f408-200d-2b1b',
    ':blond-haired_man:': '1f471-200d-2642-fe0f',
    ':blond-haired_woman:': '1f471-200d-2640-fe0f',
    ':deaf_man:': '1f9cf-200d-2642-fe0f',
    ':deaf_woman:': '1f9cf-200d-2640-fe0f',
    ':fist_tone1:': '270a-1f3fb',
    ':fist_tone2:': '270a-1f3fc',
    ':fist_tone3:': '270a-1f3fd',
    ':fist_tone4:': '270a-1f3fe',
    ':fist_tone5:': '270a-1f3ff',
    ':health_worker:': '1f9d1-200d-2695-fe0f',
    ':heart_on_fire:': '2764-fe0f-200d-1f525',
    ':judge:': '1f9d1-200d-2696-fe0f',
    ':man_beard:': '1f9d4-200d-2642-fe0f',
    ':man_biking:': '1f6b4-200d-2642-fe0f',
    ':man_bowing:': '1f647-200d-2642-fe0f',
    ':man_cartwheeling:': '1f938-200d-2642-fe0f',
    ':man_climbing:': '1f9d7-200d-2642-fe0f',
    ':man_construction_worker:': '1f477-200d-2642-fe0f',
    ':man_detective:': '1f575-fe0f-200d-2642-fe0f',
    ':man_elf:': '1f9dd-200d-2642-fe0f',
    ':man_facepalming:': '1f926-200d-2642-fe0f',
    ':man_fairy:': '1f9da-200d-2642-fe0f',
    ':man_frowning:': '1f64d-200d-2642-fe0f',
    ':man_genie:': '1f9de-200d-2642-fe0f',
    ':man_gesturing_no:': '1f645-200d-2642-fe0f',
    ':man_gesturing_ok:': '1f646-200d-2642-fe0f',
    ':man_getting_face_massage:': '1f486-200d-2642-fe0f',
    ':man_getting_haircut:': '1f487-200d-2642-fe0f',
    ':man_golfing:': '1f3cc-fe0f-200d-2642-fe0f',
    ':man_guard:': '1f482-200d-2642-fe0f',
    ':man_health_worker:': '1f468-200d-2695-fe0f',
    ':man_in_lotus_position:': '1f9d8-200d-2642-fe0f',
    ':man_in_steamy_room:': '1f9d6-200d-2642-fe0f',
    ':man_in_tuxedo:': '1f935-200d-2642-fe0f',
    ':man_judge:': '1f468-200d-2696-fe0f',
    ':man_juggling:': '1f939-200d-2642-fe0f',
    ':man_kneeling:': '1f9ce-200d-2642-fe0f',
    ':man_lifting_weights:': '1f3cb-fe0f-200d-2642-fe0f',
    ':man_mage:': '1f9d9-200d-2642-fe0f',
    ':man_mountain_biking:': '1f6b5-200d-2642-fe0f',
    ':man_pilot:': '1f468-200d-2708-fe0f',
    ':man_playing_handball:': '1f93e-200d-2642-fe0f',
    ':man_playing_water_polo:': '1f93d-200d-2642-fe0f',
    ':man_police_officer:': '1f46e-200d-2642-fe0f',
    ':man_pouting:': '1f64e-200d-2642-fe0f',
    ':man_raising_hand:': '1f64b-200d-2642-fe0f',
    ':man_rowing_boat:': '1f6a3-200d-2642-fe0f',
    ':man_running:': '1f3c3-200d-2642-fe0f',
    ':man_shrugging:': '1f937-200d-2642-fe0f',
    ':man_standing:': '1f9cd-200d-2642-fe0f',
    ':man_superhero:': '1f9b8-200d-2642-fe0f',
    ':man_supervillain:': '1f9b9-200d-2642-fe0f',
    ':man_surfing:': '1f3c4-200d-2642-fe0f',
    ':man_swimming:': '1f3ca-200d-2642-fe0f',
    ':man_tipping_hand:': '1f481-200d-2642-fe0f',
    ':man_vampire:': '1f9db-200d-2642-fe0f',
    ':man_walking:': '1f6b6-200d-2642-fe0f',
    ':man_wearing_turban:': '1f473-200d-2642-fe0f',
    ':man_with_veil:': '1f470-200d-2642-fe0f',
    ':man_zombie:': '1f9df-200d-2642-fe0f',
    ':men_with_bunny_ears_partying:': '1f46f-200d-2642-fe0f',
    ':men_wrestling:': '1f93c-200d-2642-fe0f',
    ':mending_heart:': '2764-fe0f-200d-1fa79',
    ':mermaid:': '1f9dc-200d-2640-fe0f',
    ':merman:': '1f9dc-200d-2642-fe0f',
    ':person_bouncing_ball_tone1:': '26f9-1f3fb',
    ':person_bouncing_ball_tone2:': '26f9-1f3fc',
    ':person_bouncing_ball_tone3:': '26f9-1f3fd',
    ':person_bouncing_ball_tone4:': '26f9-1f3fe',
    ':person_bouncing_ball_tone5:': '26f9-1f3ff',
    ':pilot:': '1f9d1-200d-2708-fe0f',
    ':pirate_flag:': '1f3f4-200d-2620-fe0f',
    ':point_up_tone1:': '261d-1f3fb',
    ':point_up_tone2:': '261d-1f3fc',
    ':point_up_tone3:': '261d-1f3fd',
    ':point_up_tone4:': '261d-1f3fe',
    ':point_up_tone5:': '261d-1f3ff',
    ':polar_bear:': '1f43b-200d-2744-fe0f',
    ':raised_hand_tone1:': '270b-1f3fb',
    ':raised_hand_tone2:': '270b-1f3fc',
    ':raised_hand_tone3:': '270b-1f3fd',
    ':raised_hand_tone4:': '270b-1f3fe',
    ':raised_hand_tone5:': '270b-1f3ff',
    ':transgender_flag:': '1f3f3-fe0f-200d-26a7-fe0f',
    ':v_tone1:': '270c-1f3fb',
    ':v_tone2:': '270c-1f3fc',
    ':v_tone3:': '270c-1f3fd',
    ':v_tone4:': '270c-1f3fe',
    ':v_tone5:': '270c-1f3ff',
    ':woman_beard:': '1f9d4-200d-2640-fe0f',
    ':woman_biking:': '1f6b4-200d-2640-fe0f',
    ':woman_bowing:': '1f647-200d-2640-fe0f',
    ':woman_cartwheeling:': '1f938-200d-2640-fe0f',
    ':woman_climbing:': '1f9d7-200d-2640-fe0f',
    ':woman_construction_worker:': '1f477-200d-2640-fe0f',
    ':woman_detective:': '1f575-fe0f-200d-2640-fe0f',
    ':woman_elf:': '1f9dd-200d-2640-fe0f',
    ':woman_facepalming:': '1f926-200d-2640-fe0f',
    ':woman_fairy:': '1f9da-200d-2640-fe0f',
    ':woman_frowning:': '1f64d-200d-2640-fe0f',
    ':woman_genie:': '1f9de-200d-2640-fe0f',
    ':woman_gesturing_no:': '1f645-200d-2640-fe0f',
    ':woman_gesturing_ok:': '1f646-200d-2640-fe0f',
    ':woman_getting_face_massage:': '1f486-200d-2640-fe0f',
    ':woman_getting_haircut:': '1f487-200d-2640-fe0f',
    ':woman_golfing:': '1f3cc-fe0f-200d-2640-fe0f',
    ':woman_guard:': '1f482-200d-2640-fe0f',
    ':woman_health_worker:': '1f469-200d-2695-fe0f',
    ':woman_in_lotus_position:': '1f9d8-200d-2640-fe0f',
    ':woman_in_steamy_room:': '1f9d6-200d-2640-fe0f',
    ':woman_in_tuxedo:': '1f935-200d-2640-fe0f',
    ':woman_judge:': '1f469-200d-2696-fe0f',
    ':woman_juggling:': '1f939-200d-2640-fe0f',
    ':woman_kneeling:': '1f9ce-200d-2640-fe0f',
    ':woman_lifting_weights:': '1f3cb-fe0f-200d-2640-fe0f',
    ':woman_mage:': '1f9d9-200d-2640-fe0f',
    ':woman_mountain_biking:': '1f6b5-200d-2640-fe0f',
    ':woman_pilot:': '1f469-200d-2708-fe0f',
    ':woman_playing_handball:': '1f93e-200d-2640-fe0f',
    ':woman_playing_water_polo:': '1f93d-200d-2640-fe0f',
    ':woman_police_officer:': '1f46e-200d-2640-fe0f',
    ':woman_pouting:': '1f64e-200d-2640-fe0f',
    ':woman_raising_hand:': '1f64b-200d-2640-fe0f',
    ':woman_rowing_boat:': '1f6a3-200d-2640-fe0f',
    ':woman_running:': '1f3c3-200d-2640-fe0f',
    ':woman_shrugging:': '1f937-200d-2640-fe0f',
    ':woman_standing:': '1f9cd-200d-2640-fe0f',
    ':woman_superhero:': '1f9b8-200d-2640-fe0f',
    ':woman_supervillain:': '1f9b9-200d-2640-fe0f',
    ':woman_surfing:': '1f3c4-200d-2640-fe0f',
    ':woman_swimming:': '1f3ca-200d-2640-fe0f',
    ':woman_tipping_hand:': '1f481-200d-2640-fe0f',
    ':woman_vampire:': '1f9db-200d-2640-fe0f',
    ':woman_walking:': '1f6b6-200d-2640-fe0f',
    ':woman_wearing_turban:': '1f473-200d-2640-fe0f',
    ':woman_with_veil:': '1f470-200d-2640-fe0f',
    ':woman_zombie:': '1f9df-200d-2640-fe0f',
    ':women_with_bunny_ears_partying:': '1f46f-200d-2640-fe0f',
    ':women_wrestling:': '1f93c-200d-2640-fe0f',
    ':writing_hand_tone1:': '270d-1f3fb',
    ':writing_hand_tone2:': '270d-1f3fc',
    ':writing_hand_tone3:': '270d-1f3fd',
    ':writing_hand_tone4:': '270d-1f3fe',
    ':writing_hand_tone5:': '270d-1f3ff',
    ':asterisk:': '002a-fe0f-20e3',
    ':eight:': '0038-fe0f-20e3',
    ':five:': '0035-fe0f-20e3',
    ':four:': '0034-fe0f-20e3',
    ':hash:': '0023-fe0f-20e3',
    ':man_bouncing_ball:': '26f9-fe0f-200d-2642-fe0f',
    ':nine:': '0039-fe0f-20e3',
    ':one:': '0031-fe0f-20e3',
    ':seven:': '0037-fe0f-20e3',
    ':six:': '0036-fe0f-20e3',
    ':three:': '0033-fe0f-20e3',
    ':two:': '0032-fe0f-20e3',
    ':woman_bouncing_ball:': '26f9-fe0f-200d-2640-fe0f',
    ':zero:': '0030-fe0f-20e3',
    ':100:': '1f4af',
    ':1234:': '1f522',
    ':8ball:': '1f3b1',
    ':a:': '1f170-fe0f',
    ':ab:': '1f18e',
    ':abacus:': '1f9ee',
    ':abc:': '1f524',
    ':abcd:': '1f521',
    ':accept:': '1f251',
    ':accordion:': '1fa97',
    ':adhesive_bandage:': '1fa79',
    ':adult:': '1f9d1',
    ':aerial_tramway:': '1f6a1',
    ':airplane_arriving:': '1f6ec',
    ':airplane_departure:': '1f6eb',
    ':airplane_small:': '1f6e9-fe0f',
    ':alien:': '1f47d',
    ':ambulance:': '1f691',
    ':amphora:': '1f3fa',
    ':anatomical_heart:': '1fac0',
    ':angel:': '1f47c',
    ':anger:': '1f4a2',
    ':anger_right:': '1f5ef-fe0f',
    ':angry:': '1f620',
    ':anguished:': '1f627',
    ':ant:': '1f41c',
    ':apple:': '1f34e',
    ':arrow_down_small:': '1f53d',
    ':arrow_up_small:': '1f53c',
    ':arrows_clockwise:': '1f503',
    ':arrows_counterclockwise:': '1f504',
    ':art:': '1f3a8',
    ':articulated_lorry:': '1f69b',
    ':astonished:': '1f632',
    ':athletic_shoe:': '1f45f',
    ':atm:': '1f3e7',
    ':auto_rickshaw:': '1f6fa',
    ':avocado:': '1f951',
    ':axe:': '1fa93',
    ':b:': '1f171-fe0f',
    ':baby:': '1f476',
    ':baby_bottle:': '1f37c',
    ':baby_chick:': '1f424',
    ':baby_symbol:': '1f6bc',
    ':back:': '1f519',
    ':bacon:': '1f953',
    ':badger:': '1f9a1',
    ':badminton:': '1f3f8',
    ':bagel:': '1f96f',
    ':baggage_claim:': '1f6c4',
    ':bald:': '1f9b2',
    ':ballet_shoes:': '1fa70',
    ':balloon:': '1f388',
    ':ballot_box:': '1f5f3-fe0f',
    ':bamboo:': '1f38d',
    ':banana:': '1f34c',
    ':banjo:': '1fa95',
    ':bank:': '1f3e6',
    ':bar_chart:': '1f4ca',
    ':barber:': '1f488',
    ':basket:': '1f9fa',
    ':basketball:': '1f3c0',
    ':bat:': '1f987',
    ':bath:': '1f6c0',
    ':bathtub:': '1f6c1',
    ':battery:': '1f50b',
    ':beach:': '1f3d6-fe0f',
    ':beans:': '1fad8',
    ':bear:': '1f43b',
    ':bearded_person:': '1f9d4',
    ':beaver:': '1f9ab',
    ':bed:': '1f6cf-fe0f',
    ':bee:': '1f41d',
    ':beer:': '1f37a',
    ':beers:': '1f37b',
    ':beetle:': '1fab2',
    ':beginner:': '1f530',
    ':bell:': '1f514',
    ':bell_pepper:': '1fad1',
    ':bellhop:': '1f6ce-fe0f',
    ':bento:': '1f371',
    ':beverage_box:': '1f9c3',
    ':bike:': '1f6b2',
    ':bikini:': '1f459',
    ':billed_cap:': '1f9e2',
    ':bird:': '1f426',
    ':birthday:': '1f382',
    ':bison:': '1f9ac',
    ':biting_lip:': '1fae6',
    ':black_heart:': '1f5a4',
    ':black_joker:': '1f0cf',
    ':black_square_button:': '1f532',
    ':blond_haired_person:': '1f471',
    ':blossom:': '1f33c',
    ':blowfish:': '1f421',
    ':blue_book:': '1f4d8',
    ':blue_car:': '1f699',
    ':blue_circle:': '1f535',
    ':blue_heart:': '1f499',
    ':blue_square:': '1f7e6',
    ':blueberries:': '1fad0',
    ':blush:': '1f60a',
    ':boar:': '1f417',
    ':bomb:': '1f4a3',
    ':bone:': '1f9b4',
    ':book:': '1f4d6',
    ':bookmark:': '1f516',
    ':bookmark_tabs:': '1f4d1',
    ':books:': '1f4da',
    ':boom:': '1f4a5',
    ':boomerang:': '1fa83',
    ':boot:': '1f462',
    ':bouquet:': '1f490',
    ':bow_and_arrow:': '1f3f9',
    ':bowl_with_spoon:': '1f963',
    ':bowling:': '1f3b3',
    ':boxing_glove:': '1f94a',
    ':boy:': '1f466',
    ':brain:': '1f9e0',
    ':bread:': '1f35e',
    ':breast_feeding:': '1f931',
    ':bricks:': '1f9f1',
    ':bridge_at_night:': '1f309',
    ':briefcase:': '1f4bc',
    ':briefs:': '1fa72',
    ':broccoli:': '1f966',
    ':broken_heart:': '1f494',
    ':broom:': '1f9f9',
    ':brown_circle:': '1f7e4',
    ':brown_heart:': '1f90e',
    ':brown_square:': '1f7eb',
    ':bubble_tea:': '1f9cb',
    ':bubbles:': '1fae7',
    ':bucket:': '1faa3',
    ':bug:': '1f41b',
    ':bulb:': '1f4a1',
    ':bullettrain_front:': '1f685',
    ':bullettrain_side:': '1f684',
    ':burrito:': '1f32f',
    ':bus:': '1f68c',
    ':busstop:': '1f68f',
    ':bust_in_silhouette:': '1f464',
    ':busts_in_silhouette:': '1f465',
    ':butter:': '1f9c8',
    ':butterfly:': '1f98b',
    ':cactus:': '1f335',
    ':cake:': '1f370',
    ':calendar:': '1f4c6',
    ':calendar_spiral:': '1f5d3-fe0f',
    ':call_me:': '1f919',
    ':calling:': '1f4f2',
    ':camel:': '1f42b',
    ':camera:': '1f4f7',
    ':camera_with_flash:': '1f4f8',
    ':camping:': '1f3d5-fe0f',
    ':candle:': '1f56f-fe0f',
    ':candy:': '1f36c',
    ':canned_food:': '1f96b',
    ':canoe:': '1f6f6',
    ':capital_abcd:': '1f520',
    ':card_box:': '1f5c3-fe0f',
    ':card_index:': '1f4c7',
    ':carousel_horse:': '1f3a0',
    ':carpentry_saw:': '1fa9a',
    ':carrot:': '1f955',
    ':cat2:': '1f408',
    ':cat:': '1f431',
    ':cd:': '1f4bf',
    ':chair:': '1fa91',
    ':champagne:': '1f37e',
    ':champagne_glass:': '1f942',
    ':chart:': '1f4b9',
    ':chart_with_downwards_trend:': '1f4c9',
    ':chart_with_upwards_trend:': '1f4c8',
    ':checkered_flag:': '1f3c1',
    ':cheese:': '1f9c0',
    ':cherries:': '1f352',
    ':cherry_blossom:': '1f338',
    ':chestnut:': '1f330',
    ':chicken:': '1f414',
    ':child:': '1f9d2',
    ':children_crossing:': '1f6b8',
    ':chipmunk:': '1f43f-fe0f',
    ':chocolate_bar:': '1f36b',
    ':chopsticks:': '1f962',
    ':christmas_tree:': '1f384',
    ':cinema:': '1f3a6',
    ':circus_tent:': '1f3aa',
    ':city_dusk:': '1f306',
    ':city_sunset:': '1f307',
    ':cityscape:': '1f3d9-fe0f',
    ':cl:': '1f191',
    ':clap:': '1f44f',
    ':clapper:': '1f3ac',
    ':classical_building:': '1f3db-fe0f',
    ':clipboard:': '1f4cb',
    ':clock1030:': '1f565',
    ':clock10:': '1f559',
    ':clock1130:': '1f566',
    ':clock11:': '1f55a',
    ':clock1230:': '1f567',
    ':clock12:': '1f55b',
    ':clock130:': '1f55c',
    ':clock1:': '1f550',
    ':clock230:': '1f55d',
    ':clock2:': '1f551',
    ':clock330:': '1f55e',
    ':clock3:': '1f552',
    ':clock430:': '1f55f',
    ':clock4:': '1f553',
    ':clock530:': '1f560',
    ':clock5:': '1f554',
    ':clock630:': '1f561',
    ':clock6:': '1f555',
    ':clock730:': '1f562',
    ':clock7:': '1f556',
    ':clock830:': '1f563',
    ':clock8:': '1f557',
    ':clock930:': '1f564',
    ':clock9:': '1f558',
    ':clock:': '1f570-fe0f',
    ':closed_book:': '1f4d5',
    ':closed_lock_with_key:': '1f510',
    ':closed_umbrella:': '1f302',
    ':cloud_lightning:': '1f329-fe0f',
    ':cloud_rain:': '1f327-fe0f',
    ':cloud_snow:': '1f328-fe0f',
    ':cloud_tornado:': '1f32a-fe0f',
    ':clown:': '1f921',
    ':coat:': '1f9e5',
    ':cockroach:': '1fab3',
    ':cocktail:': '1f378',
    ':coconut:': '1f965',
    ':coin:': '1fa99',
    ':cold_face:': '1f976',
    ':cold_sweat:': '1f630',
    ':compass:': '1f9ed',
    ':compression:': '1f5dc-fe0f',
    ':computer:': '1f4bb',
    ':confetti_ball:': '1f38a',
    ':confounded:': '1f616',
    ':confused:': '1f615',
    ':construction:': '1f6a7',
    ':construction_site:': '1f3d7-fe0f',
    ':construction_worker:': '1f477',
    ':control_knobs:': '1f39b-fe0f',
    ':convenience_store:': '1f3ea',
    ':cookie:': '1f36a',
    ':cooking:': '1f373',
    ':cool:': '1f192',
    ':coral:': '1fab8',
    ':corn:': '1f33d',
    ':couch:': '1f6cb-fe0f',
    ':couple:': '1f46b',
    ':couple_with_heart:': '1f491',
    ':couplekiss:': '1f48f',
    ':cow2:': '1f404',
    ':cow:': '1f42e',
    ':cowboy:': '1f920',
    ':crab:': '1f980',
    ':crayon:': '1f58d-fe0f',
    ':credit_card:': '1f4b3',
    ':crescent_moon:': '1f319',
    ':cricket:': '1f997',
    ':cricket_game:': '1f3cf',
    ':crocodile:': '1f40a',
    ':croissant:': '1f950',
    ':crossed_flags:': '1f38c',
    ':crown:': '1f451',
    ':cruise_ship:': '1f6f3-fe0f',
    ':crutch:': '1fa7c',
    ':cry:': '1f622',
    ':crying_cat_face:': '1f63f',
    ':crystal_ball:': '1f52e',
    ':cucumber:': '1f952',
    ':cup_with_straw:': '1f964',
    ':cupcake:': '1f9c1',
    ':cupid:': '1f498',
    ':curling_stone:': '1f94c',
    ':curly_haired:': '1f9b1',
    ':currency_exchange:': '1f4b1',
    ':curry:': '1f35b',
    ':custard:': '1f36e',
    ':customs:': '1f6c3',
    ':cut_of_meat:': '1f969',
    ':cyclone:': '1f300',
    ':dagger:': '1f5e1-fe0f',
    ':dancer:': '1f483',
    ':dango:': '1f361',
    ':dark_sunglasses:': '1f576-fe0f',
    ':dart:': '1f3af',
    ':dash:': '1f4a8',
    ':date:': '1f4c5',
    ':deaf_person:': '1f9cf',
    ':deciduous_tree:': '1f333',
    ':deer:': '1f98c',
    ':department_store:': '1f3ec',
    ':desert:': '1f3dc-fe0f',
    ':desktop:': '1f5a5-fe0f',
    ':detective:': '1f575',
    ':diamond_shape_with_a_dot_inside:': '1f4a0',
    ':disappointed:': '1f61e',
    ':disappointed_relieved:': '1f625',
    ':disguised_face:': '1f978',
    ':dividers:': '1f5c2-fe0f',
    ':diving_mask:': '1f93f',
    ':diya_lamp:': '1fa94',
    ':dizzy:': '1f4ab',
    ':dizzy_face:': '1f635',
    ':dna:': '1f9ec',
    ':do_not_litter:': '1f6af',
    ':dodo:': '1f9a4',
    ':dog2:': '1f415',
    ':dog:': '1f436',
    ':dollar:': '1f4b5',
    ':dolls:': '1f38e',
    ':dolphin:': '1f42c',
    ':door:': '1f6aa',
    ':dotted_line_face:': '1fae5',
    ':doughnut:': '1f369',
    ':dove:': '1f54a-fe0f',
    ':dragon:': '1f409',
    ':dragon_face:': '1f432',
    ':dress:': '1f457',
    ':dromedary_camel:': '1f42a',
    ':drooling_face:': '1f924',
    ':drop_of_blood:': '1fa78',
    ':droplet:': '1f4a7',
    ':drum:': '1f941',
    ':duck:': '1f986',
    ':dumpling:': '1f95f',
    ':dvd:': '1f4c0',
    ':e-mail:': '1f4e7',
    ':eagle:': '1f985',
    ':ear:': '1f442',
    ':ear_of_rice:': '1f33e',
    ':ear_with_hearing_aid:': '1f9bb',
    ':earth_africa:': '1f30d',
    ':earth_americas:': '1f30e',
    ':earth_asia:': '1f30f',
    ':egg:': '1f95a',
    ':eggplant:': '1f346',
    ':electric_plug:': '1f50c',
    ':elephant:': '1f418',
    ':elevator:': '1f6d7',
    ':elf:': '1f9dd',
    ':empty_nest:': '1fab9',
    ':end:': '1f51a',
    ':envelope_with_arrow:': '1f4e9',
    ':euro:': '1f4b6',
    ':european_castle:': '1f3f0',
    ':european_post_office:': '1f3e4',
    ':evergreen_tree:': '1f332',
    ':exploding_head:': '1f92f',
    ':expressionless:': '1f611',
    ':eye:': '1f441-fe0f',
    ':eyeglasses:': '1f453',
    ':eyes:': '1f440',
    ':face_holding_back_tears:': '1f979',
    ':face_vomiting:': '1f92e',
    ':face_with_diagonal_mouth:': '1fae4',
    ':face_with_hand_over_mouth:': '1f92d',
    ':face_with_monocle:': '1f9d0',
    ':face_with_open_eyes_and_hand_over_mouth:': '1fae2',
    ':face_with_peeking_eye:': '1fae3',
    ':face_with_raised_eyebrow:': '1f928',
    ':face_with_symbols_over_mouth:': '1f92c',
    ':factory:': '1f3ed',
    ':fairy:': '1f9da',
    ':falafel:': '1f9c6',
    ':fallen_leaf:': '1f342',
    ':family:': '1f46a',
    ':fax:': '1f4e0',
    ':fearful:': '1f628',
    ':feather:': '1fab6',
    ':feet:': '1f43e',
    ':ferris_wheel:': '1f3a1',
    ':field_hockey:': '1f3d1',
    ':file_cabinet:': '1f5c4-fe0f',
    ':file_folder:': '1f4c1',
    ':film_frames:': '1f39e-fe0f',
    ':fingers_crossed:': '1f91e',
    ':fire:': '1f525',
    ':fire_engine:': '1f692',
    ':fire_extinguisher:': '1f9ef',
    ':firecracker:': '1f9e8',
    ':fireworks:': '1f386',
    ':first_place:': '1f947',
    ':first_quarter_moon:': '1f313',
    ':first_quarter_moon_with_face:': '1f31b',
    ':fish:': '1f41f',
    ':fish_cake:': '1f365',
    ':fishing_pole_and_fish:': '1f3a3',
    ':flag_black:': '1f3f4',
    ':flag_white:': '1f3f3-fe0f',
    ':flags:': '1f38f',
    ':flamingo:': '1f9a9',
    ':flashlight:': '1f526',
    ':flatbread:': '1fad3',
    ':floppy_disk:': '1f4be',
    ':flower_playing_cards:': '1f3b4',
    ':flushed:': '1f633',
    ':fly:': '1fab0',
    ':flying_disc:': '1f94f',
    ':flying_saucer:': '1f6f8',
    ':fog:': '1f32b-fe0f',
    ':foggy:': '1f301',
    ':fondue:': '1fad5',
    ':foot:': '1f9b6',
    ':football:': '1f3c8',
    ':footprints:': '1f463',
    ':fork_and_knife:': '1f374',
    ':fork_knife_plate:': '1f37d-fe0f',
    ':fortune_cookie:': '1f960',
    ':four_leaf_clover:': '1f340',
    ':fox:': '1f98a',
    ':frame_photo:': '1f5bc-fe0f',
    ':free:': '1f193',
    ':french_bread:': '1f956',
    ':fried_shrimp:': '1f364',
    ':fries:': '1f35f',
    ':frog:': '1f438',
    ':frowning:': '1f626',
    ':full_moon:': '1f315',
    ':full_moon_with_face:': '1f31d',
    ':game_die:': '1f3b2',
    ':garlic:': '1f9c4',
    ':gem:': '1f48e',
    ':genie:': '1f9de',
    ':ghost:': '1f47b',
    ':gift:': '1f381',
    ':gift_heart:': '1f49d',
    ':giraffe:': '1f992',
    ':girl:': '1f467',
    ':globe_with_meridians:': '1f310',
    ':gloves:': '1f9e4',
    ':goal:': '1f945',
    ':goat:': '1f410',
    ':goggles:': '1f97d',
    ':gorilla:': '1f98d',
    ':grapes:': '1f347',
    ':green_apple:': '1f34f',
    ':green_book:': '1f4d7',
    ':green_circle:': '1f7e2',
    ':green_heart:': '1f49a',
    ':green_square:': '1f7e9',
    ':grimacing:': '1f62c',
    ':grin:': '1f601',
    ':grinning:': '1f600',
    ':guard:': '1f482',
    ':guide_dog:': '1f9ae',
    ':guitar:': '1f3b8',
    ':gun:': '1f52b',
    ':hamburger:': '1f354',
    ':hammer:': '1f528',
    ':hamsa:': '1faac',
    ':hamster:': '1f439',
    ':hand_splayed:': '1f590',
    ':hand_with_index_finger_and_thumb_crossed:': '1faf0',
    ':handbag:': '1f45c',
    ':handshake:': '1f91d',
    ':hatched_chick:': '1f425',
    ':hatching_chick:': '1f423',
    ':head_bandage:': '1f915',
    ':headphones:': '1f3a7',
    ':headstone:': '1faa6',
    ':hear_no_evil:': '1f649',
    ':heart_decoration:': '1f49f',
    ':heart_eyes:': '1f60d',
    ':heart_eyes_cat:': '1f63b',
    ':heart_hands:': '1faf6',
    ':heartbeat:': '1f493',
    ':heartpulse:': '1f497',
    ':heavy_dollar_sign:': '1f4b2',
    ':heavy_equals_sign:': '1f7f0',
    ':hedgehog:': '1f994',
    ':helicopter:': '1f681',
    ':herb:': '1f33f',
    ':hibiscus:': '1f33a',
    ':high_brightness:': '1f506',
    ':high_heel:': '1f460',
    ':hiking_boot:': '1f97e',
    ':hindu_temple:': '1f6d5',
    ':hippopotamus:': '1f99b',
    ':hockey:': '1f3d2',
    ':hole:': '1f573-fe0f',
    ':homes:': '1f3d8-fe0f',
    ':honey_pot:': '1f36f',
    ':hook:': '1fa9d',
    ':horse:': '1f434',
    ':horse_racing:': '1f3c7',
    ':hospital:': '1f3e5',
    ':hot_face:': '1f975',
    ':hot_pepper:': '1f336-fe0f',
    ':hotdog:': '1f32d',
    ':hotel:': '1f3e8',
    ':house:': '1f3e0',
    ':house_abandoned:': '1f3da-fe0f',
    ':house_with_garden:': '1f3e1',
    ':hugging:': '1f917',
    ':hushed:': '1f62f',
    ':hut:': '1f6d6',
    ':ice_cream:': '1f368',
    ':ice_cube:': '1f9ca',
    ':icecream:': '1f366',
    ':id:': '1f194',
    ':identification_card:': '1faaa',
    ':ideograph_advantage:': '1f250',
    ':imp:': '1f47f',
    ':inbox_tray:': '1f4e5',
    ':incoming_envelope:': '1f4e8',
    ':index_pointing_at_the_viewer:': '1faf5',
    ':innocent:': '1f607',
    ':island:': '1f3dd-fe0f',
    ':izakaya_lantern:': '1f3ee',
    ':jack_o_lantern:': '1f383',
    ':japan:': '1f5fe',
    ':japanese_castle:': '1f3ef',
    ':japanese_goblin:': '1f47a',
    ':japanese_ogre:': '1f479',
    ':jar:': '1fad9',
    ':jeans:': '1f456',
    ':jigsaw:': '1f9e9',
    ':joy:': '1f602',
    ':joy_cat:': '1f639',
    ':joystick:': '1f579-fe0f',
    ':kaaba:': '1f54b',
    ':kangaroo:': '1f998',
    ':key2:': '1f5dd-fe0f',
    ':key:': '1f511',
    ':keycap_ten:': '1f51f',
    ':kimono:': '1f458',
    ':kiss:': '1f48b',
    ':kissing:': '1f617',
    ':kissing_cat:': '1f63d',
    ':kissing_closed_eyes:': '1f61a',
    ':kissing_heart:': '1f618',
    ':kissing_smiling_eyes:': '1f619',
    ':kite:': '1fa81',
    ':kiwi:': '1f95d',
    ':knife:': '1f52a',
    ':knot:': '1faa2',
    ':koala:': '1f428',
    ':koko:': '1f201',
    ':lab_coat:': '1f97c',
    ':label:': '1f3f7-fe0f',
    ':lacrosse:': '1f94d',
    ':ladder:': '1fa9c',
    ':lady_beetle:': '1f41e',
    ':large_blue_diamond:': '1f537',
    ':large_orange_diamond:': '1f536',
    ':last_quarter_moon:': '1f317',
    ':last_quarter_moon_with_face:': '1f31c',
    ':laughing:': '1f606',
    ':leafy_green:': '1f96c',
    ':leaves:': '1f343',
    ':ledger:': '1f4d2',
    ':left_facing_fist:': '1f91b',
    ':left_luggage:': '1f6c5',
    ':leftwards_hand:': '1faf2',
    ':leg:': '1f9b5',
    ':lemon:': '1f34b',
    ':leopard:': '1f406',
    ':level_slider:': '1f39a-fe0f',
    ':levitate:': '1f574-fe0f',
    ':light_rail:': '1f688',
    ':link:': '1f517',
    ':lion_face:': '1f981',
    ':lips:': '1f444',
    ':lipstick:': '1f484',
    ':lizard:': '1f98e',
    ':llama:': '1f999',
    ':lobster:': '1f99e',
    ':lock:': '1f512',
    ':lock_with_ink_pen:': '1f50f',
    ':lollipop:': '1f36d',
    ':long_drum:': '1fa98',
    ':lotus:': '1fab7',
    ':loud_sound:': '1f50a',
    ':loudspeaker:': '1f4e2',
    ':love_hotel:': '1f3e9',
    ':love_letter:': '1f48c',
    ':love_you_gesture:': '1f91f',
    ':low_battery:': '1faab',
    ':low_brightness:': '1f505',
    ':luggage:': '1f9f3',
    ':lungs:': '1fac1',
    ':lying_face:': '1f925',
    ':mag:': '1f50d',
    ':mag_right:': '1f50e',
    ':mage:': '1f9d9',
    ':magic_wand:': '1fa84',
    ':magnet:': '1f9f2',
    ':mahjong:': '1f004',
    ':mailbox:': '1f4eb',
    ':mailbox_closed:': '1f4ea',
    ':mailbox_with_mail:': '1f4ec',
    ':mailbox_with_no_mail:': '1f4ed',
    ':mammoth:': '1f9a3',
    ':man:': '1f468',
    ':man_dancing:': '1f57a',
    ':man_with_chinese_cap:': '1f472',
    ':mango:': '1f96d',
    ':mans_shoe:': '1f45e',
    ':manual_wheelchair:': '1f9bd',
    ':map:': '1f5fa-fe0f',
    ':maple_leaf:': '1f341',
    ':martial_arts_uniform:': '1f94b',
    ':mask:': '1f637',
    ':mate:': '1f9c9',
    ':meat_on_bone:': '1f356',
    ':mechanical_arm:': '1f9be',
    ':mechanical_leg:': '1f9bf',
    ':medal:': '1f3c5',
    ':mega:': '1f4e3',
    ':melon:': '1f348',
    ':melting_face:': '1fae0',
    ':menorah:': '1f54e',
    ':mens:': '1f6b9',
    ':merperson:': '1f9dc',
    ':metal:': '1f918',
    ':metro:': '1f687',
    ':microbe:': '1f9a0',
    ':microphone2:': '1f399-fe0f',
    ':microphone:': '1f3a4',
    ':microscope:': '1f52c',
    ':middle_finger:': '1f595',
    ':military_helmet:': '1fa96',
    ':military_medal:': '1f396-fe0f',
    ':milk:': '1f95b',
    ':milky_way:': '1f30c',
    ':minibus:': '1f690',
    ':minidisc:': '1f4bd',
    ':mirror:': '1fa9e',
    ':mirror_ball:': '1faa9',
    ':mobile_phone:': '1f4f1',
    ':mobile_phone_off:': '1f4f4',
    ':money_mouth:': '1f911',
    ':money_with_wings:': '1f4b8',
    ':moneybag:': '1f4b0',
    ':monkey:': '1f412',
    ':monkey_face:': '1f435',
    ':monorail:': '1f69d',
    ':moon_cake:': '1f96e',
    ':mortar_board:': '1f393',
    ':mosque:': '1f54c',
    ':mosquito:': '1f99f',
    ':motor_scooter:': '1f6f5',
    ':motorboat:': '1f6e5-fe0f',
    ':motorcycle:': '1f3cd-fe0f',
    ':motorized_wheelchair:': '1f9bc',
    ':motorway:': '1f6e3-fe0f',
    ':mount_fuji:': '1f5fb',
    ':mountain_cableway:': '1f6a0',
    ':mountain_railway:': '1f69e',
    ':mountain_snow:': '1f3d4-fe0f',
    ':mouse2:': '1f401',
    ':mouse:': '1f42d',
    ':mouse_three_button:': '1f5b1-fe0f',
    ':mouse_trap:': '1faa4',
    ':movie_camera:': '1f3a5',
    ':moyai:': '1f5ff',
    ':mrs_claus:': '1f936',
    ':muscle:': '1f4aa',
    ':mushroom:': '1f344',
    ':musical_keyboard:': '1f3b9',
    ':musical_note:': '1f3b5',
    ':musical_score:': '1f3bc',
    ':mute:': '1f507',
    ':nail_care:': '1f485',
    ':name_badge:': '1f4db',
    ':nauseated_face:': '1f922',
    ':nazar_amulet:': '1f9ff',
    ':necktie:': '1f454',
    ':nerd:': '1f913',
    ':nest_with_eggs:': '1faba',
    ':nesting_dolls:': '1fa86',
    ':neutral_face:': '1f610',
    ':new:': '1f195',
    ':new_moon:': '1f311',
    ':new_moon_with_face:': '1f31a',
    ':newspaper2:': '1f5de-fe0f',
    ':newspaper:': '1f4f0',
    ':ng:': '1f196',
    ':night_with_stars:': '1f303',
    ':ninja:': '1f977',
    ':no_bell:': '1f515',
    ':no_bicycles:': '1f6b3',
    ':no_entry_sign:': '1f6ab',
    ':no_mobile_phones:': '1f4f5',
    ':no_mouth:': '1f636',
    ':no_pedestrians:': '1f6b7',
    ':no_smoking:': '1f6ad',
    ':non-potable_water:': '1f6b1',
    ':nose:': '1f443',
    ':notebook:': '1f4d3',
    ':notebook_with_decorative_cover:': '1f4d4',
    ':notepad_spiral:': '1f5d2-fe0f',
    ':notes:': '1f3b6',
    ':nut_and_bolt:': '1f529',
    ':o2:': '1f17e-fe0f',
    ':ocean:': '1f30a',
    ':octagonal_sign:': '1f6d1',
    ':octopus:': '1f419',
    ':oden:': '1f362',
    ':office:': '1f3e2',
    ':oil:': '1f6e2-fe0f',
    ':ok:': '1f197',
    ':ok_hand:': '1f44c',
    ':older_adult:': '1f9d3',
    ':older_man:': '1f474',
    ':older_woman:': '1f475',
    ':olive:': '1fad2',
    ':om_symbol:': '1f549-fe0f',
    ':on:': '1f51b',
    ':oncoming_automobile:': '1f698',
    ':oncoming_bus:': '1f68d',
    ':oncoming_police_car:': '1f694',
    ':oncoming_taxi:': '1f696',
    ':one_piece_swimsuit:': '1fa71',
    ':onion:': '1f9c5',
    ':open_file_folder:': '1f4c2',
    ':open_hands:': '1f450',
    ':open_mouth:': '1f62e',
    ':orange_book:': '1f4d9',
    ':orange_circle:': '1f7e0',
    ':orange_heart:': '1f9e1',
    ':orange_square:': '1f7e7',
    ':orangutan:': '1f9a7',
    ':otter:': '1f9a6',
    ':outbox_tray:': '1f4e4',
    ':owl:': '1f989',
    ':ox:': '1f402',
    ':oyster:': '1f9aa',
    ':package:': '1f4e6',
    ':page_facing_up:': '1f4c4',
    ':page_with_curl:': '1f4c3',
    ':pager:': '1f4df',
    ':paintbrush:': '1f58c-fe0f',
    ':palm_down_hand:': '1faf3',
    ':palm_tree:': '1f334',
    ':palm_up_hand:': '1faf4',
    ':palms_up_together:': '1f932',
    ':pancakes:': '1f95e',
    ':panda_face:': '1f43c',
    ':paperclip:': '1f4ce',
    ':paperclips:': '1f587-fe0f',
    ':parachute:': '1fa82',
    ':park:': '1f3de-fe0f',
    ':parking:': '1f17f-fe0f',
    ':parrot:': '1f99c',
    ':partying_face:': '1f973',
    ':passport_control:': '1f6c2',
    ':peach:': '1f351',
    ':peacock:': '1f99a',
    ':peanuts:': '1f95c',
    ':pear:': '1f350',
    ':pen_ballpoint:': '1f58a-fe0f',
    ':pen_fountain:': '1f58b-fe0f',
    ':pencil:': '1f4dd',
    ':penguin:': '1f427',
    ':pensive:': '1f614',
    ':people_hugging:': '1fac2',
    ':people_with_bunny_ears_partying:': '1f46f',
    ':people_wrestling:': '1f93c',
    ':performing_arts:': '1f3ad',
    ':persevere:': '1f623',
    ':person_biking:': '1f6b4',
    ':person_bowing:': '1f647',
    ':person_climbing:': '1f9d7',
    ':person_doing_cartwheel:': '1f938',
    ':person_facepalming:': '1f926',
    ':person_fencing:': '1f93a',
    ':person_frowning:': '1f64d',
    ':person_gesturing_no:': '1f645',
    ':person_gesturing_ok:': '1f646',
    ':person_getting_haircut:': '1f487',
    ':person_getting_massage:': '1f486',
    ':person_golfing:': '1f3cc',
    ':person_in_lotus_position:': '1f9d8',
    ':person_in_steamy_room:': '1f9d6',
    ':person_in_tuxedo:': '1f935',
    ':person_juggling:': '1f939',
    ':person_kneeling:': '1f9ce',
    ':person_lifting_weights:': '1f3cb',
    ':person_mountain_biking:': '1f6b5',
    ':person_playing_handball:': '1f93e',
    ':person_playing_water_polo:': '1f93d',
    ':person_pouting:': '1f64e',
    ':person_raising_hand:': '1f64b',
    ':person_rowing_boat:': '1f6a3',
    ':person_running:': '1f3c3',
    ':person_shrugging:': '1f937',
    ':person_standing:': '1f9cd',
    ':person_surfing:': '1f3c4',
    ':person_swimming:': '1f3ca',
    ':person_tipping_hand:': '1f481',
    ':person_walking:': '1f6b6',
    ':person_wearing_turban:': '1f473',
    ':person_with_crown:': '1fac5',
    ':person_with_veil:': '1f470',
    ':petri_dish:': '1f9eb',
    ':pickup_truck:': '1f6fb',
    ':pie:': '1f967',
    ':pig2:': '1f416',
    ':pig:': '1f437',
    ':pig_nose:': '1f43d',
    ':pill:': '1f48a',
    ':pinched_fingers:': '1f90c',
    ':pinching_hand:': '1f90f',
    ':pineapple:': '1f34d',
    ':ping_pong:': '1f3d3',
    ':pizza:': '1f355',
    ':piñata:': '1fa85',
    ':placard:': '1faa7',
    ':place_of_worship:': '1f6d0',
    ':playground_slide:': '1f6dd',
    ':pleading_face:': '1f97a',
    ':plunger:': '1faa0',
    ':point_down:': '1f447',
    ':point_left:': '1f448',
    ':point_right:': '1f449',
    ':point_up_2:': '1f446',
    ':police_car:': '1f693',
    ':police_officer:': '1f46e',
    ':poodle:': '1f429',
    ':poop:': '1f4a9',
    ':popcorn:': '1f37f',
    ':post_office:': '1f3e3',
    ':postal_horn:': '1f4ef',
    ':postbox:': '1f4ee',
    ':potable_water:': '1f6b0',
    ':potato:': '1f954',
    ':potted_plant:': '1fab4',
    ':pouch:': '1f45d',
    ':poultry_leg:': '1f357',
    ':pound:': '1f4b7',
    ':pouring_liquid:': '1fad7',
    ':pouting_cat:': '1f63e',
    ':pray:': '1f64f',
    ':prayer_beads:': '1f4ff',
    ':pregnant_man:': '1fac3',
    ':pregnant_person:': '1fac4',
    ':pregnant_woman:': '1f930',
    ':pretzel:': '1f968',
    ':prince:': '1f934',
    ':princess:': '1f478',
    ':printer:': '1f5a8-fe0f',
    ':probing_cane:': '1f9af',
    ':projector:': '1f4fd-fe0f',
    ':punch:': '1f44a',
    ':purple_circle:': '1f7e3',
    ':purple_heart:': '1f49c',
    ':purple_square:': '1f7ea',
    ':purse:': '1f45b',
    ':pushpin:': '1f4cc',
    ':put_litter_in_its_place:': '1f6ae',
    ':rabbit2:': '1f407',
    ':rabbit:': '1f430',
    ':raccoon:': '1f99d',
    ':race_car:': '1f3ce-fe0f',
    ':racehorse:': '1f40e',
    ':radio:': '1f4fb',
    ':radio_button:': '1f518',
    ':rage:': '1f621',
    ':railway_car:': '1f683',
    ':railway_track:': '1f6e4-fe0f',
    ':rainbow:': '1f308',
    ':raised_back_of_hand:': '1f91a',
    ':raised_hands:': '1f64c',
    ':ram:': '1f40f',
    ':ramen:': '1f35c',
    ':rat:': '1f400',
    ':razor:': '1fa92',
    ':receipt:': '1f9fe',
    ':red_car:': '1f697',
    ':red_circle:': '1f534',
    ':red_envelope:': '1f9e7',
    ':red_haired:': '1f9b0',
    ':red_square:': '1f7e5',
    ':regional_indicator_a:': '1f1e6',
    ':regional_indicator_b:': '1f1e7',
    ':regional_indicator_c:': '1f1e8',
    ':regional_indicator_d:': '1f1e9',
    ':regional_indicator_e:': '1f1ea',
    ':regional_indicator_f:': '1f1eb',
    ':regional_indicator_g:': '1f1ec',
    ':regional_indicator_h:': '1f1ed',
    ':regional_indicator_i:': '1f1ee',
    ':regional_indicator_j:': '1f1ef',
    ':regional_indicator_k:': '1f1f0',
    ':regional_indicator_l:': '1f1f1',
    ':regional_indicator_m:': '1f1f2',
    ':regional_indicator_n:': '1f1f3',
    ':regional_indicator_o:': '1f1f4',
    ':regional_indicator_p:': '1f1f5',
    ':regional_indicator_q:': '1f1f6',
    ':regional_indicator_r:': '1f1f7',
    ':regional_indicator_s:': '1f1f8',
    ':regional_indicator_t:': '1f1f9',
    ':regional_indicator_u:': '1f1fa',
    ':regional_indicator_v:': '1f1fb',
    ':regional_indicator_w:': '1f1fc',
    ':regional_indicator_x:': '1f1fd',
    ':regional_indicator_y:': '1f1fe',
    ':regional_indicator_z:': '1f1ff',
    ':relieved:': '1f60c',
    ':reminder_ribbon:': '1f397-fe0f',
    ':repeat:': '1f501',
    ':repeat_one:': '1f502',
    ':restroom:': '1f6bb',
    ':revolving_hearts:': '1f49e',
    ':rhino:': '1f98f',
    ':ribbon:': '1f380',
    ':rice:': '1f35a',
    ':rice_ball:': '1f359',
    ':rice_cracker:': '1f358',
    ':rice_scene:': '1f391',
    ':right_facing_fist:': '1f91c',
    ':rightwards_hand:': '1faf1',
    ':ring:': '1f48d',
    ':ring_buoy:': '1f6df',
    ':ringed_planet:': '1fa90',
    ':robot:': '1f916',
    ':rock:': '1faa8',
    ':rocket:': '1f680',
    ':rofl:': '1f923',
    ':roll_of_paper:': '1f9fb',
    ':roller_coaster:': '1f3a2',
    ':roller_skate:': '1f6fc',
    ':rolling_eyes:': '1f644',
    ':rooster:': '1f413',
    ':rose:': '1f339',
    ':rosette:': '1f3f5-fe0f',
    ':rotating_light:': '1f6a8',
    ':round_pushpin:': '1f4cd',
    ':rugby_football:': '1f3c9',
    ':running_shirt_with_sash:': '1f3bd',
    ':sa:': '1f202-fe0f',
    ':safety_pin:': '1f9f7',
    ':safety_vest:': '1f9ba',
    ':sake:': '1f376',
    ':salad:': '1f957',
    ':salt:': '1f9c2',
    ':saluting_face:': '1fae1',
    ':sandal:': '1f461',
    ':sandwich:': '1f96a',
    ':santa:': '1f385',
    ':sari:': '1f97b',
    ':satellite:': '1f4e1',
    ':satellite_orbital:': '1f6f0-fe0f',
    ':sauropod:': '1f995',
    ':saxophone:': '1f3b7',
    ':scarf:': '1f9e3',
    ':school:': '1f3eb',
    ':school_satchel:': '1f392',
    ':scooter:': '1f6f4',
    ':scorpion:': '1f982',
    ':scream:': '1f631',
    ':scream_cat:': '1f640',
    ':screwdriver:': '1fa9b',
    ':scroll:': '1f4dc',
    ':seal:': '1f9ad',
    ':seat:': '1f4ba',
    ':second_place:': '1f948',
    ':see_no_evil:': '1f648',
    ':seedling:': '1f331',
    ':selfie:': '1f933',
    ':sewing_needle:': '1faa1',
    ':shallow_pan_of_food:': '1f958',
    ':shark:': '1f988',
    ':shaved_ice:': '1f367',
    ':sheep:': '1f411',
    ':shell:': '1f41a',
    ':shield:': '1f6e1-fe0f',
    ':ship:': '1f6a2',
    ':shirt:': '1f455',
    ':shopping_bags:': '1f6cd-fe0f',
    ':shopping_cart:': '1f6d2',
    ':shorts:': '1fa73',
    ':shower:': '1f6bf',
    ':shrimp:': '1f990',
    ':shushing_face:': '1f92b',
    ':signal_strength:': '1f4f6',
    ':six_pointed_star:': '1f52f',
    ':skateboard:': '1f6f9',
    ':ski:': '1f3bf',
    ':skull:': '1f480',
    ':skunk:': '1f9a8',
    ':sled:': '1f6f7',
    ':sleeping:': '1f634',
    ':sleeping_accommodation:': '1f6cc',
    ':sleepy:': '1f62a',
    ':slight_frown:': '1f641',
    ':slight_smile:': '1f642',
    ':slot_machine:': '1f3b0',
    ':sloth:': '1f9a5',
    ':small_blue_diamond:': '1f539',
    ':small_orange_diamond:': '1f538',
    ':small_red_triangle:': '1f53a',
    ':small_red_triangle_down:': '1f53b',
    ':smile:': '1f604',
    ':smile_cat:': '1f638',
    ':smiley:': '1f603',
    ':smiley_cat:': '1f63a',
    ':smiling_face_with_3_hearts:': '1f970',
    ':smiling_face_with_tear:': '1f972',
    ':smiling_imp:': '1f608',
    ':smirk:': '1f60f',
    ':smirk_cat:': '1f63c',
    ':smoking:': '1f6ac',
    ':snail:': '1f40c',
    ':snake:': '1f40d',
    ':sneezing_face:': '1f927',
    ':snowboarder:': '1f3c2',
    ':soap:': '1f9fc',
    ':sob:': '1f62d',
    ':socks:': '1f9e6',
    ':softball:': '1f94e',
    ':soon:': '1f51c',
    ':sos:': '1f198',
    ':sound:': '1f509',
    ':space_invader:': '1f47e',
    ':spaghetti:': '1f35d',
    ':sparkler:': '1f387',
    ':sparkling_heart:': '1f496',
    ':speak_no_evil:': '1f64a',
    ':speaker:': '1f508',
    ':speaking_head:': '1f5e3-fe0f',
    ':speech_balloon:': '1f4ac',
    ':speech_left:': '1f5e8-fe0f',
    ':speedboat:': '1f6a4',
    ':spider:': '1f577-fe0f',
    ':spider_web:': '1f578-fe0f',
    ':sponge:': '1f9fd',
    ':spoon:': '1f944',
    ':squeeze_bottle:': '1f9f4',
    ':squid:': '1f991',
    ':stadium:': '1f3df-fe0f',
    ':star2:': '1f31f',
    ':star_struck:': '1f929',
    ':stars:': '1f320',
    ':station:': '1f689',
    ':statue_of_liberty:': '1f5fd',
    ':steam_locomotive:': '1f682',
    ':stethoscope:': '1fa7a',
    ':stew:': '1f372',
    ':straight_ruler:': '1f4cf',
    ':strawberry:': '1f353',
    ':stuck_out_tongue:': '1f61b',
    ':stuck_out_tongue_closed_eyes:': '1f61d',
    ':stuck_out_tongue_winking_eye:': '1f61c',
    ':stuffed_flatbread:': '1f959',
    ':sun_with_face:': '1f31e',
    ':sunflower:': '1f33b',
    ':sunglasses:': '1f60e',
    ':sunrise:': '1f305',
    ':sunrise_over_mountains:': '1f304',
    ':superhero:': '1f9b8',
    ':supervillain:': '1f9b9',
    ':sushi:': '1f363',
    ':suspension_railway:': '1f69f',
    ':swan:': '1f9a2',
    ':sweat:': '1f613',
    ':sweat_drops:': '1f4a6',
    ':sweat_smile:': '1f605',
    ':sweet_potato:': '1f360',
    ':symbols:': '1f523',
    ':synagogue:': '1f54d',
    ':syringe:': '1f489',
    ':t_rex:': '1f996',
    ':taco:': '1f32e',
    ':tada:': '1f389',
    ':takeout_box:': '1f961',
    ':tamale:': '1fad4',
    ':tanabata_tree:': '1f38b',
    ':tangerine:': '1f34a',
    ':taxi:': '1f695',
    ':tea:': '1f375',
    ':teapot:': '1fad6',
    ':teddy_bear:': '1f9f8',
    ':telephone_receiver:': '1f4de',
    ':telescope:': '1f52d',
    ':tennis:': '1f3be',
    ':test_tube:': '1f9ea',
    ':thermometer:': '1f321-fe0f',
    ':thermometer_face:': '1f912',
    ':thinking:': '1f914',
    ':third_place:': '1f949',
    ':thong_sandal:': '1fa74',
    ':thought_balloon:': '1f4ad',
    ':thread:': '1f9f5',
    ':thumbsdown:': '1f44e',
    ':thumbsup:': '1f44d',
    ':ticket:': '1f3ab',
    ':tickets:': '1f39f-fe0f',
    ':tiger2:': '1f405',
    ':tiger:': '1f42f',
    ':tired_face:': '1f62b',
    ':toilet:': '1f6bd',
    ':tokyo_tower:': '1f5fc',
    ':tomato:': '1f345',
    ':tone1:': '1f3fb',
    ':tone2:': '1f3fc',
    ':tone3:': '1f3fd',
    ':tone4:': '1f3fe',
    ':tone5:': '1f3ff',
    ':tongue:': '1f445',
    ':toolbox:': '1f9f0',
    ':tools:': '1f6e0-fe0f',
    ':tooth:': '1f9b7',
    ':toothbrush:': '1faa5',
    ':top:': '1f51d',
    ':tophat:': '1f3a9',
    ':trackball:': '1f5b2-fe0f',
    ':tractor:': '1f69c',
    ':traffic_light:': '1f6a5',
    ':train2:': '1f686',
    ':train:': '1f68b',
    ':tram:': '1f68a',
    ':triangular_flag_on_post:': '1f6a9',
    ':triangular_ruler:': '1f4d0',
    ':trident:': '1f531',
    ':triumph:': '1f624',
    ':troll:': '1f9cc',
    ':trolleybus:': '1f68e',
    ':trophy:': '1f3c6',
    ':tropical_drink:': '1f379',
    ':tropical_fish:': '1f420',
    ':truck:': '1f69a',
    ':trumpet:': '1f3ba',
    ':tulip:': '1f337',
    ':tumbler_glass:': '1f943',
    ':turkey:': '1f983',
    ':turtle:': '1f422',
    ':tv:': '1f4fa',
    ':twisted_rightwards_arrows:': '1f500',
    ':two_hearts:': '1f495',
    ':two_men_holding_hands:': '1f46c',
    ':two_women_holding_hands:': '1f46d',
    ':u5272:': '1f239',
    ':u5408:': '1f234',
    ':u55b6:': '1f23a',
    ':u6307:': '1f22f',
    ':u6708:': '1f237-fe0f',
    ':u6709:': '1f236',
    ':u6e80:': '1f235',
    ':u7121:': '1f21a',
    ':u7533:': '1f238',
    ':u7981:': '1f232',
    ':u7a7a:': '1f233',
    ':unamused:': '1f612',
    ':underage:': '1f51e',
    ':unicorn:': '1f984',
    ':unlock:': '1f513',
    ':up:': '1f199',
    ':upside_down:': '1f643',
    ':vampire:': '1f9db',
    ':vertical_traffic_light:': '1f6a6',
    ':vhs:': '1f4fc',
    ':vibration_mode:': '1f4f3',
    ':video_camera:': '1f4f9',
    ':video_game:': '1f3ae',
    ':violin:': '1f3bb',
    ':volcano:': '1f30b',
    ':volleyball:': '1f3d0',
    ':vs:': '1f19a',
    ':vulcan:': '1f596',
    ':waffle:': '1f9c7',
    ':waning_crescent_moon:': '1f318',
    ':waning_gibbous_moon:': '1f316',
    ':wastebasket:': '1f5d1-fe0f',
    ':water_buffalo:': '1f403',
    ':watermelon:': '1f349',
    ':wave:': '1f44b',
    ':waxing_crescent_moon:': '1f312',
    ':waxing_gibbous_moon:': '1f314',
    ':wc:': '1f6be',
    ':weary:': '1f629',
    ':wedding:': '1f492',
    ':whale2:': '1f40b',
    ':whale:': '1f433',
    ':wheel:': '1f6de',
    ':white_flower:': '1f4ae',
    ':white_haired:': '1f9b3',
    ':white_heart:': '1f90d',
    ':white_square_button:': '1f533',
    ':white_sun_cloud:': '1f325-fe0f',
    ':white_sun_rain_cloud:': '1f326-fe0f',
    ':white_sun_small_cloud:': '1f324-fe0f',
    ':wilted_rose:': '1f940',
    ':wind_blowing_face:': '1f32c-fe0f',
    ':wind_chime:': '1f390',
    ':window:': '1fa9f',
    ':wine_glass:': '1f377',
    ':wink:': '1f609',
    ':wolf:': '1f43a',
    ':woman:': '1f469',
    ':woman_with_headscarf:': '1f9d5',
    ':womans_clothes:': '1f45a',
    ':womans_flat_shoe:': '1f97f',
    ':womans_hat:': '1f452',
    ':womens:': '1f6ba',
    ':wood:': '1fab5',
    ':woozy_face:': '1f974',
    ':worm:': '1fab1',
    ':worried:': '1f61f',
    ':wrench:': '1f527',
    ':x_ray:': '1fa7b',
    ':yarn:': '1f9f6',
    ':yawning_face:': '1f971',
    ':yellow_circle:': '1f7e1',
    ':yellow_heart:': '1f49b',
    ':yellow_square:': '1f7e8',
    ':yen:': '1f4b4',
    ':yo_yo:': '1fa80',
    ':yum:': '1f60b',
    ':zany_face:': '1f92a',
    ':zebra:': '1f993',
    ':zipper_mouth:': '1f910',
    ':zombie:': '1f9df',
    ':zzz:': '1f4a4',
    ':airplane:': '2708-fe0f',
    ':alarm_clock:': '23f0',
    ':alembic:': '2697-fe0f',
    ':anchor:': '2693',
    ':aquarius:': '2652',
    ':aries:': '2648',
    ':arrow_backward:': '25c0-fe0f',
    ':arrow_double_down:': '23ec',
    ':arrow_double_up:': '23eb',
    ':arrow_down:': '2b07-fe0f',
    ':arrow_forward:': '25b6-fe0f',
    ':arrow_heading_down:': '2935-fe0f',
    ':arrow_heading_up:': '2934-fe0f',
    ':arrow_left:': '2b05-fe0f',
    ':arrow_lower_left:': '2199-fe0f',
    ':arrow_lower_right:': '2198-fe0f',
    ':arrow_right:': '27a1-fe0f',
    ':arrow_right_hook:': '21aa-fe0f',
    ':arrow_up:': '2b06-fe0f',
    ':arrow_up_down:': '2195-fe0f',
    ':arrow_upper_left:': '2196-fe0f',
    ':arrow_upper_right:': '2197-fe0f',
    ':asterisk_symbol:': '002a-fe0f',
    ':atom:': '269b-fe0f',
    ':ballot_box_with_check:': '2611-fe0f',
    ':bangbang:': '203c-fe0f',
    ':baseball:': '26be',
    ':beach_umbrella:': '26f1-fe0f',
    ':biohazard:': '2623-fe0f',
    ':black_circle:': '26ab',
    ':black_large_square:': '2b1b',
    ':black_medium_small_square:': '25fe',
    ':black_medium_square:': '25fc-fe0f',
    ':black_nib:': '2712-fe0f',
    ':black_small_square:': '25aa-fe0f',
    ':cancer:': '264b',
    ':capricorn:': '2651',
    ':chains:': '26d3-fe0f',
    ':chess_pawn:': '265f-fe0f',
    ':church:': '26ea',
    ':cloud:': '2601-fe0f',
    ':clubs:': '2663-fe0f',
    ':coffee:': '2615',
    ':coffin:': '26b0-fe0f',
    ':comet:': '2604-fe0f',
    ':congratulations:': '3297-fe0f',
    ':copyright:': '00a9-fe0f',
    ':cross:': '271d-fe0f',
    ':crossed_swords:': '2694-fe0f',
    ':curly_loop:': '27b0',
    ':diamonds:': '2666-fe0f',
    ':digit_eight:': '0038-fe0f',
    ':digit_five:': '0035-fe0f',
    ':digit_four:': '0034-fe0f',
    ':digit_nine:': '0039-fe0f',
    ':digit_one:': '0031-fe0f',
    ':digit_seven:': '0037-fe0f',
    ':digit_six:': '0036-fe0f',
    ':digit_three:': '0033-fe0f',
    ':digit_two:': '0032-fe0f',
    ':digit_zero:': '0030-fe0f',
    ':eight_pointed_black_star:': '2734-fe0f',
    ':eight_spoked_asterisk:': '2733-fe0f',
    ':eject:': '23cf-fe0f',
    ':envelope:': '2709-fe0f',
    ':exclamation:': '2757',
    ':fast_forward:': '23e9',
    ':female_sign:': '2640-fe0f',
    ':ferry:': '26f4-fe0f',
    ':fist:': '270a',
    ':fleur-de-lis:': '269c-fe0f',
    ':fountain:': '26f2',
    ':frowning2:': '2639-fe0f',
    ':fuelpump:': '26fd',
    ':gear:': '2699-fe0f',
    ':gemini:': '264a',
    ':golf:': '26f3',
    ':grey_exclamation:': '2755',
    ':grey_question:': '2754',
    ':hammer_pick:': '2692-fe0f',
    ':heart:': '2764-fe0f',
    ':heart_exclamation:': '2763-fe0f',
    ':hearts:': '2665-fe0f',
    ':heavy_check_mark:': '2714-fe0f',
    ':heavy_division_sign:': '2797',
    ':heavy_minus_sign:': '2796',
    ':heavy_multiplication_x:': '2716-fe0f',
    ':heavy_plus_sign:': '2795',
    ':helmet_with_cross:': '26d1-fe0f',
    ':hotsprings:': '2668-fe0f',
    ':hourglass:': '231b',
    ':hourglass_flowing_sand:': '23f3',
    ':ice_skate:': '26f8-fe0f',
    ':infinity:': '267e-fe0f',
    ':information_source:': '2139-fe0f',
    ':interrobang:': '2049-fe0f',
    ':keyboard:': '2328-fe0f',
    ':left_right_arrow:': '2194-fe0f',
    ':leftwards_arrow_with_hook:': '21a9-fe0f',
    ':leo:': '264c',
    ':libra:': '264e',
    ':loop:': '27bf',
    ':m:': '24c2-fe0f',
    ':male_sign:': '2642-fe0f',
    ':medical_symbol:': '2695-fe0f',
    ':mountain:': '26f0-fe0f',
    ':negative_squared_cross_mark:': '274e',
    ':no_entry:': '26d4',
    ':o:': '2b55',
    ':ophiuchus:': '26ce',
    ':orthodox_cross:': '2626-fe0f',
    ':part_alternation_mark:': '303d-fe0f',
    ':partly_sunny:': '26c5',
    ':pause_button:': '23f8-fe0f',
    ':peace:': '262e-fe0f',
    ':pencil2:': '270f-fe0f',
    ':person_bouncing_ball:': '26f9',
    ':pick:': '26cf-fe0f',
    ':pisces:': '2653',
    ':play_pause:': '23ef-fe0f',
    ':point_up:': '261d-fe0f',
    ':pound_symbol:': '0023-fe0f',
    ':question:': '2753',
    ':radioactive:': '2622-fe0f',
    ':raised_hand:': '270b',
    ':record_button:': '23fa-fe0f',
    ':recycle:': '267b-fe0f',
    ':registered:': '00ae-fe0f',
    ':relaxed:': '263a-fe0f',
    ':rewind:': '23ea',
    ':sagittarius:': '2650',
    ':sailboat:': '26f5',
    ':scales:': '2696-fe0f',
    ':scissors:': '2702-fe0f',
    ':scorpius:': '264f',
    ':secret:': '3299-fe0f',
    ':shamrock:': '2618-fe0f',
    ':shinto_shrine:': '26e9-fe0f',
    ':skier:': '26f7-fe0f',
    ':skull_crossbones:': '2620-fe0f',
    ':snowflake:': '2744-fe0f',
    ':snowman2:': '2603-fe0f',
    ':snowman:': '26c4',
    ':soccer:': '26bd',
    ':spades:': '2660-fe0f',
    ':sparkle:': '2747-fe0f',
    ':sparkles:': '2728',
    ':star:': '2b50',
    ':star_and_crescent:': '262a-fe0f',
    ':star_of_david:': '2721-fe0f',
    ':stop_button:': '23f9-fe0f',
    ':stopwatch:': '23f1-fe0f',
    ':sunny:': '2600-fe0f',
    ':taurus:': '2649',
    ':telephone:': '260e-fe0f',
    ':tent:': '26fa',
    ':thunder_cloud_rain:': '26c8-fe0f',
    ':timer:': '23f2-fe0f',
    ':tm:': '2122-fe0f',
    ':track_next:': '23ed-fe0f',
    ':track_previous:': '23ee-fe0f',
    ':transgender_symbol:': '26a7',
    ':umbrella2:': '2602-fe0f',
    ':umbrella:': '2614',
    ':urn:': '26b1-fe0f',
    ':v:': '270c-fe0f',
    ':virgo:': '264d',
    ':warning:': '26a0-fe0f',
    ':watch:': '231a',
    ':wavy_dash:': '3030-fe0f',
    ':wheel_of_dharma:': '2638-fe0f',
    ':wheelchair:': '267f',
    ':white_check_mark:': '2705',
    ':white_circle:': '26aa',
    ':white_large_square:': '2b1c',
    ':white_medium_small_square:': '25fd',
    ':white_medium_square:': '25fb-fe0f',
    ':white_small_square:': '25ab-fe0f',
    ':writing_hand:': '270d-fe0f',
    ':x:': '274c',
    ':yin_yang:': '262f-fe0f',
    ':zap:': '26a1',
};

let shortnameRegexp = '';

Object.keys(shortNameList).forEach((shortname, index) => {
    shortnameRegexp += `${index !== 0 ? '|' : ''}${shortname}`;
});

export const regShortnames = new RegExp(
    `<object[^>]*>.*?</object>|<span[^>]*>.*?</span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(${shortnameRegexp})`,
    'gi',
);
